const studentInfo = {
    "student_tcinfo": [
        {
            "REG_CODE": "HGSF/1112/989",
            "STD_NAME": "Shivendra Pathak",
            "STD_FATHER_NAME": "Brham Datt Pathak",
            "STD_MOTHER_NAME": "Rajkumari Pathak",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "TC2026",
            "STD_TC_ISSUE_DATE": "25-Jul-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODI1&cwid=MTAxMw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/989",
            "STD_NAME": "Shivendra Pathak",
            "STD_FATHER_NAME": "Brham Datt Pathak",
            "STD_MOTHER_NAME": "Rajkumari Pathak",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2061",
            "STD_TC_ISSUE_DATE": "25-Jul-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODI1&cwid=MTAxMw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/842",
            "STD_NAME": "Deepak Gupta",
            "STD_FATHER_NAME": "Raju Gupta",
            "STD_MOTHER_NAME": "Rita Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2071",
            "STD_TC_ISSUE_DATE": "29-Jul-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Njc5&cwid=MTAxNQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1201",
            "STD_NAME": "Aashish Aima",
            "STD_FATHER_NAME": "Sanjay Aima",
            "STD_MOTHER_NAME": "Nimmi Aima",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "1947",
            "STD_TC_ISSUE_DATE": "06-Jun-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzM5&cwid=MTAxNw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1168",
            "STD_NAME": "Akash Jana",
            "STD_FATHER_NAME": "Debashish Jana",
            "STD_MOTHER_NAME": "Reena Jana",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "1970",
            "STD_TC_ISSUE_DATE": "20-Jun-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzEy&cwid=MTAxOQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/185",
            "STD_NAME": "Ritik Porwal",
            "STD_FATHER_NAME": "Dilip Porwal",
            "STD_MOTHER_NAME": "Madhu ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "1999",
            "STD_TC_ISSUE_DATE": "21-Jun-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Nzc3&cwid=MTAyMQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/219",
            "STD_NAME": "Ranjandeep Singh",
            "STD_FATHER_NAME": "Narinder Pal Singh",
            "STD_MOTHER_NAME": "Jasbir Kaur",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "1976",
            "STD_TC_ISSUE_DATE": "22-Jun-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Njk3&cwid=MTAyMw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/904",
            "STD_NAME": "Rajat Sharma",
            "STD_FATHER_NAME": "Rakesh Chandra Sharma",
            "STD_MOTHER_NAME": "Vijay Kumari",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2023",
            "STD_TC_ISSUE_DATE": "28-Jun-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODE3&cwid=MTAyNQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/961",
            "STD_NAME": "Pramod Singh",
            "STD_FATHER_NAME": "Mohan Singh",
            "STD_MOTHER_NAME": "Vimla Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2040",
            "STD_TC_ISSUE_DATE": "03-Jul-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODE0&cwid=MTAyNw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/855",
            "STD_NAME": "Amit Thakur",
            "STD_FATHER_NAME": "Mahesh Thakur",
            "STD_MOTHER_NAME": "Rampati Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2051",
            "STD_TC_ISSUE_DATE": "10-Jul-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Nzk1&cwid=MTAyOQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/100",
            "STD_NAME": "Nidhi ",
            "STD_FATHER_NAME": "Satya ",
            "STD_MOTHER_NAME": "Chanchal ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2054",
            "STD_TC_ISSUE_DATE": "11-Jul-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Nzcw&cwid=MTAzMQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/450",
            "STD_NAME": "Ashish ",
            "STD_FATHER_NAME": "Narender ",
            "STD_MOTHER_NAME": "Sudesh ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2048",
            "STD_TC_ISSUE_DATE": "15-Jul-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzUz&cwid=MTAzMw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/341",
            "STD_NAME": "Aarti Sharma",
            "STD_FATHER_NAME": "Yashpal Sharma",
            "STD_MOTHER_NAME": "Rita Sharma",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2058",
            "STD_TC_ISSUE_DATE": "19-Jul-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Njcx&cwid=MTAzNQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/118",
            "STD_NAME": "Sohail Khan",
            "STD_FATHER_NAME": "Nasruddin Khan",
            "STD_MOTHER_NAME": "Shenaj Khan",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2077",
            "STD_TC_ISSUE_DATE": "29-Jul-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODMx&cwid=MTAzNw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1175",
            "STD_NAME": "Mridul Taneja",
            "STD_FATHER_NAME": "S K Taneja",
            "STD_MOTHER_NAME": "Sudha ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2072",
            "STD_TC_ISSUE_DATE": "30-Jul-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzY5&cwid=MTAzOQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1202",
            "STD_NAME": "Rishabh Gupta",
            "STD_FATHER_NAME": "Anil Gupta",
            "STD_MOTHER_NAME": "Rani Gupta",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2079",
            "STD_TC_ISSUE_DATE": "01-Aug-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzE3&cwid=MTA0MQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/53",
            "STD_NAME": "Vishant Chauhan",
            "STD_FATHER_NAME": "Lakha Singh",
            "STD_MOTHER_NAME": "Babita Chauhan",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2074",
            "STD_TC_ISSUE_DATE": "03-Aug-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzEx&cwid=MTA0Mw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/19",
            "STD_NAME": "Nitin Kumar",
            "STD_FATHER_NAME": "Sunil Kumar",
            "STD_MOTHER_NAME": "Saroj ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2073",
            "STD_TC_ISSUE_DATE": "13-Aug-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzQx&cwid=MTA0NQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1013",
            "STD_NAME": "Sachin Paswan",
            "STD_FATHER_NAME": "Surendra Paswan",
            "STD_MOTHER_NAME": "Geeta Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2090",
            "STD_TC_ISSUE_DATE": "22-Aug-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODIx&cwid=MTA0Nw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/909",
            "STD_NAME": "Rohan Kumar",
            "STD_FATHER_NAME": "Avdesh Kumar",
            "STD_MOTHER_NAME": "Pooja Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2093",
            "STD_TC_ISSUE_DATE": "27-Aug-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODE5&cwid=MTA0OQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/213",
            "STD_NAME": "Shireen Khan",
            "STD_FATHER_NAME": "Rashid Khan",
            "STD_MOTHER_NAME": "Mumtaz Khan",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2100",
            "STD_TC_ISSUE_DATE": "06-Sep-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzA3&cwid=MTA1MQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/397",
            "STD_NAME": "Mayuri Kumari Jha",
            "STD_FATHER_NAME": "Anjani Kumar Jha",
            "STD_MOTHER_NAME": "Rekha Jha",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2103",
            "STD_TC_ISSUE_DATE": "25-Sep-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Njg4&cwid=MTA1Mw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1252",
            "STD_NAME": "Ambuj Kumar Pandey",
            "STD_FATHER_NAME": "S.B.  Pandey",
            "STD_MOTHER_NAME": "Saroj Pandey",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2109",
            "STD_TC_ISSUE_DATE": "29-Oct-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY5Nw==&cwid=MTA1NQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/661",
            "STD_NAME": "Sahil Sarang",
            "STD_FATHER_NAME": "Ajit Sarang",
            "STD_MOTHER_NAME": "Darshan Devi",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2043",
            "STD_TC_ISSUE_DATE": "04-Jul-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc1&cwid=MTA1Nw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/954",
            "STD_NAME": "Kunal Nehra",
            "STD_FATHER_NAME": "Anup Singh",
            "STD_MOTHER_NAME": "Rekha ",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "2068",
            "STD_TC_ISSUE_DATE": "01-Aug-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTI=&cwid=MTA1OQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/4",
            "STD_NAME": "Astha ",
            "STD_FATHER_NAME": "- - -",
            "STD_MOTHER_NAME": "Kamlini Senapati",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2082",
            "STD_TC_ISSUE_DATE": "12-Aug-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjQ1&cwid=MTA2MQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/702",
            "STD_NAME": "Lalita Bhadana",
            "STD_FATHER_NAME": "Jaiveer Bhadana",
            "STD_MOTHER_NAME": "Geeta ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "1000",
            "STD_TC_ISSUE_DATE": "29-Apr-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NTQ0&cwid=MTA2Mw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/178",
            "STD_NAME": "Nikita ",
            "STD_FATHER_NAME": "Jaibeer Bhadana",
            "STD_MOTHER_NAME": "   ",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "1002",
            "STD_TC_ISSUE_DATE": "29-Apr-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM5Ng==&cwid=MTA2NQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/968",
            "STD_NAME": "Vishal Singh",
            "STD_FATHER_NAME": "Hodil ",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2024",
            "STD_TC_ISSUE_DATE": "03-Aug-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Nzg3&cwid=MTA2Nw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/33",
            "STD_NAME": "Sanjana Dilli",
            "STD_FATHER_NAME": "J.N Kaul",
            "STD_MOTHER_NAME": "D.Jaya Lakshmi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "1005",
            "STD_TC_ISSUE_DATE": "28-Apr-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzAz&cwid=MTA2OQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/173",
            "STD_NAME": "Divyanshu ",
            "STD_FATHER_NAME": "Atter Singh",
            "STD_MOTHER_NAME": "Saroj ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2056",
            "STD_TC_ISSUE_DATE": "17-Jul-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM5MQ==&cwid=MTA3MQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/199",
            "STD_NAME": "Puneet Solanki",
            "STD_FATHER_NAME": "Raj Kumar Solanki",
            "STD_MOTHER_NAME": "- ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "1008",
            "STD_TC_ISSUE_DATE": "14-Nov-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Nzkx&cwid=MTA3Mw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/502",
            "STD_NAME": "Himanshu Jangra",
            "STD_FATHER_NAME": "Satish ",
            "STD_MOTHER_NAME": "Savita ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2080",
            "STD_TC_ISSUE_DATE": "05-Aug-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzYx&cwid=MTA3NQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1170",
            "STD_NAME": "Debosmita Choudhury",
            "STD_FATHER_NAME": "Debashish Choudhury",
            "STD_MOTHER_NAME": "Rita Choudhury",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "1977",
            "STD_TC_ISSUE_DATE": "25-Jun-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Njc3&cwid=MTA3Nw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/215",
            "STD_NAME": "Mohd. Bhaktiyaar ",
            "STD_FATHER_NAME": "Mohd. Sajid ",
            "STD_MOTHER_NAME": "Shenaz ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2102",
            "STD_TC_ISSUE_DATE": "06-Sep-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NTQ5&cwid=MTA3OQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/94",
            "STD_NAME": "Rohit Chaudhary",
            "STD_FATHER_NAME": "- ",
            "STD_MOTHER_NAME": "- -",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2085",
            "STD_TC_ISSUE_DATE": "08-Aug-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTMxMg==&cwid=MTA4MQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/254",
            "STD_NAME": "Nisha ",
            "STD_FATHER_NAME": "J.N. Kaul",
            "STD_MOTHER_NAME": "- ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "1944",
            "STD_TC_ISSUE_DATE": "30-May-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjYw&cwid=MTA4Mw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/210",
            "STD_NAME": "Deepak Singh",
            "STD_FATHER_NAME": "Lish Pratap Singh",
            "STD_MOTHER_NAME": "Sarita ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2087",
            "STD_TC_ISSUE_DATE": "21-Aug-2013",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQyOQ==&cwid=MTA4NQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/903",
            "STD_NAME": "Kajal Rawat",
            "STD_FATHER_NAME": "Virendra Singh Rawat",
            "STD_MOTHER_NAME": "Neema Rawat",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2113",
            "STD_TC_ISSUE_DATE": "24-Mar-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODA0&cwid=MTA4Nw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/402",
            "STD_NAME": "Rohail Ahmad",
            "STD_FATHER_NAME": "Mohd. Sharif ",
            "STD_MOTHER_NAME": "Bano Nisha",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "2140",
            "STD_TC_ISSUE_DATE": "15-Apr-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTE4&cwid=MTA5MA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/368",
            "STD_NAME": "Komal ",
            "STD_FATHER_NAME": "Late Tejpal Chandela",
            "STD_MOTHER_NAME": "Pooja Chandela",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2149",
            "STD_TC_ISSUE_DATE": "30-Apr-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDY0&cwid=MTA5Mg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/570",
            "STD_NAME": "Somyadeep Sinha",
            "STD_FATHER_NAME": "Dabranjan  Sinha",
            "STD_MOTHER_NAME": "Dipa Sinha",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "2121",
            "STD_TC_ISSUE_DATE": "03-May-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODU=&cwid=MTA5NA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/506",
            "STD_NAME": "Sahil ",
            "STD_FATHER_NAME": "Ramesh Chand",
            "STD_MOTHER_NAME": "Omwati ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2153",
            "STD_TC_ISSUE_DATE": "06-May-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzAw&cwid=MTA5Ng==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/536",
            "STD_NAME": "Pravleen Kaur Sahota",
            "STD_FATHER_NAME": "Kamaljeet Singh Sahota",
            "STD_MOTHER_NAME": "Manjeet Kaur Sahota",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "2873",
            "STD_TC_ISSUE_DATE": "18-Jan-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODA=&cwid=MTA5OA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/97",
            "STD_NAME": "Aakash Choudhary",
            "STD_FATHER_NAME": "Satveer Choudhary",
            "STD_MOTHER_NAME": "Suman ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2157",
            "STD_TC_ISSUE_DATE": "16-May-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTMxNQ==&cwid=MTEwMA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/281",
            "STD_NAME": "Babli Sarkar",
            "STD_FATHER_NAME": "Late Sh.J.N. Kaul",
            "STD_MOTHER_NAME": "Syamoli Sarkar",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2171",
            "STD_TC_ISSUE_DATE": "17-May-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTUwMA==&cwid=MTEwMg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/281",
            "STD_NAME": "Babli Sarkar",
            "STD_FATHER_NAME": "Late Sh.J.N. Kaul",
            "STD_MOTHER_NAME": "Syamoli Sarkar",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2159",
            "STD_TC_ISSUE_DATE": "17-May-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTUwMA==&cwid=MTEwNA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/281",
            "STD_NAME": "Babli Sarkar",
            "STD_FATHER_NAME": "Late Sh.J.N. Kaul",
            "STD_MOTHER_NAME": "Syamoli Sarkar",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2159",
            "STD_TC_ISSUE_DATE": "17-May-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTUwMA==&cwid=MTEwNg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/108",
            "STD_NAME": "Harish Bhati",
            "STD_FATHER_NAME": "Rambeer Bhati",
            "STD_MOTHER_NAME": "Kamla Devi",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2169",
            "STD_TC_ISSUE_DATE": "22-May-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTMyNg==&cwid=MTEwOA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/73",
            "STD_NAME": "Hasan Ali",
            "STD_FATHER_NAME": "Mr. Tahir/Chand Khan",
            "STD_MOTHER_NAME": "Mrs Nasim Khan",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "2115",
            "STD_TC_ISSUE_DATE": "16-Apr-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTI5MQ==&cwid=MTExMA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/329",
            "STD_NAME": "Piyush Vashisth",
            "STD_FATHER_NAME": "Prem Kumar Vashisth",
            "STD_MOTHER_NAME": "Deepty Vashisth",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "2117",
            "STD_TC_ISSUE_DATE": "16-Apr-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTE3&cwid=MTExMg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/330",
            "STD_NAME": "Diksha Kumar",
            "STD_FATHER_NAME": "Sameer Kumar",
            "STD_MOTHER_NAME": "Rakhi Kumar",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2119",
            "STD_TC_ISSUE_DATE": "18-Apr-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTYw&cwid=MTExNA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/235",
            "STD_NAME": "Ankur Tripathi",
            "STD_FATHER_NAME": "B.K Tripathi",
            "STD_MOTHER_NAME": "Kavita Tripathi",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "2122",
            "STD_TC_ISSUE_DATE": "02-May-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE5&cwid=MTExNg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/555",
            "STD_NAME": "Kartik Tiwari",
            "STD_FATHER_NAME": "Sudhir Kumar Tiwari",
            "STD_MOTHER_NAME": "Hema Tiwari",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "2124",
            "STD_TC_ISSUE_DATE": "16-Apr-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM4&cwid=MTExOA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/101",
            "STD_NAME": "Nandini Singh",
            "STD_FATHER_NAME": "Ajay Kumar Singh",
            "STD_MOTHER_NAME": "Shalini Singh",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "2126",
            "STD_TC_ISSUE_DATE": "16-Apr-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTYwMg==&cwid=MTEyMA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/58",
            "STD_NAME": "Tanishka ",
            "STD_FATHER_NAME": "Narender Singh",
            "STD_MOTHER_NAME": "Suman Lata",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "2128",
            "STD_TC_ISSUE_DATE": "24-Apr-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTI3Ng==&cwid=MTEyMg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/71",
            "STD_NAME": "Aman Singh Bisen",
            "STD_FATHER_NAME": "Late  Mahendra Pratap Singh",
            "STD_MOTHER_NAME": "Mamta Singh",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2170",
            "STD_TC_ISSUE_DATE": "06-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTI4OQ==&cwid=MTEyNA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1210",
            "STD_NAME": "Vishal Sehgal",
            "STD_FATHER_NAME": "Ashok Sehgal",
            "STD_MOTHER_NAME": "Veena Sehgal",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2173 ",
            "STD_TC_ISSUE_DATE": "18-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjU1&cwid=MTE0Mg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1163",
            "STD_NAME": "Mohammad Zia",
            "STD_FATHER_NAME": "Guldraz Ahmed",
            "STD_MOTHER_NAME": "Kishwar Firdaus",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2175",
            "STD_TC_ISSUE_DATE": "21-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODU1&cwid=MTE0Ng==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/291",
            "STD_NAME": "Vikas ",
            "STD_FATHER_NAME": "Vinod Bhadana",
            "STD_MOTHER_NAME": "Dhirwati Bhadana",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2177",
            "STD_TC_ISSUE_DATE": "21-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTc1&cwid=MTE0OA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/66",
            "STD_NAME": "Pooja Rani",
            "STD_FATHER_NAME": "Zile Singh",
            "STD_MOTHER_NAME": "Inderwati ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2179",
            "STD_TC_ISSUE_DATE": "21-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODg0&cwid=MTE2NA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1152",
            "STD_NAME": "Shrey Agarwal",
            "STD_FATHER_NAME": "Praveen Aggarwal",
            "STD_MOTHER_NAME": "Reena Aggarwal",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2181",
            "STD_TC_ISSUE_DATE": "21-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTMy&cwid=MTE2Ng==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/147",
            "STD_NAME": "Afzal Khan",
            "STD_FATHER_NAME": "Izhar Khan",
            "STD_MOTHER_NAME": "Shabnam Begum",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2183",
            "STD_TC_ISSUE_DATE": "21-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM2NQ==&cwid=MTE2OA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/188",
            "STD_NAME": "Abhishek Chaudhary",
            "STD_FATHER_NAME": "Devender Chaudhary",
            "STD_MOTHER_NAME": "Kavita Chaudhary",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2184",
            "STD_TC_ISSUE_DATE": "21-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQwNg==&cwid=MTE3MA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/188",
            "STD_NAME": "Abhishek Chaudhary",
            "STD_FATHER_NAME": "Devender Chaudhary",
            "STD_MOTHER_NAME": "Kavita Chaudhary",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2184",
            "STD_TC_ISSUE_DATE": "21-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQwNg==&cwid=MTE3Mg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/174",
            "STD_NAME": "Gaurav Shrivastava",
            "STD_FATHER_NAME": "Ramchet ",
            "STD_MOTHER_NAME": "Usha Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2186",
            "STD_TC_ISSUE_DATE": "21-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM5Mg==&cwid=MTE3NA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/184",
            "STD_NAME": "Swasthi Singh",
            "STD_FATHER_NAME": "Anil Kumar ",
            "STD_MOTHER_NAME": "Kiran Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2187",
            "STD_TC_ISSUE_DATE": "21-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQwMg==&cwid=MTE3Ng==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/47",
            "STD_NAME": "Shivam Puri",
            "STD_FATHER_NAME": "Subhash Chandra Puri",
            "STD_MOTHER_NAME": "Jaya Puri",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2189",
            "STD_TC_ISSUE_DATE": "21-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTIw&cwid=MTE3OA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/281",
            "STD_NAME": "Babli Sarkar",
            "STD_FATHER_NAME": "Late Sh.J.N. Kaul",
            "STD_MOTHER_NAME": "Syamoli Sarkar",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2159",
            "STD_TC_ISSUE_DATE": "19-May-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTUwMA==&cwid=MTE4MA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/579",
            "STD_NAME": "Monika Shambharwal",
            "STD_FATHER_NAME": "Ravinder Shambharwal",
            "STD_MOTHER_NAME": "Sushilla Shambharwal",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2191",
            "STD_TC_ISSUE_DATE": "24-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODgz&cwid=MTE4Mg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/243",
            "STD_NAME": "Shrey Sikka",
            "STD_FATHER_NAME": "Sanjeev Sikka",
            "STD_MOTHER_NAME": "Lalita Sikka",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2193",
            "STD_TC_ISSUE_DATE": "24-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTcy&cwid=MTE4NA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/924",
            "STD_NAME": "Natasha Virdi",
            "STD_FATHER_NAME": "Kamaljeet Virdi",
            "STD_MOTHER_NAME": "Guweet Kaur",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "2130",
            "STD_TC_ISSUE_DATE": "25-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM=&cwid=MTE4Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/201",
            "STD_NAME": "Sayuj S Kumar",
            "STD_FATHER_NAME": "A R Sree Kumar",
            "STD_MOTHER_NAME": "Sudha S Kumar",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "2132",
            "STD_TC_ISSUE_DATE": "25-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzk1&cwid=MTE4OA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/31",
            "STD_NAME": "Aakash ",
            "STD_FATHER_NAME": "Rajesh Sharma",
            "STD_MOTHER_NAME": "Manju Sharma",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "2133",
            "STD_TC_ISSUE_DATE": "25-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTUzMg==&cwid=MTE5MA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/669",
            "STD_NAME": "Ankit Yadav",
            "STD_FATHER_NAME": "Anand Kishore Yadav",
            "STD_MOTHER_NAME": "Sunita Yadav",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2195",
            "STD_TC_ISSUE_DATE": "26-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTIx&cwid=MTE5Mg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/216",
            "STD_NAME": "Shakti Singh",
            "STD_FATHER_NAME": "Sher Singh",
            "STD_MOTHER_NAME": "Meera Devi ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2197",
            "STD_TC_ISSUE_DATE": "26-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQzNQ==&cwid=MTE5NA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/602",
            "STD_NAME": "Vikas Singh",
            "STD_FATHER_NAME": "Kalu Singh",
            "STD_MOTHER_NAME": "Anu Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2199",
            "STD_TC_ISSUE_DATE": "26-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTc2&cwid=MTE5Ng==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1162",
            "STD_NAME": "Nikita Sharma",
            "STD_FATHER_NAME": "Subhash Chandra Sharma",
            "STD_MOTHER_NAME": "Sumita Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2201",
            "STD_TC_ISSUE_DATE": "26-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODU3&cwid=MTE5OA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/292",
            "STD_NAME": "Ekta ",
            "STD_FATHER_NAME": "Bhim Singh",
            "STD_MOTHER_NAME": "Angoori Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2203",
            "STD_TC_ISSUE_DATE": "26-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODc4&cwid=MTIwMA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/618",
            "STD_NAME": "Manisha Meena",
            "STD_FATHER_NAME": "Mohan Lal Meena",
            "STD_MOTHER_NAME": "Barfi Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2205",
            "STD_TC_ISSUE_DATE": "26-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTE2&cwid=MTIwMg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/211",
            "STD_NAME": "Amit Singh Rathore",
            "STD_FATHER_NAME": "Surendra Singh Rathore",
            "STD_MOTHER_NAME": "Praveen Singh Rathore",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2208",
            "STD_TC_ISSUE_DATE": "26-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQzMA==&cwid=MTIwNA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/104",
            "STD_NAME": "Shubham Bhatt",
            "STD_FATHER_NAME": "Vimal Bhatt",
            "STD_MOTHER_NAME": "Anita Bhatt",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2209",
            "STD_TC_ISSUE_DATE": "26-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTMyMg==&cwid=MTIwNg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/146",
            "STD_NAME": "Abhishek Kumar",
            "STD_FATHER_NAME": "Raman Kumar",
            "STD_MOTHER_NAME": "Meenakshi  ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2211",
            "STD_TC_ISSUE_DATE": "26-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM2NA==&cwid=MTIwOA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/149",
            "STD_NAME": "Preeti Jha",
            "STD_FATHER_NAME": "Pawan Kumar",
            "STD_MOTHER_NAME": "Meera Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2213",
            "STD_TC_ISSUE_DATE": "26-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM2Nw==&cwid=MTIxMQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/136",
            "STD_NAME": "Vikrant Bhardwaj",
            "STD_FATHER_NAME": "Bharat Bhushan",
            "STD_MOTHER_NAME": "Anju Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2215",
            "STD_TC_ISSUE_DATE": "28-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM1NA==&cwid=MTIxMw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/484",
            "STD_NAME": "Keshav Jain",
            "STD_FATHER_NAME": "Vishan Jain",
            "STD_MOTHER_NAME": "Renu Jain",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2216",
            "STD_TC_ISSUE_DATE": "28-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTU2&cwid=MTIxNQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/209",
            "STD_NAME": "Kiran Sharma",
            "STD_FATHER_NAME": "Subhash Chandra Sharma",
            "STD_MOTHER_NAME": "Dilesha Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2218",
            "STD_TC_ISSUE_DATE": "28-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQyOA==&cwid=MTIxNw==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/195",
            "STD_NAME": "Amit Kumar",
            "STD_FATHER_NAME": "Harish Chandra",
            "STD_MOTHER_NAME": "Asha Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2220",
            "STD_TC_ISSUE_DATE": "28-Jun-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQxMw==&cwid=MTIxOQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/79",
            "STD_NAME": "Akash ",
            "STD_FATHER_NAME": "J.N Kaul",
            "STD_MOTHER_NAME": "Kusum Arya",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2222",
            "STD_TC_ISSUE_DATE": "01-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODcw&cwid=MTIyMQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/123",
            "STD_NAME": "Sagar Kumar Bisws",
            "STD_FATHER_NAME": "Sameer Kumar Biswas",
            "STD_MOTHER_NAME": "Jharna Biswas",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2224",
            "STD_TC_ISSUE_DATE": "01-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM0MQ==&cwid=MTIyMw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/433",
            "STD_NAME": "Vivek Kumar ",
            "STD_FATHER_NAME": "Rajendra Yadav",
            "STD_MOTHER_NAME": "Amrika Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2226",
            "STD_TC_ISSUE_DATE": "01-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODY5&cwid=MTIyNQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/81",
            "STD_NAME": "Anubhav ",
            "STD_FATHER_NAME": "J N Kaul",
            "STD_MOTHER_NAME": "Kamalini ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2228",
            "STD_TC_ISSUE_DATE": "02-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODcz&cwid=MTIyNw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/118",
            "STD_NAME": "Ashly Sibichan",
            "STD_FATHER_NAME": "Sibichan T.  Joseph",
            "STD_MOTHER_NAME": "Shiny Sibichan",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2229",
            "STD_TC_ISSUE_DATE": "03-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTMzNg==&cwid=MTIyOQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/118",
            "STD_NAME": "Ashly Sibichan",
            "STD_FATHER_NAME": "Sibichan T.  Joseph",
            "STD_MOTHER_NAME": "Shiny Sibichan",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2229",
            "STD_TC_ISSUE_DATE": "03-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTMzNg==&cwid=MTIzMQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/260",
            "STD_NAME": "Abhinav Verma",
            "STD_FATHER_NAME": "Braj Kishor  Verma",
            "STD_MOTHER_NAME": "Sheo Rani Verma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2231",
            "STD_TC_ISSUE_DATE": "04-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQ3OQ==&cwid=MTIzMw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/165",
            "STD_NAME": "Vivek Tiwari",
            "STD_FATHER_NAME": "Uday Narayan ",
            "STD_MOTHER_NAME": "Mithlesh Tiwari",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2233",
            "STD_TC_ISSUE_DATE": "04-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM4Mw==&cwid=MTIzNQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/131",
            "STD_NAME": "Vikas Kumar Jha",
            "STD_FATHER_NAME": "Jagan Nath Jha",
            "STD_MOTHER_NAME": "Suvita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2235",
            "STD_TC_ISSUE_DATE": "04-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM0OQ==&cwid=MTIzNw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/567",
            "STD_NAME": "Divesh Singh Nainwal",
            "STD_FATHER_NAME": "Dungar Singh Nainwal",
            "STD_MOTHER_NAME": "Chandra Nainwal",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2236",
            "STD_TC_ISSUE_DATE": "04-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODQ2&cwid=MTIzOQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/567",
            "STD_NAME": "Divesh Singh Nainwal",
            "STD_FATHER_NAME": "Dungar Singh Nainwal",
            "STD_MOTHER_NAME": "Chandra Nainwal",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2236",
            "STD_TC_ISSUE_DATE": "04-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODQ2&cwid=MTI0MQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1164",
            "STD_NAME": "Dharni Nair",
            "STD_FATHER_NAME": "Sunil Nair",
            "STD_MOTHER_NAME": "Rohini Nair",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2238",
            "STD_TC_ISSUE_DATE": "04-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODc2&cwid=MTI0Mw==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/391",
            "STD_NAME": "Abhishek Mishra",
            "STD_FATHER_NAME": "Ram Kumar Mishra",
            "STD_MOTHER_NAME": "Radha Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2242",
            "STD_TC_ISSUE_DATE": "07-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NTY0&cwid=MTI0NQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/572",
            "STD_NAME": "Ravinder Yadav",
            "STD_FATHER_NAME": "Om Prakash ",
            "STD_MOTHER_NAME": "Poonam Yadav",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2244",
            "STD_TC_ISSUE_DATE": "07-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjQ2&cwid=MTI0Nw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/154",
            "STD_NAME": "Sonia Verma",
            "STD_FATHER_NAME": "Nand Ram Verma",
            "STD_MOTHER_NAME": "Sunita  Verma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2246",
            "STD_TC_ISSUE_DATE": "07-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM3Mg==&cwid=MTI0OQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/153",
            "STD_NAME": "Vikshit ",
            "STD_FATHER_NAME": "Joginder Kumar",
            "STD_MOTHER_NAME": "Mamta ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2248",
            "STD_TC_ISSUE_DATE": "07-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM3MQ==&cwid=MTI1MQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1232",
            "STD_NAME": "Pratibha Jain",
            "STD_FATHER_NAME": "Tilak Jain",
            "STD_MOTHER_NAME": "Vimla Jain",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2250",
            "STD_TC_ISSUE_DATE": "07-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY3Nw==&cwid=MTI1Mw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/148",
            "STD_NAME": "Jyoti Tripathi",
            "STD_FATHER_NAME": "B.K Tripathi",
            "STD_MOTHER_NAME": "Kavita Tripathi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2252",
            "STD_TC_ISSUE_DATE": "11-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjEy&cwid=MTI1NQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/82",
            "STD_NAME": "Anupriya ",
            "STD_FATHER_NAME": "J.N Kaul",
            "STD_MOTHER_NAME": "Sonia Yadav",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2253",
            "STD_TC_ISSUE_DATE": "11-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTEw&cwid=MTI1Nw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/171",
            "STD_NAME": "Yogita ",
            "STD_FATHER_NAME": "J.N Kaul",
            "STD_MOTHER_NAME": "Shanta K Nair",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2255",
            "STD_TC_ISSUE_DATE": "11-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTEx&cwid=MTI1OQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/219",
            "STD_NAME": "Bilal Ahmed",
            "STD_FATHER_NAME": "Irshad Ahmed",
            "STD_MOTHER_NAME": "Nagma Bano",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2257",
            "STD_TC_ISSUE_DATE": "11-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQzOA==&cwid=MTI2MQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/159",
            "STD_NAME": "Ruby Rai",
            "STD_FATHER_NAME": "Vinod Rai",
            "STD_MOTHER_NAME": "Sheela Rai",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2259",
            "STD_TC_ISSUE_DATE": "11-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM3Nw==&cwid=MTI2Mw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/501",
            "STD_NAME": "Sanjana Jangra",
            "STD_FATHER_NAME": "Satish Jangra",
            "STD_MOTHER_NAME": "Santa Jangra",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2260",
            "STD_TC_ISSUE_DATE": "11-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTE3&cwid=MTI2NQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/213",
            "STD_NAME": "Farheen Bano",
            "STD_FATHER_NAME": "Abdul Munaf ",
            "STD_MOTHER_NAME": "Saira ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2262",
            "STD_TC_ISSUE_DATE": "11-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQzMg==&cwid=MTI2Nw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1159",
            "STD_NAME": "Latika Choudhary",
            "STD_FATHER_NAME": "Darshan Choudhary",
            "STD_MOTHER_NAME": "Seema Choudhary",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2264",
            "STD_TC_ISSUE_DATE": "11-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODU0&cwid=MTI2OQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/546",
            "STD_NAME": "Kuldeep Mallik",
            "STD_FATHER_NAME": "Shashi Bhushan Mallik",
            "STD_MOTHER_NAME": "Mamta  Mallik",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2269",
            "STD_TC_ISSUE_DATE": "11-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODUz&cwid=MTI3MQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/45",
            "STD_NAME": "Varnika Patil",
            "STD_FATHER_NAME": "Prakash Patil",
            "STD_MOTHER_NAME": "Asha Patil",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2267",
            "STD_TC_ISSUE_DATE": "15-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODk0&cwid=MTI3Mw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1199",
            "STD_NAME": "Lalit Mohan Devtalla",
            "STD_FATHER_NAME": "Ramesh Chandra Devtalla",
            "STD_MOTHER_NAME": "Anita Devtalla",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2278",
            "STD_TC_ISSUE_DATE": "15-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTU3&cwid=MTI3NQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/60",
            "STD_NAME": "Ankur Chanda",
            "STD_FATHER_NAME": "Sanjeev Singh",
            "STD_MOTHER_NAME": "Shephali Chanda",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2279",
            "STD_TC_ISSUE_DATE": "15-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjA0&cwid=MTI3Nw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/103",
            "STD_NAME": "Asit Llal",
            "STD_FATHER_NAME": "Shankar Lal",
            "STD_MOTHER_NAME": "Nirmala Devi",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2270",
            "STD_TC_ISSUE_DATE": "15-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjQ3&cwid=MTI3OQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/151",
            "STD_NAME": "Roshan Rai",
            "STD_FATHER_NAME": "Sarweshwar Rai",
            "STD_MOTHER_NAME": "Rita Rai",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2266",
            "STD_TC_ISSUE_DATE": "16-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM2OQ==&cwid=MTI4MQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/617",
            "STD_NAME": "Ashish Chauhan",
            "STD_FATHER_NAME": "Shyambir Chauhan",
            "STD_MOTHER_NAME": "Sunita Chauhan",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2270",
            "STD_TC_ISSUE_DATE": "17-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTQ5&cwid=MTI4Mw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1200",
            "STD_NAME": "Sarthak Sharma",
            "STD_FATHER_NAME": "Suresh Kumar Sharma",
            "STD_MOTHER_NAME": "Abha Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2276",
            "STD_TC_ISSUE_DATE": "17-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTY3&cwid=MTI4NQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1233",
            "STD_NAME": "Sheetal ",
            "STD_FATHER_NAME": "Shubhash Chand",
            "STD_MOTHER_NAME": "Rajbala Chand",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2273",
            "STD_TC_ISSUE_DATE": "17-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY3OA==&cwid=MTI4Nw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/258",
            "STD_NAME": "Vivek Rai",
            "STD_FATHER_NAME": "Om Prakash Rai",
            "STD_MOTHER_NAME": "Sarojini Rai",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2283",
            "STD_TC_ISSUE_DATE": "17-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQ3Nw==&cwid=MTI4OQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/229",
            "STD_NAME": "Twinkle Bhardwaj",
            "STD_FATHER_NAME": "Paramjeet Singh Bhardwaj",
            "STD_MOTHER_NAME": "Rupa Bhardwaj",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2285",
            "STD_TC_ISSUE_DATE": "21-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQ0OA==&cwid=MTI5MQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1282",
            "STD_NAME": "Saurabh Kumar",
            "STD_FATHER_NAME": "Ramashankar Singh",
            "STD_MOTHER_NAME": "Anita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2287",
            "STD_TC_ISSUE_DATE": "24-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTcyNw==&cwid=MTI5Mw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/76",
            "STD_NAME": "Gaurav Mishra",
            "STD_FATHER_NAME": "Uday Shankar  Mishra",
            "STD_MOTHER_NAME": "Seema Mishra",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2289",
            "STD_TC_ISSUE_DATE": "26-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTI5NA==&cwid=MTI5NQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/76",
            "STD_NAME": "Gaurav Mishra",
            "STD_FATHER_NAME": "Uday Shankar  Mishra",
            "STD_MOTHER_NAME": "Seema Mishra",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2289",
            "STD_TC_ISSUE_DATE": "26-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTI5NA==&cwid=MTI5Nw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/110",
            "STD_NAME": "Neha Rani",
            "STD_FATHER_NAME": "Rajender Kumar",
            "STD_MOTHER_NAME": "Shakuntala ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2291",
            "STD_TC_ISSUE_DATE": "28-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjY4&cwid=MTI5OQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/7",
            "STD_NAME": "Swati Sharma",
            "STD_FATHER_NAME": "Sudhir  Sharma",
            "STD_MOTHER_NAME": "Chhaya Sharma",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2299",
            "STD_TC_ISSUE_DATE": "28-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjMz&cwid=MTMwMQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/194",
            "STD_NAME": "Rahul Chauhan",
            "STD_FATHER_NAME": "Mukesh Kumar ",
            "STD_MOTHER_NAME": "Shashi ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2296",
            "STD_TC_ISSUE_DATE": "28-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQxMg==&cwid=MTMwMw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/208",
            "STD_NAME": "Abhishek Nagar",
            "STD_FATHER_NAME": "Ranvir Nagar",
            "STD_MOTHER_NAME": "Suman Nagar",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2300",
            "STD_TC_ISSUE_DATE": "28-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQyNw==&cwid=MTMwNQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/77",
            "STD_NAME": "Monu ",
            "STD_FATHER_NAME": "Late Sh. Dharm Raj",
            "STD_MOTHER_NAME": "Kiran Devi",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2294",
            "STD_TC_ISSUE_DATE": "28-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NTYz&cwid=MTMwNw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1275",
            "STD_NAME": "Uday  Pratap",
            "STD_FATHER_NAME": "Anand Singh",
            "STD_MOTHER_NAME": "Saroj Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2298",
            "STD_TC_ISSUE_DATE": "26-Jul-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTcyMA==&cwid=MTMwOQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/979",
            "STD_NAME": "Chirag ",
            "STD_FATHER_NAME": "Amit Tyagi",
            "STD_MOTHER_NAME": "Preeti ",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "2136",
            "STD_TC_ISSUE_DATE": "16-Apr-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjY=&cwid=MTMxMQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/24",
            "STD_NAME": "Abhay Mishra",
            "STD_FATHER_NAME": "Harish Mishra",
            "STD_MOTHER_NAME": "Hansi Mishra",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "2138",
            "STD_TC_ISSUE_DATE": "15-Apr-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTI0Mg==&cwid=MTMxMw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/117",
            "STD_NAME": "Taniya Bansal",
            "STD_FATHER_NAME": "Rajesh Bansal",
            "STD_MOTHER_NAME": "Anjali ",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "2141",
            "STD_TC_ISSUE_DATE": "23-Apr-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTYxOA==&cwid=MTMxNQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1000",
            "STD_NAME": "Kanshika Awasthi",
            "STD_FATHER_NAME": "Vivek Awasthi",
            "STD_MOTHER_NAME": "Deepti Awasthi",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "2145",
            "STD_TC_ISSUE_DATE": "25-Apr-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Nw==&cwid=MTMxNw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/908",
            "STD_NAME": "Deeksha Vashisht",
            "STD_FATHER_NAME": "Ghanshyam Vashisht",
            "STD_MOTHER_NAME": "Geeta Vashisht",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2146",
            "STD_TC_ISSUE_DATE": "25-Apr-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDE1&cwid=MTMxOQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1241",
            "STD_NAME": "Krishan Kumar",
            "STD_FATHER_NAME": "Puran Kumar",
            "STD_MOTHER_NAME": "Shanti Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2148",
            "STD_TC_ISSUE_DATE": "29-Apr-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc1Mw==&cwid=MTMyMQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/11",
            "STD_NAME": "Khushi Sharma",
            "STD_FATHER_NAME": "Gaurav Sharma",
            "STD_MOTHER_NAME": "Gunjan ",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "2167",
            "STD_TC_ISSUE_DATE": "20-May-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTIyOQ==&cwid=MTMyNA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1352",
            "STD_NAME": "Yash  Sharma",
            "STD_FATHER_NAME": "Sanjay Kumar Sharma",
            "STD_MOTHER_NAME": "Anita Sharma",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "00",
            "STD_TC_ISSUE_DATE": "07-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTgwNA==&cwid=MTMyNw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/653",
            "STD_NAME": "Rosmi Mathew",
            "STD_FATHER_NAME": "K S Dubey",
            "STD_MOTHER_NAME": "Mauli Methew",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "2163",
            "STD_TC_ISSUE_DATE": "19-May-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjcw&cwid=MTMyOQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/172",
            "STD_NAME": "Sonal Sharma",
            "STD_FATHER_NAME": "Fatte Lal Sharma",
            "STD_MOTHER_NAME": "Bindawati Sharma",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2304",
            "STD_TC_ISSUE_DATE": "08-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjMx&cwid=MTMzMQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/163",
            "STD_NAME": "Shubham Sharma",
            "STD_FATHER_NAME": "Anil Sharma",
            "STD_MOTHER_NAME": "Urmila Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2305",
            "STD_TC_ISSUE_DATE": "11-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM4MQ==&cwid=MTMzMw==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/220",
            "STD_NAME": "Arjit Chaturvedi",
            "STD_FATHER_NAME": "Rajesh Chaturvedi",
            "STD_MOTHER_NAME": "Shobha Chaturvedi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2307",
            "STD_TC_ISSUE_DATE": "11-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQzOQ==&cwid=MTMzNQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1222",
            "STD_NAME": "Akash Arya",
            "STD_FATHER_NAME": "J.N. Kaul",
            "STD_MOTHER_NAME": "Kusum Arya",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3",
            "STD_TC_ISSUE_DATE": "12-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY2Nw==&cwid=MTMzOA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1224",
            "STD_NAME": "Anubhav ",
            "STD_FATHER_NAME": "J.N. Kaul",
            "STD_MOTHER_NAME": "Kamalini ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3",
            "STD_TC_ISSUE_DATE": "12-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY2OQ==&cwid=MTM0MA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1224",
            "STD_NAME": "Anubhav ",
            "STD_FATHER_NAME": "J. N. Kaul",
            "STD_MOTHER_NAME": "Kamalini ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3",
            "STD_TC_ISSUE_DATE": "12-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY1MA==&cwid=MTM0Mw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1225",
            "STD_NAME": "Anupriya Yadav",
            "STD_FATHER_NAME": "J.N. Kaul",
            "STD_MOTHER_NAME": "Sonia ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3",
            "STD_TC_ISSUE_DATE": "12-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY3MA==&cwid=MTM0Ng==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1227",
            "STD_NAME": "Ashly Sibichan",
            "STD_FATHER_NAME": "Joseph Sibichan",
            "STD_MOTHER_NAME": "Shiny Sibichan",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3",
            "STD_TC_ISSUE_DATE": "12-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY1Mw==&cwid=MTM0OA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1232",
            "STD_NAME": "Pratibha Jain",
            "STD_FATHER_NAME": "   ",
            "STD_MOTHER_NAME": "   ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2",
            "STD_TC_ISSUE_DATE": "12-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY1OA==&cwid=MTM1MA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1237",
            "STD_NAME": "Twinkle Bhardwaj",
            "STD_FATHER_NAME": "   ",
            "STD_MOTHER_NAME": "   ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3",
            "STD_TC_ISSUE_DATE": "12-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY2Mw==&cwid=MTM1Mg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1226",
            "STD_NAME": "Arun Bhadana",
            "STD_FATHER_NAME": "Dayachand Bhadana",
            "STD_MOTHER_NAME": "Surendri Bhadana",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3",
            "STD_TC_ISSUE_DATE": "13-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY1Mg==&cwid=MTM1NA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1229",
            "STD_NAME": "Lakshay Saini",
            "STD_FATHER_NAME": "Kimti Saini",
            "STD_MOTHER_NAME": "Moly Matthew",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3",
            "STD_TC_ISSUE_DATE": "13-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY1NQ==&cwid=MTM1Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1231",
            "STD_NAME": "Monica Shambharwal",
            "STD_FATHER_NAME": "   ",
            "STD_MOTHER_NAME": "   ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4",
            "STD_TC_ISSUE_DATE": "13-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY1Nw==&cwid=MTM1OA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1234",
            "STD_NAME": "Shiv Kr. Bhardwaj",
            "STD_FATHER_NAME": "   ",
            "STD_MOTHER_NAME": "   ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3",
            "STD_TC_ISSUE_DATE": "13-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY2MA==&cwid=MTM2MA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1238",
            "STD_NAME": "Vijay Arya",
            "STD_FATHER_NAME": "   ",
            "STD_MOTHER_NAME": "   ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3",
            "STD_TC_ISSUE_DATE": "13-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY2NA==&cwid=MTM2Mg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1240",
            "STD_NAME": "Vishal Sajwan",
            "STD_FATHER_NAME": "   ",
            "STD_MOTHER_NAME": "   ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3",
            "STD_TC_ISSUE_DATE": "13-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY2Ng==&cwid=MTM2NA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/145",
            "STD_NAME": "Inder Kumar",
            "STD_FATHER_NAME": "Sahdev  Shah",
            "STD_MOTHER_NAME": "Meena Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2311",
            "STD_TC_ISSUE_DATE": "20-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM2Mw==&cwid=MTM2Ng==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/543",
            "STD_NAME": "Kartik Walia",
            "STD_FATHER_NAME": "Sanjeev Walia",
            "STD_MOTHER_NAME": "Manju Bala",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "2313",
            "STD_TC_ISSUE_DATE": "30-Aug-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzU=&cwid=MTM2OA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/199",
            "STD_NAME": "Gaurav Babra",
            "STD_FATHER_NAME": "Dharmpal Singh",
            "STD_MOTHER_NAME": "Pappi ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2315",
            "STD_TC_ISSUE_DATE": "10-Sep-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQxNw==&cwid=MTM3MA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/165",
            "STD_NAME": "Javed Ali",
            "STD_FATHER_NAME": "Sajjan Ali",
            "STD_MOTHER_NAME": "Salma Parveen",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2317",
            "STD_TC_ISSUE_DATE": "15-Sep-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODUx&cwid=MTM3Mg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/955",
            "STD_NAME": "Dhruv ",
            "STD_FATHER_NAME": "Rachit Dogra",
            "STD_MOTHER_NAME": "Suchela ",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "2320",
            "STD_TC_ISSUE_DATE": "23-Sep-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Njg=&cwid=MTM3NA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1417",
            "STD_NAME": "Dhairyaa Arya",
            "STD_FATHER_NAME": "Sundieep Arya",
            "STD_MOTHER_NAME": "Kirron  Arya",
            "STD_LAST_CLASS": "LKG",
            "STD_TCNO": "2322",
            "STD_TC_ISSUE_DATE": "27-Sep-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg2OQ==&cwid=MTM3Ng==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/32",
            "STD_NAME": "Lakshay Saini",
            "STD_FATHER_NAME": "J.N. Kaul",
            "STD_MOTHER_NAME": "Mouliy Mathew",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2324",
            "STD_TC_ISSUE_DATE": "13-Oct-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODgw&cwid=MTM3OA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/599",
            "STD_NAME": "Sohini Gupta",
            "STD_FATHER_NAME": "Satish Gupta",
            "STD_MOTHER_NAME": "Mamta Gupta",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2326",
            "STD_TC_ISSUE_DATE": "15-Oct-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTcw&cwid=MTM4MA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/142",
            "STD_NAME": "Ashutosh Kumar",
            "STD_FATHER_NAME": "Raman Kumar",
            "STD_MOTHER_NAME": "Meenakshi ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2328",
            "STD_TC_ISSUE_DATE": "10-Oct-2014",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM2MA==&cwid=MTM4Mg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/706",
            "STD_NAME": "Bhanu Prakash Joshi",
            "STD_FATHER_NAME": "Lalit Mohan Joshi",
            "STD_MOTHER_NAME": "Uma Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2333",
            "STD_TC_ISSUE_DATE": "12-Feb-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTgy&cwid=MTM4NA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1609",
            "STD_NAME": "Pritam ",
            "STD_FATHER_NAME": "Nagendra Kumar Thakur",
            "STD_MOTHER_NAME": "Babita Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2334",
            "STD_TC_ISSUE_DATE": "02-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjA2MQ==&cwid=MTM4Ng==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/137",
            "STD_NAME": "Deepak Bhadana",
            "STD_FATHER_NAME": "Tej  Singh",
            "STD_MOTHER_NAME": "Jasrathi ",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "2337",
            "STD_TC_ISSUE_DATE": "06-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM1NQ==&cwid=MTM4OA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/377",
            "STD_NAME": "Abhinav Singh",
            "STD_FATHER_NAME": "Mahender Pratap Singh",
            "STD_MOTHER_NAME": "Ritu Singh",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "2339",
            "STD_TC_ISSUE_DATE": "07-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzUz&cwid=MTM5MA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1350",
            "STD_NAME": "Shaurya Sai",
            "STD_FATHER_NAME": "Sandeep ",
            "STD_MOTHER_NAME": "Kamal ",
            "STD_LAST_CLASS": "LKG",
            "STD_TCNO": "2341",
            "STD_TC_ISSUE_DATE": "07-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTgwMg==&cwid=MTM5Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1399",
            "STD_NAME": "Ravi  Yadav",
            "STD_FATHER_NAME": "Kishori Lal Yadav",
            "STD_MOTHER_NAME": "Manoj Devi",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2343",
            "STD_TC_ISSUE_DATE": "07-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg1MQ==&cwid=MTM5NA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/540",
            "STD_NAME": "Hardik Dadheech",
            "STD_FATHER_NAME": "Shree Ram Dadheech",
            "STD_MOTHER_NAME": "Kanchan Dadheech",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "2345",
            "STD_TC_ISSUE_DATE": "10-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Njk=&cwid=MTM5Ng==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1377",
            "STD_NAME": "Ayushi Mall",
            "STD_FATHER_NAME": "Jitender Kumar",
            "STD_MOTHER_NAME": "Maya Devi",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "2346",
            "STD_TC_ISSUE_DATE": "11-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTgyOQ==&cwid=MTM5OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1454",
            "STD_NAME": "Chirag Chopra",
            "STD_FATHER_NAME": "Suman Chopra",
            "STD_MOTHER_NAME": "Simmi Chopra",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "2572",
            "STD_TC_ISSUE_DATE": "14-May-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkwNg==&cwid=MTQwMA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/475",
            "STD_NAME": "Shivam Varshney",
            "STD_FATHER_NAME": "Subodh Varshney",
            "STD_MOTHER_NAME": "Shivani Varshney",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "2351",
            "STD_TC_ISSUE_DATE": "11-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk5&cwid=MTQwMg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1396",
            "STD_NAME": "Ayush ",
            "STD_FATHER_NAME": "Satish ",
            "STD_MOTHER_NAME": "Poonam ",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "2353",
            "STD_TC_ISSUE_DATE": "15-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg0OA==&cwid=MTQwNA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/145",
            "STD_NAME": "Ganesh Ghosh",
            "STD_FATHER_NAME": "Kamal Kumar Ghosh",
            "STD_MOTHER_NAME": "Preeti Ghosh",
            "STD_LAST_CLASS": "UKG",
            "STD_TCNO": "2358",
            "STD_TC_ISSUE_DATE": "20-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY0Ng==&cwid=MTQwOQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1414",
            "STD_NAME": "Yogita ",
            "STD_FATHER_NAME": "Sanjay Kumar",
            "STD_MOTHER_NAME": "Vinita ",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "2360",
            "STD_TC_ISSUE_DATE": "20-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg2Ng==&cwid=MTQxMg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/75",
            "STD_NAME": "Hrithik Bhadana",
            "STD_FATHER_NAME": "Mahavir Bhadana",
            "STD_MOTHER_NAME": "Suman Bhadana",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "2362",
            "STD_TC_ISSUE_DATE": "18-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTI5Mw==&cwid=MTQxNA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/105",
            "STD_NAME": "Harsh Baisoya",
            "STD_FATHER_NAME": "Vinod Kumar",
            "STD_MOTHER_NAME": "Seema ",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "2365",
            "STD_TC_ISSUE_DATE": "22-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTMyMw==&cwid=MTQxNg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/299",
            "STD_NAME": "Ritesh Chaprana",
            "STD_FATHER_NAME": "Rakesh Chaprana",
            "STD_MOTHER_NAME": "Sangeeta Chaprana",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "2367",
            "STD_TC_ISSUE_DATE": "23-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk0&cwid=MTQxOA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/233",
            "STD_NAME": "Ankush Baisla",
            "STD_FATHER_NAME": "Rohit Baisla",
            "STD_MOTHER_NAME": "Teena ",
            "STD_LAST_CLASS": "UKG",
            "STD_TCNO": "2369",
            "STD_TC_ISSUE_DATE": "23-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQ1Mg==&cwid=MTQyMA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1401",
            "STD_NAME": "Asha ",
            "STD_FATHER_NAME": "Babu Ram",
            "STD_MOTHER_NAME": "Saroj ",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "2371",
            "STD_TC_ISSUE_DATE": "23-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg1Mw==&cwid=MTQyMg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/990",
            "STD_NAME": "Anmol Sharma",
            "STD_FATHER_NAME": "Praveen Sharma",
            "STD_MOTHER_NAME": "Poonam Devi",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "2373",
            "STD_TC_ISSUE_DATE": "23-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjI=&cwid=MTQyNA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1336",
            "STD_NAME": "Ruth Singh",
            "STD_FATHER_NAME": "Vijay ",
            "STD_MOTHER_NAME": "Sujana ",
            "STD_LAST_CLASS": "UKG",
            "STD_TCNO": "2336",
            "STD_TC_ISSUE_DATE": "04-Apr-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc4OA==&cwid=MTQyNg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/944",
            "STD_NAME": "Sagar  ",
            "STD_FATHER_NAME": "Ajipal ",
            "STD_MOTHER_NAME": "Aarti ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2376",
            "STD_TC_ISSUE_DATE": "06-May-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzkz&cwid=MTQyOA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1394",
            "STD_NAME": "Pallavi Sharma",
            "STD_FATHER_NAME": "Kishore Sharma",
            "STD_MOTHER_NAME": "Preeti Sharma",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2378",
            "STD_TC_ISSUE_DATE": "06-May-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg0Ng==&cwid=MTQzMA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/82",
            "STD_NAME": "Ayush Chaudhary",
            "STD_FATHER_NAME": "Sandeep Chaudhry",
            "STD_MOTHER_NAME": "Anu Chaudhary",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "3296",
            "STD_TC_ISSUE_DATE": "04-Oct-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTMwMA==&cwid=MTQzMg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/36",
            "STD_NAME": "Lakshay Sharma",
            "STD_FATHER_NAME": "Rakesh Sharma",
            "STD_MOTHER_NAME": "Meena Sharma",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "2380",
            "STD_TC_ISSUE_DATE": "06-May-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTI1NA==&cwid=MTQzNA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1481",
            "STD_NAME": "Dikshant ",
            "STD_FATHER_NAME": "Yashpal Ahlawat",
            "STD_MOTHER_NAME": "Rajrani Ahlawat",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2384",
            "STD_TC_ISSUE_DATE": "14-May-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkzMw==&cwid=MTQzNg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1333",
            "STD_NAME": "Pavni  Joshi",
            "STD_FATHER_NAME": "Sunil  Joshi",
            "STD_MOTHER_NAME": "Anita Joshi",
            "STD_LAST_CLASS": "UKG",
            "STD_TCNO": "2386",
            "STD_TC_ISSUE_DATE": "14-May-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc4Mg==&cwid=MTQzOA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1535",
            "STD_NAME": "Harsh Bhadana",
            "STD_FATHER_NAME": "Mahaveer Bhadana",
            "STD_MOTHER_NAME": "Babita Bhadana",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2388",
            "STD_TC_ISSUE_DATE": "25-May-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk4Nw==&cwid=MTQ0MA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1707",
            "STD_NAME": "Sakya H. Kilpady",
            "STD_FATHER_NAME": "Vikram Kilpady",
            "STD_MOTHER_NAME": "Shyamalika Haldar Kilpady",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "2390",
            "STD_TC_ISSUE_DATE": "25-May-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE5Nw==&cwid=MTQ0Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1323",
            "STD_NAME": "Rahul ",
            "STD_FATHER_NAME": "Gopal  Saxena",
            "STD_MOTHER_NAME": "Chammoraj Saxena",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2392",
            "STD_TC_ISSUE_DATE": "20-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc3Mg==&cwid=MTQ0NA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/6",
            "STD_NAME": "Ruth Abraham",
            "STD_FATHER_NAME": "K.C. Abraham",
            "STD_MOTHER_NAME": "Missiamma Abraham",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2394",
            "STD_TC_ISSUE_DATE": "20-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTUwNw==&cwid=MTQ0Ng==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/901",
            "STD_NAME": "Ritu ",
            "STD_FATHER_NAME": "Sudhir Kumar Singh",
            "STD_MOTHER_NAME": "Kamini Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2396",
            "STD_TC_ISSUE_DATE": "20-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODE4&cwid=MTQ0OA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/308",
            "STD_NAME": "Shilpa S. Nair",
            "STD_FATHER_NAME": "V B Sasi Kumar",
            "STD_MOTHER_NAME": "Jyothi Kumar",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2398",
            "STD_TC_ISSUE_DATE": "20-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzA2&cwid=MTQ1MA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/882",
            "STD_NAME": "Mukul Sharma",
            "STD_FATHER_NAME": "Ramesh Sharma",
            "STD_MOTHER_NAME": "Deepika Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2400",
            "STD_TC_ISSUE_DATE": "22-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODEx&cwid=MTQ1Mg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/914",
            "STD_NAME": "Meetanshi Aggarwal",
            "STD_FATHER_NAME": "Ravi Aggarwal",
            "STD_MOTHER_NAME": "Chitra Rani",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2402",
            "STD_TC_ISSUE_DATE": "22-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODA5&cwid=MTQ1NA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/920",
            "STD_NAME": "Vijay Singh Patni",
            "STD_FATHER_NAME": "Ganesh Singh Patni",
            "STD_MOTHER_NAME": "Radha Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2404",
            "STD_TC_ISSUE_DATE": "22-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODI3&cwid=MTQ1Ng==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/27",
            "STD_NAME": "Preeti Jakhmola",
            "STD_FATHER_NAME": "Khushal Mani",
            "STD_MOTHER_NAME": "Lalita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2406",
            "STD_TC_ISSUE_DATE": "22-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzI5&cwid=MTQ1OA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/129",
            "STD_NAME": "Divyanshi Sharma",
            "STD_FATHER_NAME": "Ajay Sharma",
            "STD_MOTHER_NAME": "Mithlesh  Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2408",
            "STD_TC_ISSUE_DATE": "22-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM0Nw==&cwid=MTQ2MA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/309",
            "STD_NAME": "Yashna Aneja",
            "STD_FATHER_NAME": "Prem Kumar",
            "STD_MOTHER_NAME": "Manju Aneja",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2410",
            "STD_TC_ISSUE_DATE": "23-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Nzg4&cwid=MTQ2Mg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/17",
            "STD_NAME": "Sahil Chauhan",
            "STD_FATHER_NAME": "Brahm Pal ",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2412",
            "STD_TC_ISSUE_DATE": "23-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDc3&cwid=MTQ2NA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/848",
            "STD_NAME": "Pooja Rani",
            "STD_FATHER_NAME": "Mahendra Pal  Singh",
            "STD_MOTHER_NAME": "Sangeeta Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2414",
            "STD_TC_ISSUE_DATE": "23-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODEz&cwid=MTQ2Ng==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/849",
            "STD_NAME": "Shalini Singh",
            "STD_FATHER_NAME": "Gyanendra Singh",
            "STD_MOTHER_NAME": "Archana Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2416",
            "STD_TC_ISSUE_DATE": "23-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODIz&cwid=MTQ2OA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/212",
            "STD_NAME": "Prince Singh",
            "STD_FATHER_NAME": "Virender Singh",
            "STD_MOTHER_NAME": "Sanyukta Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2418",
            "STD_TC_ISSUE_DATE": "23-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQzMQ==&cwid=MTQ3MA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1248",
            "STD_NAME": "Roshni Kumari",
            "STD_FATHER_NAME": "Devendra Bhagat",
            "STD_MOTHER_NAME": "Annpurna Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2420",
            "STD_TC_ISSUE_DATE": "23-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY5Mw==&cwid=MTQ3Mg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/508",
            "STD_NAME": "Kuldeep Choudhary",
            "STD_FATHER_NAME": "Kallu Singh",
            "STD_MOTHER_NAME": "Minkal Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2422",
            "STD_TC_ISSUE_DATE": "23-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Njg3&cwid=MTQ3NA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/851",
            "STD_NAME": "Mohit Choudhary",
            "STD_FATHER_NAME": "Satveer Singh",
            "STD_MOTHER_NAME": "Shimla Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2425",
            "STD_TC_ISSUE_DATE": "30-Jun-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODEw&cwid=MTQ3Ng==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1265",
            "STD_NAME": "Kamal Kumar Chauhan ",
            "STD_FATHER_NAME": "Sagar Mal Chauhan ",
            "STD_MOTHER_NAME": "Bhagwati ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2427",
            "STD_TC_ISSUE_DATE": "03-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTcxMA==&cwid=MTQ3OA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1205",
            "STD_NAME": "Bhavna Kanhere",
            "STD_FATHER_NAME": "Girish Kanhere",
            "STD_MOTHER_NAME": "Shubhangi Kanhere",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2429",
            "STD_TC_ISSUE_DATE": "04-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzI4&cwid=MTQ4MA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/135",
            "STD_NAME": "Rakesh Kumar Singh",
            "STD_FATHER_NAME": "Vishwas Singh",
            "STD_MOTHER_NAME": "Devanti Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2431",
            "STD_TC_ISSUE_DATE": "04-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTYzNg==&cwid=MTQ4Mg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/149",
            "STD_NAME": "Aakansha Srivastava",
            "STD_FATHER_NAME": "Vijay Kumar Srivastava",
            "STD_MOTHER_NAME": "Meena Srivastava",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2433",
            "STD_TC_ISSUE_DATE": "07-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDU2&cwid=MTQ4NA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/959",
            "STD_NAME": "Shekhar ",
            "STD_FATHER_NAME": "Late Virender ",
            "STD_MOTHER_NAME": "Seema ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2435",
            "STD_TC_ISSUE_DATE": "07-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDQw&cwid=MTQ4Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/852",
            "STD_NAME": "Satish Kamati",
            "STD_FATHER_NAME": "Kumar Lal Kamati",
            "STD_MOTHER_NAME": "Meena Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2436",
            "STD_TC_ISSUE_DATE": "07-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODIy&cwid=MTQ4OA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/422",
            "STD_NAME": "Vivek Sharma",
            "STD_FATHER_NAME": "Madan Gopal Sharma",
            "STD_MOTHER_NAME": "Malti Devi Sharma",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2439",
            "STD_TC_ISSUE_DATE": "08-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NTI0&cwid=MTQ5MA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1325",
            "STD_NAME": "Farukh Khan",
            "STD_FATHER_NAME": "Saeed Khan",
            "STD_MOTHER_NAME": "Saroj ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2441",
            "STD_TC_ISSUE_DATE": "08-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc3NA==&cwid=MTQ5Mg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/18",
            "STD_NAME": "Ayesha Khan",
            "STD_FATHER_NAME": "J N Kaul",
            "STD_MOTHER_NAME": "Saroj ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2443",
            "STD_TC_ISSUE_DATE": "08-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzI1&cwid=MTQ5NA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/993",
            "STD_NAME": "Subham Singh",
            "STD_FATHER_NAME": "Shyam Singh",
            "STD_MOTHER_NAME": "Sushma Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2445",
            "STD_TC_ISSUE_DATE": "09-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODI2&cwid=MTQ5Ng==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/218",
            "STD_NAME": "Diya Benny",
            "STD_FATHER_NAME": "Benny Ms",
            "STD_MOTHER_NAME": "Minny Benny",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2447",
            "STD_TC_ISSUE_DATE": "13-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDYy&cwid=MTQ5OA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/863",
            "STD_NAME": "Kiran Khairia",
            "STD_FATHER_NAME": "B.N Khairia",
            "STD_MOTHER_NAME": "Sunita Khairia",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2449",
            "STD_TC_ISSUE_DATE": "14-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Njg2&cwid=MTUwMA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1330",
            "STD_NAME": "Pawan Bora",
            "STD_FATHER_NAME": "Govind Singh Bora",
            "STD_MOTHER_NAME": "Bimla ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2451",
            "STD_TC_ISSUE_DATE": "14-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc3OQ==&cwid=MTUwMg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/128",
            "STD_NAME": "Tanya ",
            "STD_FATHER_NAME": "Hans Raj ",
            "STD_MOTHER_NAME": "Asha  Devi",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2453",
            "STD_TC_ISSUE_DATE": "14-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDQ0&cwid=MTUwNA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1243",
            "STD_NAME": "Himanshu Mishra",
            "STD_FATHER_NAME": "Ajay Mishra",
            "STD_MOTHER_NAME": "Ragini Mishra",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2455",
            "STD_TC_ISSUE_DATE": "15-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY4OA==&cwid=MTUwNg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/831",
            "STD_NAME": "Vikas Bharti",
            "STD_FATHER_NAME": "Vimal Bharti",
            "STD_MOTHER_NAME": "Saroj Bala",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2457",
            "STD_TC_ISSUE_DATE": "16-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODI4&cwid=MTUwOA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/854",
            "STD_NAME": "Damini Chauhan",
            "STD_FATHER_NAME": "Gajraj Singh Chauhan",
            "STD_MOTHER_NAME": "Sudha Chauhan",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2459",
            "STD_TC_ISSUE_DATE": "16-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Nzk4&cwid=MTUxMA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/80",
            "STD_NAME": "Roopa ",
            "STD_FATHER_NAME": "Jagdish Pathak",
            "STD_MOTHER_NAME": "Seeta  Pathak",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2461",
            "STD_TC_ISSUE_DATE": "16-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NTE3&cwid=MTUxMg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/21",
            "STD_NAME": "Sumit Kumar",
            "STD_FATHER_NAME": "Uma Shankar Kushwaha",
            "STD_MOTHER_NAME": "Indu Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2463",
            "STD_TC_ISSUE_DATE": "16-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NTUy&cwid=MTUxNA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1216",
            "STD_NAME": "Sarthak Singh",
            "STD_FATHER_NAME": "Hardeep Singh",
            "STD_MOTHER_NAME": "Bhagwati Kaur",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2465",
            "STD_TC_ISSUE_DATE": "17-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzE0&cwid=MTUxNg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/20",
            "STD_NAME": "Deepak Vashist",
            "STD_FATHER_NAME": "Manoj Sharma",
            "STD_MOTHER_NAME": "Rajni Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2467",
            "STD_TC_ISSUE_DATE": "17-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzE4&cwid=MTUxOA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1274",
            "STD_NAME": "Tripuresh Tiwari",
            "STD_FATHER_NAME": "Vinod Kumar Tiwari",
            "STD_MOTHER_NAME": "Kalindi Tiwari",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2469",
            "STD_TC_ISSUE_DATE": "17-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTcxOQ==&cwid=MTUyMA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1059",
            "STD_NAME": "Sunidhi Bhatnagar",
            "STD_FATHER_NAME": "J N Kaul",
            "STD_MOTHER_NAME": "Sadhana Bhatnagar",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2471",
            "STD_TC_ISSUE_DATE": "17-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Nzgz&cwid=MTUyMg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/957",
            "STD_NAME": "Priyanshi Soni",
            "STD_FATHER_NAME": "J.D Soni",
            "STD_MOTHER_NAME": "Priti Soni",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2473",
            "STD_TC_ISSUE_DATE": "20-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Njk0&cwid=MTUyNA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/374",
            "STD_NAME": "Rohit S. Chand",
            "STD_FATHER_NAME": "Shrichand ",
            "STD_MOTHER_NAME": "Sushila ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2475",
            "STD_TC_ISSUE_DATE": "20-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Nzc4&cwid=MTUyNg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1285",
            "STD_NAME": "Shwetank ",
            "STD_FATHER_NAME": "Subodh Kumar",
            "STD_MOTHER_NAME": "Usha Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2477",
            "STD_TC_ISSUE_DATE": "20-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTczMA==&cwid=MTUyOA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/41",
            "STD_NAME": "Dheeraj  Kumar",
            "STD_FATHER_NAME": "Ranbir Singh",
            "STD_MOTHER_NAME": "Mithlesh Kumari",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2479",
            "STD_TC_ISSUE_DATE": "20-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Njgw&cwid=MTUzMA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/117",
            "STD_NAME": "Ashrey Rajgyan",
            "STD_FATHER_NAME": "Arun Chaudhary",
            "STD_MOTHER_NAME": "Mamta Chaudhry",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2481",
            "STD_TC_ISSUE_DATE": "20-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTMzNQ==&cwid=MTUzMg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1448",
            "STD_NAME": "Anubhav Tiwari",
            "STD_FATHER_NAME": "Arun Kumar Tiwari",
            "STD_MOTHER_NAME": "Rama Tiwari",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2483",
            "STD_TC_ISSUE_DATE": "20-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkwMA==&cwid=MTUzNA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/43",
            "STD_NAME": "Suman Rai",
            "STD_FATHER_NAME": "Birender Kumar  Rai",
            "STD_MOTHER_NAME": "Kiran Rai",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2485",
            "STD_TC_ISSUE_DATE": "21-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzI2&cwid=MTUzNg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/5",
            "STD_NAME": "Swati ",
            "STD_FATHER_NAME": "J.N Kaul",
            "STD_MOTHER_NAME": "Supriti Patnaik",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2487",
            "STD_TC_ISSUE_DATE": "22-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjMy&cwid=MTUzOA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1539",
            "STD_NAME": "Kamal Tanwar",
            "STD_FATHER_NAME": "Manhipal Singh Tanwar",
            "STD_MOTHER_NAME": "Veervati Singh Tanwar",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2489",
            "STD_TC_ISSUE_DATE": "22-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk5MQ==&cwid=MTU0MA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/236",
            "STD_NAME": "Afreen ",
            "STD_FATHER_NAME": "Mohmmad Khalid",
            "STD_MOTHER_NAME": "Asma Ban0",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2491",
            "STD_TC_ISSUE_DATE": "27-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQ1NQ==&cwid=MTU0Mg==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1270",
            "STD_NAME": "Kartik Almia",
            "STD_FATHER_NAME": "Harinder Singh",
            "STD_MOTHER_NAME": "Tulsi Almia",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2494",
            "STD_TC_ISSUE_DATE": "27-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTcxNQ==&cwid=MTU0NA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1324",
            "STD_NAME": "Shivani ",
            "STD_FATHER_NAME": "Naval Kishore",
            "STD_MOTHER_NAME": "Darshan ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2495",
            "STD_TC_ISSUE_DATE": "27-Jul-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc3Mw==&cwid=MTU0Ng==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/120",
            "STD_NAME": "Manjeet ",
            "STD_FATHER_NAME": "J.N. Kaul",
            "STD_MOTHER_NAME": "Reena ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2497",
            "STD_TC_ISSUE_DATE": "07-Aug-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTYyMQ==&cwid=MTU0OA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1321",
            "STD_NAME": "Akshay Rawat",
            "STD_FATHER_NAME": "Rajesh Rawat",
            "STD_MOTHER_NAME": "Geeta Rawat",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2499",
            "STD_TC_ISSUE_DATE": "07-Aug-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc3MA==&cwid=MTU1MA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/832",
            "STD_NAME": "Krish Chhetri",
            "STD_FATHER_NAME": "Bedraj Chhetri",
            "STD_MOTHER_NAME": "Malika Chhetri",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "2501",
            "STD_TC_ISSUE_DATE": "10-Aug-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM=&cwid=MTU1Mg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/956",
            "STD_NAME": "Sukriti Kumari",
            "STD_FATHER_NAME": "Nand Kishor Prasad",
            "STD_MOTHER_NAME": "Madhuri Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2503",
            "STD_TC_ISSUE_DATE": "14-Aug-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Nzgy&cwid=MTU1NA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/439",
            "STD_NAME": "Mukhtar Ahmad Siddeeque",
            "STD_FATHER_NAME": "Khalil Ahmed",
            "STD_MOTHER_NAME": "Mustari ",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2505",
            "STD_TC_ISSUE_DATE": "17-Aug-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Nzc=&cwid=MTU1Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/164",
            "STD_NAME": "Dilip Yadav",
            "STD_FATHER_NAME": "Shiv Mangal Yadav",
            "STD_MOTHER_NAME": "Sushila Yadav",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2507",
            "STD_TC_ISSUE_DATE": "21-Aug-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTMz&cwid=MTU1OA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/182",
            "STD_NAME": "Nitin Tomar",
            "STD_FATHER_NAME": "Brij Mohan Tomar",
            "STD_MOTHER_NAME": "Ritu ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2509",
            "STD_TC_ISSUE_DATE": "21-Aug-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQwMA==&cwid=MTU2MA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1284",
            "STD_NAME": "Shubham Negi",
            "STD_FATHER_NAME": "Sukhpal  Negi",
            "STD_MOTHER_NAME": "Shanti Negi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2511",
            "STD_TC_ISSUE_DATE": "21-Aug-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTcyOQ==&cwid=MTU2Mg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/865",
            "STD_NAME": "Chiraag Dhindhwal",
            "STD_FATHER_NAME": "Lalit Kumar Dhindhwal",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "2512",
            "STD_TC_ISSUE_DATE": "25-Aug-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg=&cwid=MTU2NA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/283",
            "STD_NAME": "Abhijeet ",
            "STD_FATHER_NAME": "J.N. Kaul",
            "STD_MOTHER_NAME": "Shyamoli ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2514",
            "STD_TC_ISSUE_DATE": "26-Aug-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTUwMg==&cwid=MTU2Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1494",
            "STD_NAME": "Shikher Awana",
            "STD_FATHER_NAME": "Sanjay ",
            "STD_MOTHER_NAME": "Santosh ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2517",
            "STD_TC_ISSUE_DATE": "27-Aug-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk0Ng==&cwid=MTU2OA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1251",
            "STD_NAME": "Anchal Singh Rathore",
            "STD_FATHER_NAME": "Surendra Singh Rathore",
            "STD_MOTHER_NAME": "Praveen Singh Rathore",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2518",
            "STD_TC_ISSUE_DATE": "27-Aug-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY5Ng==&cwid=MTU3MA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/183",
            "STD_NAME": "Abhishek Rajbhar",
            "STD_FATHER_NAME": "Rabindra Rajbhar",
            "STD_MOTHER_NAME": "Tara Rajbhar",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2520",
            "STD_TC_ISSUE_DATE": "12-Sep-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQwMQ==&cwid=MTU3Mg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/692",
            "STD_NAME": "Ramveer Bhadana",
            "STD_FATHER_NAME": "Sukhbeer Singh Bhadana",
            "STD_MOTHER_NAME": "Kamlesh Bhadana",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2523",
            "STD_TC_ISSUE_DATE": "12-Sep-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODg2&cwid=MTU3NA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/96",
            "STD_NAME": "Rohit Sain",
            "STD_FATHER_NAME": "Ramesh Kumar",
            "STD_MOTHER_NAME": "Lalti Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2525",
            "STD_TC_ISSUE_DATE": "12-Sep-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTU5Nw==&cwid=MTU3Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/834",
            "STD_NAME": "Farid Salmani",
            "STD_FATHER_NAME": "Mohd Hanif Ahmad Salmani",
            "STD_MOTHER_NAME": "Amana Salmani",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2527",
            "STD_TC_ISSUE_DATE": "15-Sep-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Nzk5&cwid=MTU3OA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/111",
            "STD_NAME": "Ayushi ",
            "STD_FATHER_NAME": "Rajkumar ",
            "STD_MOTHER_NAME": "Anita ",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "2532",
            "STD_TC_ISSUE_DATE": "23-Sep-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTMyOQ==&cwid=MTU4MA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/100",
            "STD_NAME": "Uppal ",
            "STD_FATHER_NAME": "Omveer ",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2529",
            "STD_TC_ISSUE_DATE": "23-Sep-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTMxOA==&cwid=MTU4Mg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/31",
            "STD_NAME": "Nandini ",
            "STD_FATHER_NAME": "Shiv Dayal",
            "STD_MOTHER_NAME": "Sheela Rajvanshi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2533",
            "STD_TC_ISSUE_DATE": "23-Sep-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzMx&cwid=MTU4NA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/349",
            "STD_NAME": "Abhishek Bhadana",
            "STD_FATHER_NAME": "Rajesh Bhadana",
            "STD_MOTHER_NAME": "Pushpa Bhadana",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2535",
            "STD_TC_ISSUE_DATE": "23-Nov-2015",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Nzk0&cwid=MTU4Ng==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/227",
            "STD_NAME": "Deepti Sharma",
            "STD_FATHER_NAME": "Brijesh Kumar",
            "STD_MOTHER_NAME": "Poonam Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2537",
            "STD_TC_ISSUE_DATE": "12-Feb-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQ0Ng==&cwid=MTU4OA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1668",
            "STD_NAME": "K.Harshita ",
            "STD_FATHER_NAME": "A. Kumaraguru ",
            "STD_MOTHER_NAME": "K.Andal  Kani",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "2539",
            "STD_TC_ISSUE_DATE": "21-Mar-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE1OA==&cwid=MTU5MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/250",
            "STD_NAME": "Arjun Panchal",
            "STD_FATHER_NAME": "Late Shri J.N Kaul",
            "STD_MOTHER_NAME": "Madavi Pant",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "2540",
            "STD_TC_ISSUE_DATE": "06-Apr-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQ2OQ==&cwid=MTU5Mg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/5",
            "STD_NAME": "Soumya Prasad",
            "STD_FATHER_NAME": "Durga Prasad Nishad",
            "STD_MOTHER_NAME": "Roma Prasad",
            "STD_LAST_CLASS": "LKG",
            "STD_TCNO": "2543",
            "STD_TC_ISSUE_DATE": "09-Apr-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQzNg==&cwid=MTU5NA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1697",
            "STD_NAME": "Pranavi ",
            "STD_FATHER_NAME": "Jagdish Madan",
            "STD_MOTHER_NAME": "Deepika ",
            "STD_LAST_CLASS": "LKG",
            "STD_TCNO": "2545",
            "STD_TC_ISSUE_DATE": "09-Apr-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE4Nw==&cwid=MTU5Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/866",
            "STD_NAME": "Lakshay Kumar",
            "STD_FATHER_NAME": "Kamal Kumar",
            "STD_MOTHER_NAME": "Manju Rani",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "2547",
            "STD_TC_ISSUE_DATE": "16-Apr-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU=&cwid=MTU5OA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/401",
            "STD_NAME": "Gagandeep Matharu",
            "STD_FATHER_NAME": " Inderjeet Singh",
            "STD_MOTHER_NAME": "Gurjeet Kaur",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "2549",
            "STD_TC_ISSUE_DATE": "09-Apr-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTMy&cwid=MTYwMA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/38",
            "STD_NAME": "Aditya Bhardwaj",
            "STD_FATHER_NAME": "Jitender Sharma",
            "STD_MOTHER_NAME": "Seema Sharma",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "2551",
            "STD_TC_ISSUE_DATE": "09-Apr-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTI1Ng==&cwid=MTYwMg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/588",
            "STD_NAME": "Harsh ",
            "STD_FATHER_NAME": "Harpal Singh",
            "STD_MOTHER_NAME": "Rohini Kaul",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2553",
            "STD_TC_ISSUE_DATE": "09-Apr-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzA=&cwid=MTYwNA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1345",
            "STD_NAME": "Harsh Singh",
            "STD_FATHER_NAME": "Dharmendra  Singh",
            "STD_MOTHER_NAME": "Sarita Signh",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2555",
            "STD_TC_ISSUE_DATE": "19-Apr-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc5Nw==&cwid=MTYwNg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1373",
            "STD_NAME": "Rohit Kumar",
            "STD_FATHER_NAME": "Pramod Kumar",
            "STD_MOTHER_NAME": "Rangeeta Devi",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "2557",
            "STD_TC_ISSUE_DATE": "19-Apr-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTgyNQ==&cwid=MTYwOA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/65",
            "STD_NAME": "Avinav Chauhan",
            "STD_FATHER_NAME": "Indrapal Singh ",
            "STD_MOTHER_NAME": "Jyoti Chauhan",
            "STD_LAST_CLASS": "UKG",
            "STD_TCNO": "2559",
            "STD_TC_ISSUE_DATE": "22-Apr-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTU2Ng==&cwid=MTYxMA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1730",
            "STD_NAME": "Yash Raj Massey",
            "STD_FATHER_NAME": "Barnard Massey",
            "STD_MOTHER_NAME": "Manjeet   Massey",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2561",
            "STD_TC_ISSUE_DATE": "26-Apr-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjIyMA==&cwid=MTYxMg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1435",
            "STD_NAME": "Susheel Yadav",
            "STD_FATHER_NAME": "Rajkumar ",
            "STD_MOTHER_NAME": "Laxmi Devi",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "2563",
            "STD_TC_ISSUE_DATE": "26-Apr-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg4Nw==&cwid=MTYxNA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1700",
            "STD_NAME": "Amarjeet ",
            "STD_FATHER_NAME": "Ashok Kumar Yadav",
            "STD_MOTHER_NAME": "Nisha ",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2565",
            "STD_TC_ISSUE_DATE": "26-Apr-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE5MA==&cwid=MTYxNg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1806",
            "STD_NAME": "Jai Upadhyay",
            "STD_FATHER_NAME": "Dheeraj Kumar Upadhyay",
            "STD_MOTHER_NAME": "Shalini Upadhyay",
            "STD_LAST_CLASS": "LKG",
            "STD_TCNO": "2567",
            "STD_TC_ISSUE_DATE": "26-Apr-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI5Ng==&cwid=MTYxOA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/49",
            "STD_NAME": "Manish Nagar",
            "STD_FATHER_NAME": "Rajeshwar Nagar",
            "STD_MOTHER_NAME": "Balesh ",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "2726",
            "STD_TC_ISSUE_DATE": "04-Mar-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTU1MA==&cwid=MTYyMA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1775",
            "STD_NAME": "Harvinder Singh Poonia",
            "STD_FATHER_NAME": "Rajeswar Singh Poonia",
            "STD_MOTHER_NAME": "Mukesh Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2571",
            "STD_TC_ISSUE_DATE": "12-May-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI2NQ==&cwid=MTYyMg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1767",
            "STD_NAME": "Shubham  Kumar Choudhary",
            "STD_FATHER_NAME": "Raj Kumar ",
            "STD_MOTHER_NAME": "Rinku Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2578",
            "STD_TC_ISSUE_DATE": "27-May-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI1Nw==&cwid=MTYyNA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/932",
            "STD_NAME": "Priyanshu Sharma",
            "STD_FATHER_NAME": "Hukam Chand  Sharma",
            "STD_MOTHER_NAME": "Madhu Sharma",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2580",
            "STD_TC_ISSUE_DATE": "30-May-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI5&cwid=MTYyNg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1642",
            "STD_NAME": "Devashree ",
            "STD_FATHER_NAME": " J N  Kaul",
            "STD_MOTHER_NAME": "Sabita Gosh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2582",
            "STD_TC_ISSUE_DATE": "10-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjA5NA==&cwid=MTYyOA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1606",
            "STD_NAME": "Satyam Gupta",
            "STD_FATHER_NAME": "Rajeev Gupta",
            "STD_MOTHER_NAME": "Ranjana Gupta",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2584",
            "STD_TC_ISSUE_DATE": "10-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjA1OA==&cwid=MTYzMA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1530",
            "STD_NAME": "Dhairya Nayyar",
            "STD_FATHER_NAME": "Yashumeet Nayyar",
            "STD_MOTHER_NAME": "Neetu Nayyar",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2586",
            "STD_TC_ISSUE_DATE": "10-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk4Mg==&cwid=MTYzMg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1485",
            "STD_NAME": "Neha Chaprana",
            "STD_FATHER_NAME": "Nakul Chaprana",
            "STD_MOTHER_NAME": "Poonam ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2588",
            "STD_TC_ISSUE_DATE": "10-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkzNw==&cwid=MTYzNA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1612",
            "STD_NAME": "Aishwrya ",
            "STD_FATHER_NAME": " J. N. Kaul",
            "STD_MOTHER_NAME": "Kusum Arya",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2590",
            "STD_TC_ISSUE_DATE": "10-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjA2NA==&cwid=MTYzNg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1613",
            "STD_NAME": "Jyoti ",
            "STD_FATHER_NAME": "J. N.  Kaul",
            "STD_MOTHER_NAME": "Supriti Patnaik",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2592",
            "STD_TC_ISSUE_DATE": "10-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjA2NQ==&cwid=MTYzOA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1611",
            "STD_NAME": "Rekha Verma",
            "STD_FATHER_NAME": "Keshav  Verma",
            "STD_MOTHER_NAME": "Chanda Devi Verma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2594",
            "STD_TC_ISSUE_DATE": "10-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjA2Mw==&cwid=MTY0MA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1489",
            "STD_NAME": "Pooja Rana",
            "STD_FATHER_NAME": "Shakti Chand Rana",
            "STD_MOTHER_NAME": "Krishna Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2596",
            "STD_TC_ISSUE_DATE": "10-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk0MQ==&cwid=MTY0Mg==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1329",
            "STD_NAME": "Manish Kumar Jha",
            "STD_FATHER_NAME": "Pravin Kumar Jha",
            "STD_MOTHER_NAME": "Anita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2598",
            "STD_TC_ISSUE_DATE": "11-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc3OA==&cwid=MTY0NA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1420",
            "STD_NAME": "Abhishek Hari Krishan",
            "STD_FATHER_NAME": "Hari Krishan V.S Panicker",
            "STD_MOTHER_NAME": "Alka Johri",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2600",
            "STD_TC_ISSUE_DATE": "23-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg3Mg==&cwid=MTY0Ng==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1368",
            "STD_NAME": "Ashutosh Singh",
            "STD_FATHER_NAME": "Ravi Pratap Singh",
            "STD_MOTHER_NAME": "Geeta Singh",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2602",
            "STD_TC_ISSUE_DATE": "10-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTgyMA==&cwid=MTY0OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1498",
            "STD_NAME": "Rituraj Singh",
            "STD_FATHER_NAME": "Alakh Niranjan Singh",
            "STD_MOTHER_NAME": "Shardha Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2604",
            "STD_TC_ISSUE_DATE": "16-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk1MA==&cwid=MTY1MA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1492",
            "STD_NAME": "Sumit ",
            "STD_FATHER_NAME": "Rajbeer Singh",
            "STD_MOTHER_NAME": "Anita Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2606",
            "STD_TC_ISSUE_DATE": "16-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk0NA==&cwid=MTY1Mg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1605",
            "STD_NAME": "Shikha Kasyap",
            "STD_FATHER_NAME": "Sanjay Kasyap",
            "STD_MOTHER_NAME": "Geeta Kasyap",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2608",
            "STD_TC_ISSUE_DATE": "20-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjA1Nw==&cwid=MTY1NA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/900",
            "STD_NAME": "Sagar ",
            "STD_FATHER_NAME": "Jagpal ",
            "STD_MOTHER_NAME": "Sonwati ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2610",
            "STD_TC_ISSUE_DATE": "22-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzky&cwid=MTY1Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1523",
            "STD_NAME": "Shivangee ",
            "STD_FATHER_NAME": "Birendra Prasad Singh",
            "STD_MOTHER_NAME": "Pushpa Lata Kumari",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2612",
            "STD_TC_ISSUE_DATE": "22-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk3NQ==&cwid=MTY1OA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1403",
            "STD_NAME": "Mayank Singh",
            "STD_FATHER_NAME": "Kunwar  Singh",
            "STD_MOTHER_NAME": "Kalawati ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2614",
            "STD_TC_ISSUE_DATE": "22-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg1NQ==&cwid=MTY2MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1513",
            "STD_NAME": "Soniya ",
            "STD_FATHER_NAME": "Surender ",
            "STD_MOTHER_NAME": "Sunita Yadav",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2616",
            "STD_TC_ISSUE_DATE": "22-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk2NQ==&cwid=MTY2Mg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1478",
            "STD_NAME": "Sakshi Jha",
            "STD_FATHER_NAME": "Diwakar Jha",
            "STD_MOTHER_NAME": "Anupama Jha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2618",
            "STD_TC_ISSUE_DATE": "22-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkzMA==&cwid=MTY2NA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1558",
            "STD_NAME": "Tamanna Sharma",
            "STD_FATHER_NAME": "Hukum Chand Sharma",
            "STD_MOTHER_NAME": "Madhu Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2620",
            "STD_TC_ISSUE_DATE": "23-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjAxMA==&cwid=MTY2Ng==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1643",
            "STD_NAME": "Manish Daryani",
            "STD_FATHER_NAME": "Ramesh Daryani",
            "STD_MOTHER_NAME": "Ganga Daryani",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2622",
            "STD_TC_ISSUE_DATE": "23-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjA5NQ==&cwid=MTY2OA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1452",
            "STD_NAME": "Bharti ",
            "STD_FATHER_NAME": "Karan Singh",
            "STD_MOTHER_NAME": "Lajjawati Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2624",
            "STD_TC_ISSUE_DATE": "23-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkwNA==&cwid=MTY3MA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1531",
            "STD_NAME": "Simran ",
            "STD_FATHER_NAME": "Sunil Kumar Soni",
            "STD_MOTHER_NAME": "Kamlesh ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2626",
            "STD_TC_ISSUE_DATE": "23-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk4Mw==&cwid=MTY3Mg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1551",
            "STD_NAME": "Harsh Aggerwal",
            "STD_FATHER_NAME": "Rakesh Aggerwal",
            "STD_MOTHER_NAME": "Late  Savita Aggerwal",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2628",
            "STD_TC_ISSUE_DATE": "23-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjAwMw==&cwid=MTY3NA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1596",
            "STD_NAME": "Prem  Chand Sharma",
            "STD_FATHER_NAME": "Jagdesh  Prasad Sharma",
            "STD_MOTHER_NAME": "Shashi Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2630",
            "STD_TC_ISSUE_DATE": "23-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjA0OA==&cwid=MTY3Ng==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1254",
            "STD_NAME": "Arti Rawat",
            "STD_FATHER_NAME": "Gopal Singh",
            "STD_MOTHER_NAME": "Anju  Rawat",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2632",
            "STD_TC_ISSUE_DATE": "23-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTY5OQ==&cwid=MTY3OA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1544",
            "STD_NAME": "Karishma Srivastava",
            "STD_FATHER_NAME": "Lakhi Srivastava",
            "STD_MOTHER_NAME": "Badami Srivastava",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2634",
            "STD_TC_ISSUE_DATE": "23-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk5Ng==&cwid=MTY4MA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1450",
            "STD_NAME": "Arveen Kaur",
            "STD_FATHER_NAME": "Gurwant Singh",
            "STD_MOTHER_NAME": "Harneet Kaur",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2636",
            "STD_TC_ISSUE_DATE": "24-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkwMg==&cwid=MTY4Mg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1486",
            "STD_NAME": "Anil Patil",
            "STD_FATHER_NAME": "Suresh Patil",
            "STD_MOTHER_NAME": "Indu Patil",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2638",
            "STD_TC_ISSUE_DATE": "24-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkzOA==&cwid=MTY4NA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1034",
            "STD_NAME": "Sandeep ",
            "STD_FATHER_NAME": " Hatpal ",
            "STD_MOTHER_NAME": " Mukesh ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2640",
            "STD_TC_ISSUE_DATE": "24-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzk0&cwid=MTY4Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1500",
            "STD_NAME": "Anushree Banerjee",
            "STD_FATHER_NAME": "Shiv Nath Banerjee",
            "STD_MOTHER_NAME": "Nandita Banerjee",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2642",
            "STD_TC_ISSUE_DATE": "25-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk1Mg==&cwid=MTY4OA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1468",
            "STD_NAME": "Bhuvan Bist",
            "STD_FATHER_NAME": "Man Singh Bist",
            "STD_MOTHER_NAME": "Shiva Bist",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2644",
            "STD_TC_ISSUE_DATE": "25-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkyMA==&cwid=MTY5MA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1471",
            "STD_NAME": "Gitanjali Nair",
            "STD_FATHER_NAME": "Javahar Nair",
            "STD_MOTHER_NAME": "Geetika Nair",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2646",
            "STD_TC_ISSUE_DATE": "27-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkyMw==&cwid=MTY5Mg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1502",
            "STD_NAME": "Aamir Khan",
            "STD_FATHER_NAME": "Ayub Khan",
            "STD_MOTHER_NAME": "Akhtari Khan",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2663",
            "STD_TC_ISSUE_DATE": "03-Aug-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk1NA==&cwid=MTY5NA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1554",
            "STD_NAME": "Sahil ",
            "STD_FATHER_NAME": "Anjani Kumar Jha",
            "STD_MOTHER_NAME": "Rehana Jha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2649",
            "STD_TC_ISSUE_DATE": "29-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjAwNg==&cwid=MTY5Ng==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1529",
            "STD_NAME": "Riya Singhal",
            "STD_FATHER_NAME": "Jai Prakash Singhal",
            "STD_MOTHER_NAME": "Sangeeta Singhal",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2651",
            "STD_TC_ISSUE_DATE": "29-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk4MQ==&cwid=MTY5OA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1536",
            "STD_NAME": "Anshuman ",
            "STD_FATHER_NAME": "Anoop Tripathi",
            "STD_MOTHER_NAME": "Madhu Tripathi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2653",
            "STD_TC_ISSUE_DATE": "29-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk4OA==&cwid=MTcwMA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1447",
            "STD_NAME": "Ankit Kumar",
            "STD_FATHER_NAME": "Ravinder Kumar",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2655",
            "STD_TC_ISSUE_DATE": "29-Jun-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg5OQ==&cwid=MTcwMg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1370",
            "STD_NAME": "Nitesh Goel",
            "STD_FATHER_NAME": "Kailash Chand",
            "STD_MOTHER_NAME": "Kamlesh ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2657",
            "STD_TC_ISSUE_DATE": "02-Jul-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTgyMg==&cwid=MTcwNA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1509",
            "STD_NAME": "Yash Bakshi",
            "STD_FATHER_NAME": "Sanjeev Bakshi",
            "STD_MOTHER_NAME": "Indu Bakshi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2660",
            "STD_TC_ISSUE_DATE": "07-Jul-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk2MQ==&cwid=MTcwNg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1346",
            "STD_NAME": "Vaibhav Yadav",
            "STD_FATHER_NAME": "Rampal Yadav",
            "STD_MOTHER_NAME": "Meena ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2662",
            "STD_TC_ISSUE_DATE": "07-Jul-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc5OA==&cwid=MTcwOA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1465",
            "STD_NAME": "Mohit Rawat",
            "STD_FATHER_NAME": "Manohar Rawat",
            "STD_MOTHER_NAME": "Kavita Rawat",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2665",
            "STD_TC_ISSUE_DATE": "08-Jul-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkxNw==&cwid=MTcxMA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1520",
            "STD_NAME": "Pooja Raghav",
            "STD_FATHER_NAME": "Dhaniram ",
            "STD_MOTHER_NAME": "Shyamwati ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2667",
            "STD_TC_ISSUE_DATE": "12-Jul-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk3Mg==&cwid=MTcxMg==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1484",
            "STD_NAME": "Josna George",
            "STD_FATHER_NAME": "George John",
            "STD_MOTHER_NAME": "Saly George",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2669",
            "STD_TC_ISSUE_DATE": "12-Jul-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkzNg==&cwid=MTcxNA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1480",
            "STD_NAME": "Aman Tripathi",
            "STD_FATHER_NAME": "B D  Tripathi",
            "STD_MOTHER_NAME": "Shail Tripathi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2671",
            "STD_TC_ISSUE_DATE": "12-Jul-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkzMg==&cwid=MTcxNg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/194",
            "STD_NAME": "Rohit Kumar",
            "STD_FATHER_NAME": "Shrikant Ram",
            "STD_MOTHER_NAME": "Sunaina Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2674",
            "STD_TC_ISSUE_DATE": "16-Jul-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDM3&cwid=MTcxOA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/672",
            "STD_NAME": "Kapil Yadav",
            "STD_FATHER_NAME": "Ram Lakhan  Yadav",
            "STD_MOTHER_NAME": "Shiv Dhara Yadav",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2673",
            "STD_TC_ISSUE_DATE": "19-Jul-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY4&cwid=MTcyMA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/257",
            "STD_NAME": "Dibanshu ",
            "STD_FATHER_NAME": "Rajesh Mehra",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2677",
            "STD_TC_ISSUE_DATE": "26-Jul-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY0&cwid=MTcyMg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1820",
            "STD_NAME": "Vishal Dubey",
            "STD_FATHER_NAME": "Brijesh Dubey",
            "STD_MOTHER_NAME": "Anita Dubey",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2679",
            "STD_TC_ISSUE_DATE": "26-Jul-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMxMA==&cwid=MTcyNA==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1451",
            "STD_NAME": "Aseem  Saxena",
            "STD_FATHER_NAME": "Atul Saxena",
            "STD_MOTHER_NAME": "Shikha Saxena",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2681",
            "STD_TC_ISSUE_DATE": "28-Jul-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkwMw==&cwid=MTcyNg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1559",
            "STD_NAME": "Anoop Nagar",
            "STD_FATHER_NAME": "Brhampal ",
            "STD_MOTHER_NAME": "Kusum ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2683",
            "STD_TC_ISSUE_DATE": "28-Jul-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjAxMQ==&cwid=MTcyOA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1469",
            "STD_NAME": "Deepak Kumar Singh",
            "STD_FATHER_NAME": "Prem Ram ",
            "STD_MOTHER_NAME": "Sheela Arya",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2685",
            "STD_TC_ISSUE_DATE": "28-Jul-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkyMQ==&cwid=MTczMA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1327",
            "STD_NAME": "Viswajeet Kumar Dubey",
            "STD_FATHER_NAME": "Vijay Shankar  Dubey",
            "STD_MOTHER_NAME": "Manju Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2687",
            "STD_TC_ISSUE_DATE": "30-Jul-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc3Ng==&cwid=MTczMg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1482",
            "STD_NAME": "Dinesh Kumar",
            "STD_FATHER_NAME": "Ratan Singh",
            "STD_MOTHER_NAME": "Jashodha ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2689",
            "STD_TC_ISSUE_DATE": "09-Aug-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkzNA==&cwid=MTczNA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1490",
            "STD_NAME": "Sunidhi Jaglan",
            "STD_FATHER_NAME": "Sandeep  Jaglan",
            "STD_MOTHER_NAME": "Manita Jaglan",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2691",
            "STD_TC_ISSUE_DATE": "09-Aug-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk0Mg==&cwid=MTczNg==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1853",
            "STD_NAME": "Shankey Baisla",
            "STD_FATHER_NAME": "Rajbir Baisla",
            "STD_MOTHER_NAME": "Binesh Baisla",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2693",
            "STD_TC_ISSUE_DATE": "09-Aug-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM0Mw==&cwid=MTczOA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/929",
            "STD_NAME": "Kaushal Tiwari",
            "STD_FATHER_NAME": "Siya Ram Tiwari",
            "STD_MOTHER_NAME": "Rekha Tiwari",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2695",
            "STD_TC_ISSUE_DATE": "12-Aug-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzcw&cwid=MTc0MA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/981",
            "STD_NAME": "Nitin Sharma",
            "STD_FATHER_NAME": "Hariom  Sharma",
            "STD_MOTHER_NAME": "Sonu Sharma",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2697",
            "STD_TC_ISSUE_DATE": "16-Aug-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzgx&cwid=MTc0Mg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1458",
            "STD_NAME": "Saurabh Bhadana",
            "STD_FATHER_NAME": "Vikash Kumar Bhadana",
            "STD_MOTHER_NAME": "Pushpa Rani",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2699",
            "STD_TC_ISSUE_DATE": "20-Aug-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkxMA==&cwid=MTc0NA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/894",
            "STD_NAME": "Ankit Pandey",
            "STD_FATHER_NAME": "Sanjay Pandey",
            "STD_MOTHER_NAME": "Juli Pandey",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2701",
            "STD_TC_ISSUE_DATE": "20-Aug-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDU4&cwid=MTc0Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1916",
            "STD_NAME": "Ganga Singh Kouranga",
            "STD_FATHER_NAME": " J N  Kaul",
            "STD_MOTHER_NAME": "Purnima Sutradhar",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2703",
            "STD_TC_ISSUE_DATE": "20-Aug-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQwNg==&cwid=MTc0OA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1477",
            "STD_NAME": "Karan Sharma",
            "STD_FATHER_NAME": "Sanjeev Kumar",
            "STD_MOTHER_NAME": "Neetu Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2705",
            "STD_TC_ISSUE_DATE": "22-Aug-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkyOQ==&cwid=MTc1MA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1467",
            "STD_NAME": "Ashutosh Padhy",
            "STD_FATHER_NAME": "Shankar Prasad Padhy",
            "STD_MOTHER_NAME": "Kiran Padhy",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2707",
            "STD_TC_ISSUE_DATE": "27-Aug-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkxOQ==&cwid=MTc1Mg==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/343",
            "STD_NAME": "Amool ",
            "STD_FATHER_NAME": "Sanjay Kumar",
            "STD_MOTHER_NAME": "Shobha ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2709",
            "STD_TC_ISSUE_DATE": "31-Aug-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIz&cwid=MTc1NA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1547",
            "STD_NAME": "Simarpreet Singh",
            "STD_FATHER_NAME": "Tejinder Singh",
            "STD_MOTHER_NAME": "Tejinder Kaur Lamba",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2710",
            "STD_TC_ISSUE_DATE": "24-Sep-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk5OQ==&cwid=MTc1Ng==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1979",
            "STD_NAME": "Rahul Bhardwaj",
            "STD_FATHER_NAME": "Reshmani Sharma",
            "STD_MOTHER_NAME": "Rukmani Devi ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2712",
            "STD_TC_ISSUE_DATE": "04-Oct-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjUxNg==&cwid=MTc1OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1522",
            "STD_NAME": "Jyoti Prajapati",
            "STD_FATHER_NAME": "Prem  Chand",
            "STD_MOTHER_NAME": "Rajrani ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2715",
            "STD_TC_ISSUE_DATE": "14-Oct-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk3NA==&cwid=MTc2MA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1418",
            "STD_NAME": "Kalpana Yadav",
            "STD_FATHER_NAME": "Vakil Singh Yadav",
            "STD_MOTHER_NAME": "Durvasha Yadav",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "2717",
            "STD_TC_ISSUE_DATE": "26-Oct-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg3MA==&cwid=MTc2Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2014",
            "STD_NAME": "Udit Kumar Yadav",
            "STD_FATHER_NAME": "Vakil Singh Yadav",
            "STD_MOTHER_NAME": "Durvasha Yadav",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2719",
            "STD_TC_ISSUE_DATE": "26-Oct-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU1MQ==&cwid=MTc2NA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1279",
            "STD_NAME": "Sachin ",
            "STD_FATHER_NAME": "Shiv Nath",
            "STD_MOTHER_NAME": "Shyama ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2721",
            "STD_TC_ISSUE_DATE": "24-Nov-2016",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTcyNA==&cwid=MTc2Ng==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1499",
            "STD_NAME": "Ankita Yadav",
            "STD_FATHER_NAME": "Nagendra Yadav",
            "STD_MOTHER_NAME": "Rina Yadav",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2723",
            "STD_TC_ISSUE_DATE": "16-Feb-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk1MQ==&cwid=MTc2OQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1506",
            "STD_NAME": "Mohd Ayaan ",
            "STD_FATHER_NAME": "Hafizulla ",
            "STD_MOTHER_NAME": "Naseem Fatma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2725",
            "STD_TC_ISSUE_DATE": "16-Feb-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk1OA==&cwid=MTc3MQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1464",
            "STD_NAME": "Nisha Sharma",
            "STD_FATHER_NAME": "Purushottam Sharma",
            "STD_MOTHER_NAME": "Tara Devi",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2728",
            "STD_TC_ISSUE_DATE": "13-Apr-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkxNg==&cwid=MTc3NA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1953",
            "STD_NAME": "Chirag Chopra",
            "STD_FATHER_NAME": "Suman Chopra",
            "STD_MOTHER_NAME": "Simmi Chopra",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "2730",
            "STD_TC_ISSUE_DATE": "13-Apr-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ5MA==&cwid=MTc3Ng==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/23",
            "STD_NAME": "Aashi Chauhan",
            "STD_FATHER_NAME": "Deepak Chauhan",
            "STD_MOTHER_NAME": "Lalita Chauhan",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "2732",
            "STD_TC_ISSUE_DATE": "13-Apr-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTUyNA==&cwid=MTc3OA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/21",
            "STD_NAME": "Amogh Gautam",
            "STD_FATHER_NAME": "Himanshu Gautam",
            "STD_MOTHER_NAME": "Pooja Gautam",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "2734",
            "STD_TC_ISSUE_DATE": "15-Apr-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTIzOQ==&cwid=MTc4MA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1347",
            "STD_NAME": "Tanush Singh",
            "STD_FATHER_NAME": "Jaipal ",
            "STD_MOTHER_NAME": "Suman ",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "2736",
            "STD_TC_ISSUE_DATE": "22-Apr-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc5OQ==&cwid=MTc4Mg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2043",
            "STD_NAME": "Roshan Sharma",
            "STD_FATHER_NAME": "Dhanjee Sharma",
            "STD_MOTHER_NAME": "Kusum Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2738",
            "STD_TC_ISSUE_DATE": "22-Apr-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU4MA==&cwid=MTc4NA==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2112",
            "STD_NAME": "Tanisha Agrawal",
            "STD_FATHER_NAME": "Ashish Agrawal",
            "STD_MOTHER_NAME": "Shilpi Agrawal",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "2740",
            "STD_TC_ISSUE_DATE": "03-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY0OQ==&cwid=MTc4Ng==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/106",
            "STD_NAME": "Anirudh Yadav",
            "STD_FATHER_NAME": "Naresh Yadav",
            "STD_MOTHER_NAME": "Pyari Devi",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3960",
            "STD_TC_ISSUE_DATE": "22-Apr-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ4&cwid=MTc4OA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/32",
            "STD_NAME": "Khushi Saini",
            "STD_FATHER_NAME": "Naresh  Kumar ",
            "STD_MOTHER_NAME": "Samita Saini",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "2744",
            "STD_TC_ISSUE_DATE": "29-Apr-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE0MQ==&cwid=MTc5MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2025",
            "STD_NAME": "Mohit Sah",
            "STD_FATHER_NAME": "Laxman Sah",
            "STD_MOTHER_NAME": "Lalita Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2746",
            "STD_TC_ISSUE_DATE": "17-May-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU2Mg==&cwid=MTc5Mg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1856",
            "STD_NAME": "Ranjeet ",
            "STD_FATHER_NAME": "Dilip Shah",
            "STD_MOTHER_NAME": "Geeta Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2748",
            "STD_TC_ISSUE_DATE": "12-Jun-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM0Ng==&cwid=MTc5NA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1821",
            "STD_NAME": "Dhruv Sharma",
            "STD_FATHER_NAME": "Subhash Sharma",
            "STD_MOTHER_NAME": "Sumita Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2750",
            "STD_TC_ISSUE_DATE": "27-Jun-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMxMQ==&cwid=MTc5Ng==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1914",
            "STD_NAME": "Jemathi ",
            "STD_FATHER_NAME": "Puran Bhoj",
            "STD_MOTHER_NAME": "Prema Shiela",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2755",
            "STD_TC_ISSUE_DATE": "28-Jun-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQwNA==&cwid=MTc5OA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1798",
            "STD_NAME": "Ajay Mehra",
            "STD_FATHER_NAME": "Govind  Singh Mehra",
            "STD_MOTHER_NAME": "Bhawani Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2752",
            "STD_TC_ISSUE_DATE": "28-Jun-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI4OA==&cwid=MTgwMA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1810",
            "STD_NAME": "Harsh Chaprana",
            "STD_FATHER_NAME": "Narender  Singh Chaprana",
            "STD_MOTHER_NAME": "Neeraj ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2754",
            "STD_TC_ISSUE_DATE": "28-Jun-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMwMA==&cwid=MTgwMg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1794",
            "STD_NAME": "Devyani Verma",
            "STD_FATHER_NAME": "Ashok Kumar Verma",
            "STD_MOTHER_NAME": "Jagdamba Verma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2757",
            "STD_TC_ISSUE_DATE": "28-Jun-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI4NA==&cwid=MTgwNA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2070",
            "STD_NAME": "Ankit Kumar",
            "STD_FATHER_NAME": "Ramphool ",
            "STD_MOTHER_NAME": "Kamla Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2760",
            "STD_TC_ISSUE_DATE": "28-Jun-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYwNw==&cwid=MTgwNg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1729",
            "STD_NAME": "Kuldeep ",
            "STD_FATHER_NAME": "Satish Kumar",
            "STD_MOTHER_NAME": "Suman ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2763",
            "STD_TC_ISSUE_DATE": "28-Jun-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjIxOQ==&cwid=MTgwOA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1764",
            "STD_NAME": "Bhawna Rexwal",
            "STD_FATHER_NAME": "Sanjay Rexwal",
            "STD_MOTHER_NAME": "Veena Rexwal",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2764",
            "STD_TC_ISSUE_DATE": "28-Jun-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI1NA==&cwid=MTgxMA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/67",
            "STD_NAME": "Tezi ",
            "STD_FATHER_NAME": "Naval Kishore",
            "STD_MOTHER_NAME": "Savita ",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "2766",
            "STD_TC_ISSUE_DATE": "30-Jun-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjczMg==&cwid=MTgxMg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1759",
            "STD_NAME": "Ankur Tripathi",
            "STD_FATHER_NAME": "Ganesh Chandra Tripathi",
            "STD_MOTHER_NAME": "Rita Tripathi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2772",
            "STD_TC_ISSUE_DATE": "03-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI0OQ==&cwid=MTgxNA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1771",
            "STD_NAME": "Pooja Pal",
            "STD_FATHER_NAME": "Ramraj Pal",
            "STD_MOTHER_NAME": "Parvati Pal",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2769",
            "STD_TC_ISSUE_DATE": "03-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI2MQ==&cwid=MTgxNg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1733",
            "STD_NAME": "Kunj Kradiya",
            "STD_FATHER_NAME": "Kamal  Kishor",
            "STD_MOTHER_NAME": "Vinod Kumari",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2770",
            "STD_TC_ISSUE_DATE": "03-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjIyMw==&cwid=MTgxOA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1819",
            "STD_NAME": "Priyanka  Baisla",
            "STD_FATHER_NAME": "Sunil Baisla",
            "STD_MOTHER_NAME": "Seema Baisla",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2776",
            "STD_TC_ISSUE_DATE": "07-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMwOQ==&cwid=MTgyMA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1493",
            "STD_NAME": "Suraj Singh",
            "STD_FATHER_NAME": "Dharam  Pal ",
            "STD_MOTHER_NAME": "Geeta ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2775",
            "STD_TC_ISSUE_DATE": "07-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk0NQ==&cwid=MTgyMg==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1801",
            "STD_NAME": "Dev Sharma",
            "STD_FATHER_NAME": "Mohan Sharma",
            "STD_MOTHER_NAME": "Tekwati ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2777",
            "STD_TC_ISSUE_DATE": "03-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI5MQ==&cwid=MTgyNA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1728",
            "STD_NAME": "Minki Kumari",
            "STD_FATHER_NAME": "Ram Babu Mahto",
            "STD_MOTHER_NAME": "Shakuntala Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2783",
            "STD_TC_ISSUE_DATE": "07-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjIxOA==&cwid=MTgyNg==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1751",
            "STD_NAME": "Naseeb Khan",
            "STD_FATHER_NAME": "Saffi Mohammad",
            "STD_MOTHER_NAME": "Meera Bano",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2781",
            "STD_TC_ISSUE_DATE": "07-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI0MQ==&cwid=MTgyOA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1889",
            "STD_NAME": "Shivam Kaul",
            "STD_FATHER_NAME": "Kundan Lal Sharma",
            "STD_MOTHER_NAME": "Nirmala Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2800",
            "STD_TC_ISSUE_DATE": "07-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM3OQ==&cwid=MTgzMA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/84",
            "STD_NAME": "Vineet Singh",
            "STD_FATHER_NAME": "Ramveer Singh",
            "STD_MOTHER_NAME": "Usha  Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2802",
            "STD_TC_ISSUE_DATE": "07-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTU4NQ==&cwid=MTgzMg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1708",
            "STD_NAME": "Rahul Paswan",
            "STD_FATHER_NAME": "Late  Chhote  Lal ",
            "STD_MOTHER_NAME": "Lal Pari  Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2779",
            "STD_TC_ISSUE_DATE": "08-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE5OA==&cwid=MTgzNA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1789",
            "STD_NAME": "Aparna Pandey",
            "STD_FATHER_NAME": "Rakesh Pandey",
            "STD_MOTHER_NAME": "Rukmini Pandey",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2794",
            "STD_TC_ISSUE_DATE": "08-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI3OQ==&cwid=MTgzNg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1791",
            "STD_NAME": "Priyanka  Dhiman",
            "STD_FATHER_NAME": "Davinder  Dhiman",
            "STD_MOTHER_NAME": "Gurjeet Kaur",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2798",
            "STD_TC_ISSUE_DATE": "08-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI4MQ==&cwid=MTgzOA==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1792",
            "STD_NAME": "Anjali Bhandari",
            "STD_FATHER_NAME": "Ranbir Bhandari",
            "STD_MOTHER_NAME": "Yashoda Bhandari",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2799",
            "STD_TC_ISSUE_DATE": "08-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI4Mg==&cwid=MTg0MA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1824",
            "STD_NAME": "Gaurav Kumar Jha",
            "STD_FATHER_NAME": "Satish Jha",
            "STD_MOTHER_NAME": "Sarita Jha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2805",
            "STD_TC_ISSUE_DATE": "08-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMxNA==&cwid=MTg0Mg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1779",
            "STD_NAME": "Deeksha Sharma",
            "STD_FATHER_NAME": "Rajesh  Kumar",
            "STD_MOTHER_NAME": "Meena Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2807",
            "STD_TC_ISSUE_DATE": "08-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI2OQ==&cwid=MTg0NA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1836",
            "STD_NAME": "Prakash Sharma",
            "STD_FATHER_NAME": "Rakesh Sharma",
            "STD_MOTHER_NAME": "Poonam Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2787",
            "STD_TC_ISSUE_DATE": "08-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMyNg==&cwid=MTg0Ng==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1762",
            "STD_NAME": "Pradeep Singh",
            "STD_FATHER_NAME": "Ram Pravesh Singh",
            "STD_MOTHER_NAME": "Geeta Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2785",
            "STD_TC_ISSUE_DATE": "08-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI1Mg==&cwid=MTg0OA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1564",
            "STD_NAME": "Mohamad Anas ",
            "STD_FATHER_NAME": "Fahim Ahmed",
            "STD_MOTHER_NAME": "Samer Fatima",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2790",
            "STD_TC_ISSUE_DATE": "08-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjAxNg==&cwid=MTg1MA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1833",
            "STD_NAME": "Maya ",
            "STD_FATHER_NAME": "Bhoodev Singh",
            "STD_MOTHER_NAME": "Shyamwati ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2792",
            "STD_TC_ISSUE_DATE": "08-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMyMw==&cwid=MTg1Mg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1726",
            "STD_NAME": "Madhumita Sarkar",
            "STD_FATHER_NAME": "Subir Sarkar",
            "STD_MOTHER_NAME": "Lipika Sarkar",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2789",
            "STD_TC_ISSUE_DATE": "08-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjIxNg==&cwid=MTg1NA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1886",
            "STD_NAME": "Ankit Gupta",
            "STD_FATHER_NAME": "Virender Kumar Gupta",
            "STD_MOTHER_NAME": "Reena Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2804",
            "STD_TC_ISSUE_DATE": "08-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM3Ng==&cwid=MTg1Ng==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1837",
            "STD_NAME": "Nitin Mishra",
            "STD_FATHER_NAME": "Virat Mishra",
            "STD_MOTHER_NAME": "Anju Mishra",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2812",
            "STD_TC_ISSUE_DATE": "08-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMyNw==&cwid=MTg1OA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1780",
            "STD_NAME": "Yogesh Goyal",
            "STD_FATHER_NAME": "Shyam Lal",
            "STD_MOTHER_NAME": "Manju Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2814",
            "STD_TC_ISSUE_DATE": "10-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI3MA==&cwid=MTg2MA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1838",
            "STD_NAME": "Tabbi Mehra",
            "STD_FATHER_NAME": "Anand Mehra",
            "STD_MOTHER_NAME": "Radha Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2816",
            "STD_TC_ISSUE_DATE": "11-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMyOA==&cwid=MTg2Mg==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1286",
            "STD_NAME": "Jasir ",
            "STD_FATHER_NAME": "Mohd. Imran ",
            "STD_MOTHER_NAME": "Saroj ",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2819",
            "STD_TC_ISSUE_DATE": "12-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTczMQ==&cwid=MTg2NA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/324",
            "STD_NAME": "Aryan ",
            "STD_FATHER_NAME": " Birender Kr Sharma",
            "STD_MOTHER_NAME": "Tulsi Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2820",
            "STD_TC_ISSUE_DATE": "13-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIy&cwid=MTg2Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2299",
            "STD_NAME": "Ashish Singh",
            "STD_FATHER_NAME": "Dharmendra Singh",
            "STD_MOTHER_NAME": "Manju Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2822",
            "STD_TC_ISSUE_DATE": "18-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjkzOA==&cwid=MTg2OA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1518",
            "STD_NAME": "Nakul Gupta",
            "STD_FATHER_NAME": "Subhash Gupta",
            "STD_MOTHER_NAME": "Suman Gupta",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2824",
            "STD_TC_ISSUE_DATE": "21-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk3MA==&cwid=MTg3MA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1857",
            "STD_NAME": "Prabhat ",
            "STD_FATHER_NAME": " J N  Kaul",
            "STD_MOTHER_NAME": "Sonia ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2826",
            "STD_TC_ISSUE_DATE": "21-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM0Nw==&cwid=MTg3Mg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1930",
            "STD_NAME": "Mazid Seif Mazumder",
            "STD_FATHER_NAME": "Fazleh Borkat Manik Shah Mazumder",
            "STD_MOTHER_NAME": "Rajia  Sultana Barbhuiya",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "2838",
            "STD_TC_ISSUE_DATE": "22-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQyMA==&cwid=MTg3NA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1761",
            "STD_NAME": "Pawan Kumar",
            "STD_FATHER_NAME": "Bijendra Kumar",
            "STD_MOTHER_NAME": "Poonam ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2828",
            "STD_TC_ISSUE_DATE": "25-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI1MQ==&cwid=MTg3Ng==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1731",
            "STD_NAME": "Rahul Prasad",
            "STD_FATHER_NAME": "Banarashi Lal",
            "STD_MOTHER_NAME": "Chinta Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2830",
            "STD_TC_ISSUE_DATE": "25-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjIyMQ==&cwid=MTg3OA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1822",
            "STD_NAME": "Laxmi Sharma",
            "STD_FATHER_NAME": "Durga Prasad Sharma",
            "STD_MOTHER_NAME": "Suman Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2839",
            "STD_TC_ISSUE_DATE": "25-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMxMg==&cwid=MTg4MA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1790",
            "STD_NAME": "Sachin Verma",
            "STD_FATHER_NAME": "Puran Singh",
            "STD_MOTHER_NAME": "Omvati Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2833",
            "STD_TC_ISSUE_DATE": "25-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI4MA==&cwid=MTg4Mg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1818",
            "STD_NAME": "Rahul Kumar",
            "STD_FATHER_NAME": "Sunil Kumar",
            "STD_MOTHER_NAME": "Saroj Kumari",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2835",
            "STD_TC_ISSUE_DATE": "25-Jul-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMwOA==&cwid=MTg4NA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1491",
            "STD_NAME": "Sumit Ranjan",
            "STD_FATHER_NAME": "Kamal Kishor ",
            "STD_MOTHER_NAME": "Kanchan ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2841",
            "STD_TC_ISSUE_DATE": "01-Aug-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk0Mw==&cwid=MTg4Ng==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1541",
            "STD_NAME": "Anirudha Mallick",
            "STD_FATHER_NAME": "Debjit Mallick",
            "STD_MOTHER_NAME": "Renuka Mallick",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2842",
            "STD_TC_ISSUE_DATE": "01-Aug-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk5Mw==&cwid=MTg4OA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1815",
            "STD_NAME": "Yogesh Kumar",
            "STD_FATHER_NAME": "Shatrughan ",
            "STD_MOTHER_NAME": "Kamlesh Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2843",
            "STD_TC_ISSUE_DATE": "01-Aug-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMwNQ==&cwid=MTg5MA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1815",
            "STD_NAME": "Yogesh Kumar",
            "STD_FATHER_NAME": "Shatrughan ",
            "STD_MOTHER_NAME": "Kamlesh Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2843",
            "STD_TC_ISSUE_DATE": "01-Aug-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMwNQ==&cwid=MTg5Mw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1815",
            "STD_NAME": "Yogesh Kumar",
            "STD_FATHER_NAME": "Shatrughan ",
            "STD_MOTHER_NAME": "Kamlesh Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2843",
            "STD_TC_ISSUE_DATE": "01-Aug-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMwNQ==&cwid=MTg5NQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1815",
            "STD_NAME": "Yogesh Kumar",
            "STD_FATHER_NAME": "Shatrughan ",
            "STD_MOTHER_NAME": "Kamlesh Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2843",
            "STD_TC_ISSUE_DATE": "01-Aug-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMwNQ==&cwid=MTg5Nw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1815",
            "STD_NAME": "Yogesh Kumar",
            "STD_FATHER_NAME": "Shatrughan ",
            "STD_MOTHER_NAME": "Kamlesh Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2843",
            "STD_TC_ISSUE_DATE": "01-Aug-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMwNQ==&cwid=MTg5OQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1851",
            "STD_NAME": "Ahshan Jeelani",
            "STD_FATHER_NAME": "Md.Mohiuddin ",
            "STD_MOTHER_NAME": "Ajmeri Khatoon",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2844",
            "STD_TC_ISSUE_DATE": "02-Aug-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM0MQ==&cwid=MTkwMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1496",
            "STD_NAME": "Bhuvan Khatri",
            "STD_FATHER_NAME": "Pitamber  Khatri",
            "STD_MOTHER_NAME": "Bharti Khatri",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2847",
            "STD_TC_ISSUE_DATE": "05-Aug-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTk0OA==&cwid=MTkwMw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2316",
            "STD_NAME": "Rahul Kumar",
            "STD_FATHER_NAME": "Rakesh Kumar Ravi",
            "STD_MOTHER_NAME": "Reeta Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2846",
            "STD_TC_ISSUE_DATE": "05-Aug-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk1NQ==&cwid=MTkwNQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1814",
            "STD_NAME": "Kshitij Sagar",
            "STD_FATHER_NAME": "Anant Sagar",
            "STD_MOTHER_NAME": "Sunita Sagar",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2850",
            "STD_TC_ISSUE_DATE": "19-Aug-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMwNA==&cwid=MTkwNw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1858",
            "STD_NAME": "Nitin Pant",
            "STD_FATHER_NAME": " J N  Kaul",
            "STD_MOTHER_NAME": "Devki Pant",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2852",
            "STD_TC_ISSUE_DATE": "25-Aug-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM0OA==&cwid=MTkwOQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1760",
            "STD_NAME": "Abhishek Sarkar",
            "STD_FATHER_NAME": "Vinay Sarkar",
            "STD_MOTHER_NAME": "Meera Sarkar",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2854",
            "STD_TC_ISSUE_DATE": "31-Aug-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI1MA==&cwid=MTkxMQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1766",
            "STD_NAME": "Jaswant Singh",
            "STD_FATHER_NAME": "Jai Kishore Singh",
            "STD_MOTHER_NAME": "Pinki Singh Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2858",
            "STD_TC_ISSUE_DATE": "08-Sep-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI1Ng==&cwid=MTkxMw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/679",
            "STD_NAME": "Preet Awana",
            "STD_FATHER_NAME": "Manoj Awana",
            "STD_MOTHER_NAME": "Sunita Awana",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2857",
            "STD_TC_ISSUE_DATE": "08-Sep-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzg1&cwid=MTkxNQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/64",
            "STD_NAME": "Baldev Pathak",
            "STD_FATHER_NAME": "Purshottam Pathak",
            "STD_MOTHER_NAME": "Shashi Devi Pathak",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2860",
            "STD_TC_ISSUE_DATE": "06-Oct-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTU2NQ==&cwid=MTkxNw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/590",
            "STD_NAME": "Manish ",
            "STD_FATHER_NAME": "Late Balkishan Sharma",
            "STD_MOTHER_NAME": "Late Savita Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2865",
            "STD_TC_ISSUE_DATE": "06-Nov-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc3&cwid=MTkxOQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1812",
            "STD_NAME": "Mukul Kumar",
            "STD_FATHER_NAME": "Krishan Pal Sharma",
            "STD_MOTHER_NAME": "Saroj Bala ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2867",
            "STD_TC_ISSUE_DATE": "27-Nov-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMwMg==&cwid=MTkyMQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1035",
            "STD_NAME": "Vimal Singh Bhati",
            "STD_FATHER_NAME": " Dhani Ram ",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2869",
            "STD_TC_ISSUE_DATE": "27-Dec-2017",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDQ4&cwid=MTkyMw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2370",
            "STD_NAME": "Krishna Panchal",
            "STD_FATHER_NAME": "Omprakash ",
            "STD_MOTHER_NAME": "Priya ",
            "STD_LAST_CLASS": "LKG",
            "STD_TCNO": "2872",
            "STD_TC_ISSUE_DATE": "18-Jan-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzAwOQ==&cwid=MTkyNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1758",
            "STD_NAME": "Bharti Sharma",
            "STD_FATHER_NAME": "D R  Sharma",
            "STD_MOTHER_NAME": "Seema Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2875",
            "STD_TC_ISSUE_DATE": "08-Feb-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI0OA==&cwid=MTkyNw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/197",
            "STD_NAME": "Rahul Chauhan",
            "STD_FATHER_NAME": "Subhash  Chand",
            "STD_MOTHER_NAME": "Keshvati Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2877",
            "STD_TC_ISSUE_DATE": "12-Feb-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjI1&cwid=MTkyOQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/514",
            "STD_NAME": "Manas Jha",
            "STD_FATHER_NAME": "Vinay  Chandra Jha",
            "STD_MOTHER_NAME": "Saraswati Jha",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "2879",
            "STD_TC_ISSUE_DATE": "09-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzY=&cwid=MTkzMQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/14",
            "STD_NAME": "Richa Choudhary",
            "STD_FATHER_NAME": "Kishore  Kumar Choudhary",
            "STD_MOTHER_NAME": "Rina Choudhary",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "2882",
            "STD_TC_ISSUE_DATE": "09-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ0NQ==&cwid=MTkzNA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/53",
            "STD_NAME": "Mohit Jangid",
            "STD_FATHER_NAME": "Hariom Jangid",
            "STD_MOTHER_NAME": "Santosh ",
            "STD_LAST_CLASS": "UKG",
            "STD_TCNO": "2884",
            "STD_TC_ISSUE_DATE": "09-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjcxOA==&cwid=MTkzNg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2231",
            "STD_NAME": "Tanishq Soni",
            "STD_FATHER_NAME": "Laxmikant Soni",
            "STD_MOTHER_NAME": "Sangeeta Soni",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "2886",
            "STD_TC_ISSUE_DATE": "09-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg3MA==&cwid=MTkzOA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1701",
            "STD_NAME": "Poorva Sharma",
            "STD_FATHER_NAME": "Hariom  Sharma",
            "STD_MOTHER_NAME": "Late Shobha Sharma",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "2888",
            "STD_TC_ISSUE_DATE": "09-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE5MQ==&cwid=MTk0MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/77",
            "STD_NAME": "Mahip Siradhana",
            "STD_FATHER_NAME": "Rajesh ",
            "STD_MOTHER_NAME": "Nirmala ",
            "STD_LAST_CLASS": "LKG",
            "STD_TCNO": "2892",
            "STD_TC_ISSUE_DATE": "09-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc0Mg==&cwid=MTk0Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/79",
            "STD_NAME": "Lakshay ",
            "STD_FATHER_NAME": "Rajesh ",
            "STD_MOTHER_NAME": "Nirmala ",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2890",
            "STD_TC_ISSUE_DATE": "09-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc0NA==&cwid=MTk0NA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/24",
            "STD_NAME": "Jayant ",
            "STD_FATHER_NAME": "Mahaveer Singh",
            "STD_MOTHER_NAME": "Rashmi Singh",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "2894",
            "STD_TC_ISSUE_DATE": "10-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTUyNQ==&cwid=MTk0Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1923",
            "STD_NAME": "Robin ",
            "STD_FATHER_NAME": "Praveen Sardana",
            "STD_MOTHER_NAME": "Kanta ",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "2896",
            "STD_TC_ISSUE_DATE": "10-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQxMw==&cwid=MTk0OA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1457",
            "STD_NAME": "Hasvi Singh",
            "STD_FATHER_NAME": "Satyveer ",
            "STD_MOTHER_NAME": "Abhilasha ",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "2898",
            "STD_TC_ISSUE_DATE": "10-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkwOQ==&cwid=MTk1MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/899",
            "STD_NAME": "Bhumika Jha",
            "STD_FATHER_NAME": "Vinay Chandra Jha",
            "STD_MOTHER_NAME": "Saraswati Jha",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2900",
            "STD_TC_ISSUE_DATE": "10-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NA==&cwid=MTk1Mg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2233",
            "STD_NAME": "Vaibhav Lawrence Pinto",
            "STD_FATHER_NAME": "Late  Suresh Pinto",
            "STD_MOTHER_NAME": "Monika Pinto",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "2902",
            "STD_TC_ISSUE_DATE": "10-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg3Mg==&cwid=MTk1NA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2167",
            "STD_NAME": "Arbab Hussain",
            "STD_FATHER_NAME": "Sartaj Ahmad",
            "STD_MOTHER_NAME": "Nigar Siddique",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2912",
            "STD_TC_ISSUE_DATE": "11-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjgwNg==&cwid=MTk1Ng==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/22",
            "STD_NAME": "Depesh Kamboj",
            "STD_FATHER_NAME": "Lekhraj ",
            "STD_MOTHER_NAME": "Sheela Devi",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "2910",
            "STD_TC_ISSUE_DATE": "11-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjEzMQ==&cwid=MTk1OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1688",
            "STD_NAME": "Pallavi Sarova",
            "STD_FATHER_NAME": "Naresh  Kumar",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "2908",
            "STD_TC_ISSUE_DATE": "11-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE3OA==&cwid=MTk2MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/29",
            "STD_NAME": "Somya ",
            "STD_FATHER_NAME": "Ajay  Kumar",
            "STD_MOTHER_NAME": "Minti Devi",
            "STD_LAST_CLASS": "LKG",
            "STD_TCNO": "2906",
            "STD_TC_ISSUE_DATE": "11-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY5NA==&cwid=MTk2Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/69",
            "STD_NAME": "Utsav Pathak",
            "STD_FATHER_NAME": "Arun Pathak",
            "STD_MOTHER_NAME": "Mamta Pathak",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2904",
            "STD_TC_ISSUE_DATE": "11-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjczNA==&cwid=MTk2NA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2186",
            "STD_NAME": "Kunal ",
            "STD_FATHER_NAME": "Keshav Prasad",
            "STD_MOTHER_NAME": "Shashi Bala",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2914",
            "STD_TC_ISSUE_DATE": "12-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjgyNQ==&cwid=MTk2Ng==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/11",
            "STD_NAME": "Khushboo Yadav",
            "STD_FATHER_NAME": "Narendra Singh Yadav",
            "STD_MOTHER_NAME": "Dharamwati ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2916",
            "STD_TC_ISSUE_DATE": "18-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY3Ng==&cwid=MTk2OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2230",
            "STD_NAME": "Nikhil ",
            "STD_FATHER_NAME": "Sunil Kumar",
            "STD_MOTHER_NAME": "Parmila Devi",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "2918",
            "STD_TC_ISSUE_DATE": "19-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg2OQ==&cwid=MTk3MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2229",
            "STD_NAME": "Jyoti ",
            "STD_FATHER_NAME": "Sunil Kumar",
            "STD_MOTHER_NAME": "Parmila Devi",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "2920",
            "STD_TC_ISSUE_DATE": "20-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg2OA==&cwid=MTk3Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/98",
            "STD_NAME": "Harsh Vardhan",
            "STD_FATHER_NAME": "Virender Singh Bittu",
            "STD_MOTHER_NAME": "Ritu ",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "2922",
            "STD_TC_ISSUE_DATE": "20-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc2Mw==&cwid=MTk3NA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1982",
            "STD_NAME": "Vartika Chaudhary",
            "STD_FATHER_NAME": "Samarpal Chaudhary",
            "STD_MOTHER_NAME": "Princy Chaudhary",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "2924",
            "STD_TC_ISSUE_DATE": "20-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjUxOQ==&cwid=MTk3Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2183",
            "STD_NAME": "Raju ",
            "STD_FATHER_NAME": "Ravinder Pal",
            "STD_MOTHER_NAME": "Rajwati ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2926",
            "STD_TC_ISSUE_DATE": "23-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjgyMg==&cwid=MTk3OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/615",
            "STD_NAME": "Sumit Chauhan",
            "STD_FATHER_NAME": "Jagresh Chauhan",
            "STD_MOTHER_NAME": "Suman Chauhan",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "2928",
            "STD_TC_ISSUE_DATE": "23-Apr-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODY=&cwid=MTk4MA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2262",
            "STD_NAME": "Fara Khan",
            "STD_FATHER_NAME": "Firoz Khan",
            "STD_MOTHER_NAME": "Mubina ",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "2930",
            "STD_TC_ISSUE_DATE": "01-May-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjkwMQ==&cwid=MTk4Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2138",
            "STD_NAME": "Krishna Singh Bhandari",
            "STD_FATHER_NAME": "Jagmohan  Singh ",
            "STD_MOTHER_NAME": "Sangeeta Devi",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "2934",
            "STD_TC_ISSUE_DATE": "01-May-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc3Nw==&cwid=MTk4NA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/157",
            "STD_NAME": "Ritika ",
            "STD_FATHER_NAME": "Jagmohan Singh",
            "STD_MOTHER_NAME": "Sangeeta ",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2931",
            "STD_TC_ISSUE_DATE": "01-May-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM3NQ==&cwid=MTk4Nw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1661",
            "STD_NAME": "Aanya Sharma",
            "STD_FATHER_NAME": "Naresh  Sharma",
            "STD_MOTHER_NAME": "Seema Sharma",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "2936",
            "STD_TC_ISSUE_DATE": "10-May-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE1MQ==&cwid=MTk4OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1902",
            "STD_NAME": "Ranjay Kumar",
            "STD_FATHER_NAME": "Kamlesh Gupta",
            "STD_MOTHER_NAME": "Kushmila Devi",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2940",
            "STD_TC_ISSUE_DATE": "14-May-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM5Mg==&cwid=MTk5MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/44",
            "STD_NAME": "Piyush Kumar",
            "STD_FATHER_NAME": "Bishan Kumar",
            "STD_MOTHER_NAME": "Raj Bala",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2942",
            "STD_TC_ISSUE_DATE": "18-May-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjcwOQ==&cwid=MTk5Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1998",
            "STD_NAME": "Dev Sharma",
            "STD_FATHER_NAME": "Munish Sharma",
            "STD_MOTHER_NAME": "Aarti Sharma",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "2944",
            "STD_TC_ISSUE_DATE": "18-May-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjUzNQ==&cwid=MTk5NQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2395",
            "STD_NAME": "Tezi ",
            "STD_FATHER_NAME": "Naval Kishore",
            "STD_MOTHER_NAME": "Savita ",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "2946",
            "STD_TC_ISSUE_DATE": "18-May-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzAzNA==&cwid=MTk5Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2137",
            "STD_NAME": "Eklavya Kumar Jha",
            "STD_FATHER_NAME": "Vipin Kumar Jha",
            "STD_MOTHER_NAME": "Guriya Jha",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "2939",
            "STD_TC_ISSUE_DATE": "18-May-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc3Ng==&cwid=MTk5OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/72",
            "STD_NAME": "Devesh Sharma",
            "STD_FATHER_NAME": "Tejveer Sharma",
            "STD_MOTHER_NAME": "Rajkumari ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "2951",
            "STD_TC_ISSUE_DATE": "19-May-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjczNw==&cwid=MjAwMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2392",
            "STD_NAME": "Ankit Gupta",
            "STD_FATHER_NAME": "Virender Kumar Gupta",
            "STD_MOTHER_NAME": "Reena Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2949",
            "STD_TC_ISSUE_DATE": "19-May-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzAzMQ==&cwid=MjAwMw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2344",
            "STD_NAME": "Sachin Adhikari",
            "STD_FATHER_NAME": "Nitai Adhikari",
            "STD_MOTHER_NAME": "Barnaly Adhikari",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2947",
            "STD_TC_ISSUE_DATE": "19-May-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk4Mw==&cwid=MjAwNQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2342",
            "STD_NAME": "Suraj Dabas",
            "STD_FATHER_NAME": "Motilal ",
            "STD_MOTHER_NAME": "Kamlesh ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2956",
            "STD_TC_ISSUE_DATE": "02-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk4MQ==&cwid=MjAwNw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/452",
            "STD_NAME": "Akash Sharma",
            "STD_FATHER_NAME": "Praveen Sharma",
            "STD_MOTHER_NAME": "Poonam Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2958",
            "STD_TC_ISSUE_DATE": "06-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ0&cwid=MjAwOQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2123",
            "STD_NAME": "Priya Yadav",
            "STD_FATHER_NAME": "Rajesh Yadav",
            "STD_MOTHER_NAME": "Kamlesh Yadav",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2960",
            "STD_TC_ISSUE_DATE": "06-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY2MA==&cwid=MjAxMQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1995",
            "STD_NAME": "Ankit Maurya",
            "STD_FATHER_NAME": "Babu Lal Maurya",
            "STD_MOTHER_NAME": "Urmila ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "2962",
            "STD_TC_ISSUE_DATE": "07-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjUzMg==&cwid=MjAxMw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2329",
            "STD_NAME": "Rahul Kumar",
            "STD_FATHER_NAME": "Manoj Kumar",
            "STD_MOTHER_NAME": "Savita Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "2953",
            "STD_TC_ISSUE_DATE": "26-May-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk2OA==&cwid=MjAxNQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2077",
            "STD_NAME": "Yatish Kumar",
            "STD_FATHER_NAME": "Rakesh Kumar",
            "STD_MOTHER_NAME": "Sunita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2967",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYxNA==&cwid=MjAxNw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2009",
            "STD_NAME": "Brijesh Sharma",
            "STD_FATHER_NAME": "Laxman Swaroop Sharma",
            "STD_MOTHER_NAME": "Nita Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2969",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU0Ng==&cwid=MjAxOQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2020",
            "STD_NAME": "Kshitiz ",
            "STD_FATHER_NAME": "Krishan  Kumar Kaushik",
            "STD_MOTHER_NAME": "Anupama ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2971",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU1Nw==&cwid=MjAyMQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2066",
            "STD_NAME": "Vishal Vats",
            "STD_FATHER_NAME": "Shiv Hari ",
            "STD_MOTHER_NAME": "Lalita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2973",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYwMw==&cwid=MjAyMw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2072",
            "STD_NAME": "Tarun Singh",
            "STD_FATHER_NAME": "Gyanendra Singh",
            "STD_MOTHER_NAME": "Archana Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2975",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYwOQ==&cwid=MjAyNQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2006",
            "STD_NAME": "Ravi  Shankar",
            "STD_FATHER_NAME": "Devender Bhagat",
            "STD_MOTHER_NAME": "Anpurna Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2977",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU0Mw==&cwid=MjAyNw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2090",
            "STD_NAME": "Om  Singh",
            "STD_FATHER_NAME": "Sandeep Kumar Singh",
            "STD_MOTHER_NAME": "Archana Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2979",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYyNw==&cwid=MjAyOQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2017",
            "STD_NAME": "Rishav Gusain",
            "STD_FATHER_NAME": "Bhupender Singh",
            "STD_MOTHER_NAME": "Rameshwari Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2981",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU1NA==&cwid=MjAzMQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1768",
            "STD_NAME": "Vineet Rana",
            "STD_FATHER_NAME": "Surender Singh",
            "STD_MOTHER_NAME": "Suman ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2983",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjI1OA==&cwid=MjAzMw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2041",
            "STD_NAME": "Gaurav Tripathi",
            "STD_FATHER_NAME": "Vinod Tripathi",
            "STD_MOTHER_NAME": "Sandhya Tripathi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2985",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU3OA==&cwid=MjAzNQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2127",
            "STD_NAME": "Kartikeya Kaul",
            "STD_FATHER_NAME": "Sudhakar Kaul",
            "STD_MOTHER_NAME": "Shrini Kaul",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3026",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY2NA==&cwid=MjAzNw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2089",
            "STD_NAME": "Anand Baisla",
            "STD_FATHER_NAME": "Sanjay Baisla",
            "STD_MOTHER_NAME": "Mukesh Baisla",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3029",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYyNg==&cwid=MjAzOQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2015",
            "STD_NAME": "Saurabh Bhadana",
            "STD_FATHER_NAME": "Lt  Rakesh Kumar",
            "STD_MOTHER_NAME": "Poonam ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3031",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU1Mg==&cwid=MjA0MQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2075",
            "STD_NAME": "Parul Chaprana",
            "STD_FATHER_NAME": "Gyander Chaprana",
            "STD_MOTHER_NAME": "Sunita Chaprana",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3033",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYxMg==&cwid=MjA0Mw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2108",
            "STD_NAME": "Isha ",
            "STD_FATHER_NAME": "Pritam Singh",
            "STD_MOTHER_NAME": "Rajesh Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3035",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY0NQ==&cwid=MjA0NQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2084",
            "STD_NAME": "Firdos ",
            "STD_FATHER_NAME": "Mohd   Muslim ",
            "STD_MOTHER_NAME": "Tabassum ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3037",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYyMQ==&cwid=MjA0Nw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1746",
            "STD_NAME": "Pinky Kumari",
            "STD_FATHER_NAME": "Vinod Kumar",
            "STD_MOTHER_NAME": "Ombati ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3039",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjIzNg==&cwid=MjA0OQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2038",
            "STD_NAME": "Taniya Chaudhary",
            "STD_FATHER_NAME": "Jagdish Chaudhary",
            "STD_MOTHER_NAME": "Kamlesh ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2965",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU3NQ==&cwid=MjA1MQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2065",
            "STD_NAME": "Akriti Pandey",
            "STD_FATHER_NAME": "Mahendra Pratap Pandey",
            "STD_MOTHER_NAME": "Bintoo Pandey",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2986",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYwMg==&cwid=MjA1Mw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2011",
            "STD_NAME": "Deepali Bansal",
            "STD_FATHER_NAME": "Vijay Bansal",
            "STD_MOTHER_NAME": "Manju Bansal",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2988",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU0OA==&cwid=MjA1NQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2018",
            "STD_NAME": "Pradeep Singh  Chilwal",
            "STD_FATHER_NAME": "Mohan Singh Chilwal",
            "STD_MOTHER_NAME": "Vimla    Chilwal",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2991",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU1NQ==&cwid=MjA1Nw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2053",
            "STD_NAME": "Vidushi Mehndiratta",
            "STD_FATHER_NAME": "Jitender  Mehndiratta",
            "STD_MOTHER_NAME": "Pooja Mehndiratta",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2993",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU5MA==&cwid=MjA1OQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2078",
            "STD_NAME": "Shahin Akhter",
            "STD_FATHER_NAME": "Md  Naimuddin Jeelani",
            "STD_MOTHER_NAME": "Kuraisha Khatoon",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2995",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYxNQ==&cwid=MjA2MQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1906",
            "STD_NAME": "Anubhav Anand",
            "STD_FATHER_NAME": "Kanhaiya Kumar Jha",
            "STD_MOTHER_NAME": "Ranju Jha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2997",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM5Ng==&cwid=MjA2Mw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2001",
            "STD_NAME": "Niketa   Chauhan",
            "STD_FATHER_NAME": "Khoob  Singh Chauhan",
            "STD_MOTHER_NAME": "Savita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3000",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjUzOA==&cwid=MjA2NQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2060",
            "STD_NAME": "Bhawna Chauhan",
            "STD_FATHER_NAME": "Avadhesh Chauhan",
            "STD_MOTHER_NAME": "Asha Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3002",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU5Nw==&cwid=MjA2Nw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2050",
            "STD_NAME": "Hari Om Sharan",
            "STD_FATHER_NAME": "Rajesh Kumar Rai",
            "STD_MOTHER_NAME": "Rita Rai",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3013",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU4Nw==&cwid=MjA2OQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2083",
            "STD_NAME": "Ankur Kumar Mishra",
            "STD_FATHER_NAME": "Sanjay Kumar Mishra",
            "STD_MOTHER_NAME": "Bharti Mishra",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3016",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYyMA==&cwid=MjA3MQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2061",
            "STD_NAME": "Anujeet Maurya",
            "STD_FATHER_NAME": "Hanuman Prasad Maurya",
            "STD_MOTHER_NAME": "Gayatri  Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3018",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU5OA==&cwid=MjA3Mw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2087",
            "STD_NAME": "Govind Kumar",
            "STD_FATHER_NAME": "Madan Mishra",
            "STD_MOTHER_NAME": "Lalita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3020",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYyNA==&cwid=MjA3NQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2104",
            "STD_NAME": "Kundan ",
            "STD_FATHER_NAME": "Madan Mandal",
            "STD_MOTHER_NAME": "Reena Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3023",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY0MQ==&cwid=MjA3Nw==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2069",
            "STD_NAME": "Nidhi Vashishth",
            "STD_FATHER_NAME": "Satish  Narain",
            "STD_MOTHER_NAME": "Madhuri ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "2966",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYwNg==&cwid=MjA3OQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2003",
            "STD_NAME": "Vandana ",
            "STD_FATHER_NAME": "Devi Singh",
            "STD_MOTHER_NAME": "Kusum ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3004",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU0MA==&cwid=MjA4MQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2079",
            "STD_NAME": "Yash Mishra",
            "STD_FATHER_NAME": "  Anil   Mishra",
            "STD_MOTHER_NAME": "Sunita Mishra",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3006",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYxNg==&cwid=MjA4Mw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2058",
            "STD_NAME": "Ojasvi Siwach",
            "STD_FATHER_NAME": "Ajit Singh",
            "STD_MOTHER_NAME": "Anita  Singh Siwach",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3008",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU5NQ==&cwid=MjA4NQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2106",
            "STD_NAME": "Rachita ",
            "STD_FATHER_NAME": "Arjun Prasad",
            "STD_MOTHER_NAME": "Geeta ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3010",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY0Mw==&cwid=MjA4Nw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2036",
            "STD_NAME": "Yash Sharma",
            "STD_FATHER_NAME": "Sheetal Sharma",
            "STD_MOTHER_NAME": "Preeti Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3012",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU3Mw==&cwid=MjA4OQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2055",
            "STD_NAME": "Jyoti ",
            "STD_FATHER_NAME": "Satpal Goswami",
            "STD_MOTHER_NAME": "Rajesh ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3021",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU5Mg==&cwid=MjA5MQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/334",
            "STD_NAME": "Harshika Vats",
            "STD_FATHER_NAME": "Shiv Hari",
            "STD_MOTHER_NAME": "Lalita Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3041",
            "STD_TC_ISSUE_DATE": "16-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU3&cwid=MjA5Mw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1974",
            "STD_NAME": "Mangal Bharat",
            "STD_FATHER_NAME": "Vishwanath Tiwari",
            "STD_MOTHER_NAME": "Neetu Tiwari",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3044",
            "STD_TC_ISSUE_DATE": "21-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjUxMQ==&cwid=MjA5NQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/327",
            "STD_NAME": "Preet Kaur",
            "STD_FATHER_NAME": "Jaswant Singh",
            "STD_MOTHER_NAME": "Soni Singh",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3046",
            "STD_TC_ISSUE_DATE": "21-Jun-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY4&cwid=MjA5Nw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/297",
            "STD_NAME": "Jai Shree ",
            "STD_FATHER_NAME": "Vinay Chandra Jha",
            "STD_MOTHER_NAME": "Saraswati Jha",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3051",
            "STD_TC_ISSUE_DATE": "03-Jul-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYw&cwid=MjA5OQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/89",
            "STD_NAME": "Saubhagya Grover",
            "STD_FATHER_NAME": "Rajinder Grover",
            "STD_MOTHER_NAME": "Neeru Grover",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3057",
            "STD_TC_ISSUE_DATE": "09-Jul-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc1NA==&cwid=MjEwMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/411",
            "STD_NAME": "Aastha Sharma",
            "STD_FATHER_NAME": "Rajesh Kumar ",
            "STD_MOTHER_NAME": "Meena Sharma",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3055",
            "STD_TC_ISSUE_DATE": "09-Jul-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjA4&cwid=MjEwMw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1365",
            "STD_NAME": "Aman Kumar Gupta",
            "STD_FATHER_NAME": "Suresh Kumar Gupta",
            "STD_MOTHER_NAME": "Indu Gupta",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3059",
            "STD_TC_ISSUE_DATE": "09-Jul-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTgxNw==&cwid=MjEwNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2349",
            "STD_NAME": "Deepak ",
            "STD_FATHER_NAME": "Vijay Vishwakarma",
            "STD_MOTHER_NAME": "Mansa Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "3062",
            "STD_TC_ISSUE_DATE": "10-Jul-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk4OA==&cwid=MjEwNw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2361",
            "STD_NAME": "Vikas Jha",
            "STD_FATHER_NAME": "Phool Kumar Jha",
            "STD_MOTHER_NAME": "Poonam Jha",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "3064",
            "STD_TC_ISSUE_DATE": "12-Jul-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzAwMA==&cwid=MjEwOQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1899",
            "STD_NAME": "Vishwajeet Dixit",
            "STD_FATHER_NAME": "Subedar Dixit",
            "STD_MOTHER_NAME": "Nisha Dixit",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3067",
            "STD_TC_ISSUE_DATE": "20-Jul-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM4OQ==&cwid=MjExMQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1884",
            "STD_NAME": "Aditi ",
            "STD_FATHER_NAME": "Rajkumar ",
            "STD_MOTHER_NAME": "Urmila ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3070",
            "STD_TC_ISSUE_DATE": "20-Jul-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM3NA==&cwid=MjExMw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/270",
            "STD_NAME": "Yash Shriavstava",
            "STD_FATHER_NAME": "Anant Shankar Shrivastava",
            "STD_MOTHER_NAME": "Shwetima Srivastava",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3071",
            "STD_TC_ISSUE_DATE": "23-Jul-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQy&cwid=MjExNQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/479",
            "STD_NAME": "Tamanna ",
            "STD_FATHER_NAME": "Amarjeet  Singh",
            "STD_MOTHER_NAME": "Kamlesh ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3072",
            "STD_TC_ISSUE_DATE": "23-Jul-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjAy&cwid=MjExNw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2032",
            "STD_NAME": "Rahul Chaudhary",
            "STD_FATHER_NAME": "B R  Chaudhary",
            "STD_MOTHER_NAME": "Poonam Chaudhary",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3076",
            "STD_TC_ISSUE_DATE": "31-Jul-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU2OQ==&cwid=MjExOQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1968",
            "STD_NAME": "Aarav Ujjinwal",
            "STD_FATHER_NAME": "Rajesh Kumar",
            "STD_MOTHER_NAME": "Teena ",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "3078",
            "STD_TC_ISSUE_DATE": "09-Aug-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjUwNQ==&cwid=MjEyMQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2057",
            "STD_NAME": "Sagar Singh",
            "STD_FATHER_NAME": "Bhogender Singh",
            "STD_MOTHER_NAME": "Sunita Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3080",
            "STD_TC_ISSUE_DATE": "10-Aug-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU5NA==&cwid=MjEyMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/29",
            "STD_NAME": "Vikash Chauhan",
            "STD_FATHER_NAME": "Avdhesh Chauhan",
            "STD_MOTHER_NAME": "Asha Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3094",
            "STD_TC_ISSUE_DATE": "20-Nov-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ2MA==&cwid=MjEyNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/646",
            "STD_NAME": "Madhulika ",
            "STD_FATHER_NAME": "J.N. Kaul",
            "STD_MOTHER_NAME": "Savita Mohanty",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3085",
            "STD_TC_ISSUE_DATE": "06-Sep-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjIx&cwid=MjEyNw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2142",
            "STD_NAME": "Nandeshwar Yadav",
            "STD_FATHER_NAME": "Rajesh Kumar Yadav",
            "STD_MOTHER_NAME": "Lata Yadav",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3086",
            "STD_TC_ISSUE_DATE": "06-Sep-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc4MQ==&cwid=MjEyOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1001",
            "STD_NAME": "Vishal Singh",
            "STD_FATHER_NAME": "Karamjeet Singh",
            "STD_MOTHER_NAME": "Paramjeet Kaur",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3089",
            "STD_TC_ISSUE_DATE": "04-Oct-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE3&cwid=MjEzMQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1944",
            "STD_NAME": "Paras ",
            "STD_FATHER_NAME": "Lokesh Nagar",
            "STD_MOTHER_NAME": "Munesh Kumari",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3091",
            "STD_TC_ISSUE_DATE": "16-Oct-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ4MQ==&cwid=MjEzMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1976",
            "STD_NAME": "Shyam Narayan Gupta",
            "STD_FATHER_NAME": "Soman Gupta",
            "STD_MOTHER_NAME": "Kalawati Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3093",
            "STD_TC_ISSUE_DATE": "03-Nov-2018",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjUxMw==&cwid=MjEzNQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/45",
            "STD_NAME": "Md. Anaullah ",
            "STD_FATHER_NAME": "Md.Rustam Ali",
            "STD_MOTHER_NAME": "Sitara  Khatun",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "3100",
            "STD_TC_ISSUE_DATE": "27-Mar-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjcxMA==&cwid=MjEzOA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2225",
            "STD_NAME": "Arunima Nair",
            "STD_FATHER_NAME": "Girijavallabhan.N ",
            "STD_MOTHER_NAME": "Rajani T.V. ",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3110",
            "STD_TC_ISSUE_DATE": "05-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg2NA==&cwid=MjE0MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/42",
            "STD_NAME": "Khanak ",
            "STD_FATHER_NAME": "Deepak Kumar Tikiya",
            "STD_MOTHER_NAME": "Bhawna ",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "3112",
            "STD_TC_ISSUE_DATE": "05-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTU0Mw==&cwid=MjE0Mg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2226",
            "STD_NAME": "Aditya  Nair",
            "STD_FATHER_NAME": "Girijavallabhan.N ",
            "STD_MOTHER_NAME": "Rajani  T.V. ",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "3102",
            "STD_TC_ISSUE_DATE": "05-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg2NQ==&cwid=MjE0NA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1948",
            "STD_NAME": "S.S. Laksha ",
            "STD_FATHER_NAME": "S.S. Suresh ",
            "STD_MOTHER_NAME": "V. M.  Vijayalakshmi ",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3107",
            "STD_TC_ISSUE_DATE": "05-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ4NQ==&cwid=MjE0Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/43",
            "STD_NAME": "Piyush Kumar",
            "STD_FATHER_NAME": "Shivshanker Chaurasia",
            "STD_MOTHER_NAME": "Sindu Rani",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "3117",
            "STD_TC_ISSUE_DATE": "05-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ3NA==&cwid=MjE0OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2",
            "STD_NAME": "Aryan Ray",
            "STD_FATHER_NAME": "Rakesh Kumar Roushan",
            "STD_MOTHER_NAME": "Abhilasha Kumari",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3111",
            "STD_TC_ISSUE_DATE": "05-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA0Ng==&cwid=MjE1MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1719",
            "STD_NAME": "Kashvi Yogesh Agrawal",
            "STD_FATHER_NAME": "Yogesh Agrawal",
            "STD_MOTHER_NAME": "Sweta Agrawal",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "3121",
            "STD_TC_ISSUE_DATE": "05-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjIwOQ==&cwid=MjE1Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/97",
            "STD_NAME": "Saanvi Sood",
            "STD_FATHER_NAME": "Seeman Sood",
            "STD_MOTHER_NAME": "Deborah Sood",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "3124",
            "STD_TC_ISSUE_DATE": "05-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTU5OA==&cwid=MjE1NA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2412",
            "STD_NAME": "Shreya Yadav",
            "STD_FATHER_NAME": "Sanjay Kumar Yadav",
            "STD_MOTHER_NAME": "Usha Kiran",
            "STD_LAST_CLASS": "UKG",
            "STD_TCNO": "3103",
            "STD_TC_ISSUE_DATE": "05-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA4Ng==&cwid=MjE1Ng==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/63",
            "STD_NAME": "Drishti Baghel",
            "STD_FATHER_NAME": "Dinesh Baghel",
            "STD_MOTHER_NAME": "Sneha Baghel",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "3119",
            "STD_TC_ISSUE_DATE": "05-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjcyOA==&cwid=MjE1OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/42",
            "STD_NAME": "Ruth Singh",
            "STD_FATHER_NAME": "Late   Vijay ",
            "STD_MOTHER_NAME": "Sujana ",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "3127",
            "STD_TC_ISSUE_DATE": "09-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ3Mw==&cwid=MjE2MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/16",
            "STD_NAME": "Nikhil Rathore",
            "STD_FATHER_NAME": "Pradeep Rathore",
            "STD_MOTHER_NAME": "Beena Rathore",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "3131",
            "STD_TC_ISSUE_DATE": "09-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA2MA==&cwid=MjE2Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/660",
            "STD_NAME": "Himanshu ",
            "STD_FATHER_NAME": "Manoj Kumar",
            "STD_MOTHER_NAME": "Manju Bala",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3136",
            "STD_TC_ISSUE_DATE": "12-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzM=&cwid=MjE2NA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/116",
            "STD_NAME": "Nikita ",
            "STD_FATHER_NAME": "Satbir  Singh",
            "STD_MOTHER_NAME": "Manju ",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3132",
            "STD_TC_ISSUE_DATE": "12-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTMzNA==&cwid=MjE2Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1355",
            "STD_NAME": "Yash Rathi",
            "STD_FATHER_NAME": "Vikas Rathi",
            "STD_MOTHER_NAME": "Kavita Rathi",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "3128",
            "STD_TC_ISSUE_DATE": "12-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTgwNw==&cwid=MjE2OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1987",
            "STD_NAME": "Sunil Singh",
            "STD_FATHER_NAME": "Rajender Singh",
            "STD_MOTHER_NAME": "Sarita Devi",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "3133",
            "STD_TC_ISSUE_DATE": "12-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjUyNA==&cwid=MjE3MA==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1375",
            "STD_NAME": "Priyanshi Sharma",
            "STD_FATHER_NAME": "Ashok Kumar",
            "STD_MOTHER_NAME": "Poonam Devi",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3141",
            "STD_TC_ISSUE_DATE": "12-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTgyNw==&cwid=MjE3Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/64",
            "STD_NAME": "Rakshita ",
            "STD_FATHER_NAME": "Rajesh ",
            "STD_MOTHER_NAME": "Pooja Rani",
            "STD_LAST_CLASS": "UKG",
            "STD_TCNO": "3142",
            "STD_TC_ISSUE_DATE": "12-Apr-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjcyOQ==&cwid=MjE3NA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/468",
            "STD_NAME": "Bulbul ",
            "STD_FATHER_NAME": "Late Chanderpal ",
            "STD_MOTHER_NAME": "Babita ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3150",
            "STD_TC_ISSUE_DATE": "04-May-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTU4&cwid=MjE3Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2588",
            "STD_NAME": "Ayush Gupta",
            "STD_FATHER_NAME": "Mahesh Gupta",
            "STD_MOTHER_NAME": "Mansi Gupta",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "3152",
            "STD_TC_ISSUE_DATE": "16-May-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI2Mg==&cwid=MjE3OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2551",
            "STD_NAME": "Suraj Kumar Yadav",
            "STD_FATHER_NAME": "Dev Narayan Yadav",
            "STD_MOTHER_NAME": "Saroj Devi",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3151",
            "STD_TC_ISSUE_DATE": "16-May-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIyNQ==&cwid=MjE4MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1392",
            "STD_NAME": "Mohit  Kumar",
            "STD_FATHER_NAME": "Ganesh ",
            "STD_MOTHER_NAME": "Rajkumari ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3164",
            "STD_TC_ISSUE_DATE": "27-May-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg0NA==&cwid=MjE4Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2274",
            "STD_NAME": "Jatin Tanwar",
            "STD_FATHER_NAME": "Devender ",
            "STD_MOTHER_NAME": "Krishna ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3160",
            "STD_TC_ISSUE_DATE": "27-May-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjkxMw==&cwid=MjE4NA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/310",
            "STD_NAME": "Gauri  Maurya",
            "STD_FATHER_NAME": "Ramkaran Maurya",
            "STD_MOTHER_NAME": "Savitri Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3159",
            "STD_TC_ISSUE_DATE": "27-May-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg1&cwid=MjE4Ng==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1683",
            "STD_NAME": "Muskan Bhadauriya",
            "STD_FATHER_NAME": "Avdesh Singh Bhadauriya",
            "STD_MOTHER_NAME": "Poonam ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3163",
            "STD_TC_ISSUE_DATE": "27-May-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE3Mw==&cwid=MjE4OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/59",
            "STD_NAME": "Abhay Bhatti",
            "STD_FATHER_NAME": "Peter Bhatti",
            "STD_MOTHER_NAME": "Kanta ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3166",
            "STD_TC_ISSUE_DATE": "27-May-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjcyNA==&cwid=MjE5MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2373",
            "STD_NAME": "Deepak Singh",
            "STD_FATHER_NAME": "Dhan Singh",
            "STD_MOTHER_NAME": "Kalavati Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3170",
            "STD_TC_ISSUE_DATE": "06-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzAxMg==&cwid=MjE5Mg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2323",
            "STD_NAME": "Aditya Kumar Malhotra",
            "STD_FATHER_NAME": "Naveen Kumar Malhotra",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3180",
            "STD_TC_ISSUE_DATE": "10-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk2Mg==&cwid=MjE5NA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2201",
            "STD_NAME": "Shubham Negi",
            "STD_FATHER_NAME": "Naresh Negi",
            "STD_MOTHER_NAME": "Bhawana Negi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3172",
            "STD_TC_ISSUE_DATE": "10-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg0MA==&cwid=MjE5Ng==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2203",
            "STD_NAME": "Ravi Yadav",
            "STD_FATHER_NAME": "Dharam Raj  Yadav",
            "STD_MOTHER_NAME": "Indra Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3167",
            "STD_TC_ISSUE_DATE": "10-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg0Mg==&cwid=MjE5OA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2200",
            "STD_NAME": "Vishal Chauhan",
            "STD_FATHER_NAME": "Manoj Kumar Chauhan",
            "STD_MOTHER_NAME": "Neetu Chauhan",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3206",
            "STD_TC_ISSUE_DATE": "10-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjgzOQ==&cwid=MjIwMA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2181",
            "STD_NAME": "Harsh Chaprana",
            "STD_FATHER_NAME": "Ravinder  Chaprana",
            "STD_MOTHER_NAME": "Savita Chaprana",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3189",
            "STD_TC_ISSUE_DATE": "10-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjgyMA==&cwid=MjIwMg==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2357",
            "STD_NAME": "Rahul Dixit",
            "STD_FATHER_NAME": "Sarvesh Kumar",
            "STD_MOTHER_NAME": "Anuradha ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3188",
            "STD_TC_ISSUE_DATE": "10-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk5Ng==&cwid=MjIwNA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2357",
            "STD_NAME": "Rahul Dixit",
            "STD_FATHER_NAME": "Sarvesh Kumar",
            "STD_MOTHER_NAME": "Anuradha ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3188",
            "STD_TC_ISSUE_DATE": "10-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk5Ng==&cwid=MjIwNg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2360",
            "STD_NAME": "Aayushi Singh",
            "STD_FATHER_NAME": "Ajay  Singh",
            "STD_MOTHER_NAME": "Sangeeta Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3202",
            "STD_TC_ISSUE_DATE": "10-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk5OQ==&cwid=MjIwOA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2389",
            "STD_NAME": "Hritikka Kak",
            "STD_FATHER_NAME": "Vimal Kumar Kak",
            "STD_MOTHER_NAME": "Jyoti Kak",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3201",
            "STD_TC_ISSUE_DATE": "10-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzAyOA==&cwid=MjIxMA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2324",
            "STD_NAME": "Amrit Pal Kaur",
            "STD_FATHER_NAME": "Sukhwinder Singh",
            "STD_MOTHER_NAME": "Ranjeet Kaur",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3203",
            "STD_TC_ISSUE_DATE": "10-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk2Mw==&cwid=MjIxMg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2337",
            "STD_NAME": "Deepak Singh",
            "STD_FATHER_NAME": "Rahis Pal Singh",
            "STD_MOTHER_NAME": "Prabha Kiran",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3175",
            "STD_TC_ISSUE_DATE": "10-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk3Ng==&cwid=MjIxNA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2185",
            "STD_NAME": "Lalit ",
            "STD_FATHER_NAME": "Mr Inder Singh",
            "STD_MOTHER_NAME": "Mrs  Munesh ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3208",
            "STD_TC_ISSUE_DATE": "11-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjgyNA==&cwid=MjIxNg==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2222",
            "STD_NAME": "Mohd Ashad ",
            "STD_FATHER_NAME": "Mohd  Israr ",
            "STD_MOTHER_NAME": "Reshma Parveen",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3174",
            "STD_TC_ISSUE_DATE": "11-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg2MQ==&cwid=MjIxOA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2298",
            "STD_NAME": "Ritik Jain",
            "STD_FATHER_NAME": "Dinesh Kumar Jain",
            "STD_MOTHER_NAME": "Beena Jain",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3209",
            "STD_TC_ISSUE_DATE": "11-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjkzNw==&cwid=MjIyMA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2376",
            "STD_NAME": "Vartika Rajgyan",
            "STD_FATHER_NAME": "Arun Chaudhary",
            "STD_MOTHER_NAME": "Mamta Chaudhary",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3198",
            "STD_TC_ISSUE_DATE": "11-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzAxNQ==&cwid=MjIyMg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2328",
            "STD_NAME": "Akash Kumar",
            "STD_FATHER_NAME": "Ravinder Kumar",
            "STD_MOTHER_NAME": "Sunita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3168",
            "STD_TC_ISSUE_DATE": "11-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk2Nw==&cwid=MjIyNA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2330",
            "STD_NAME": "Chanchal ",
            "STD_FATHER_NAME": "Ompal ",
            "STD_MOTHER_NAME": "Sarvesh Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3197",
            "STD_TC_ISSUE_DATE": "11-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk2OQ==&cwid=MjIyNg==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2275",
            "STD_NAME": "Tarun ",
            "STD_FATHER_NAME": "Chaman  Lal",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3195",
            "STD_TC_ISSUE_DATE": "11-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjkxNA==&cwid=MjIyOA==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2221",
            "STD_NAME": "Tushar Rajvansh",
            "STD_FATHER_NAME": "Prem Kumar ",
            "STD_MOTHER_NAME": "Mamta ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3192",
            "STD_TC_ISSUE_DATE": "11-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg2MA==&cwid=MjIzMA==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2257",
            "STD_NAME": "Parvesh ",
            "STD_FATHER_NAME": "Dayanand ",
            "STD_MOTHER_NAME": "Kanta Devi ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3205",
            "STD_TC_ISSUE_DATE": "11-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg5Ng==&cwid=MjIzMg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1570",
            "STD_NAME": "Radha ",
            "STD_FATHER_NAME": "Virender Singh",
            "STD_MOTHER_NAME": "Jamuna Devi",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3212",
            "STD_TC_ISSUE_DATE": "12-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjAyMg==&cwid=MjIzNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2279",
            "STD_NAME": "Bunty Verma",
            "STD_FATHER_NAME": "Puran Singh",
            "STD_MOTHER_NAME": "Omvati Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3204",
            "STD_TC_ISSUE_DATE": "12-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjkxOA==&cwid=MjIzNw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2276",
            "STD_NAME": "Udayveer ",
            "STD_FATHER_NAME": "Madan Lal",
            "STD_MOTHER_NAME": "Vimlesh ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3215",
            "STD_TC_ISSUE_DATE": "12-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjkxNQ==&cwid=MjIzOQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2400",
            "STD_NAME": "Mokshit Kashyap",
            "STD_FATHER_NAME": "Subhash Kashyap",
            "STD_MOTHER_NAME": "Radha Kashyap",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3218",
            "STD_TC_ISSUE_DATE": "12-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzAzOQ==&cwid=MjI0MQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2207",
            "STD_NAME": "Tushar Arora",
            "STD_FATHER_NAME": "Gopal Arora",
            "STD_MOTHER_NAME": "Sandhya Arora",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3225",
            "STD_TC_ISSUE_DATE": "12-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg0Ng==&cwid=MjI0Mw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2210",
            "STD_NAME": "Priya Mehra",
            "STD_FATHER_NAME": "Anand Singh Mehra",
            "STD_MOTHER_NAME": "Radha Mehra",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3222",
            "STD_TC_ISSUE_DATE": "12-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg0OQ==&cwid=MjI0NQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2387",
            "STD_NAME": "Anjali ",
            "STD_FATHER_NAME": "Anil Kushwaha",
            "STD_MOTHER_NAME": "Geeta Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3226",
            "STD_TC_ISSUE_DATE": "12-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzAyNg==&cwid=MjI0Nw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2334",
            "STD_NAME": "Nikita Chauhan",
            "STD_FATHER_NAME": "Jay Shri Chauhan",
            "STD_MOTHER_NAME": "Subhadra Chauhan",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3217",
            "STD_TC_ISSUE_DATE": "12-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk3Mw==&cwid=MjI0OQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2254",
            "STD_NAME": "Nizam Ali",
            "STD_FATHER_NAME": " Asgar Ali",
            "STD_MOTHER_NAME": "Alma Begam",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3221",
            "STD_TC_ISSUE_DATE": "12-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg5Mw==&cwid=MjI1MQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2321",
            "STD_NAME": "Sunil Kumar",
            "STD_FATHER_NAME": "Vishwnath Raut",
            "STD_MOTHER_NAME": "Gauri Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3185",
            "STD_TC_ISSUE_DATE": "12-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk2MA==&cwid=MjI1Mw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2255",
            "STD_NAME": "Gunjan ",
            "STD_FATHER_NAME": "Suresh Singh Ahlawat",
            "STD_MOTHER_NAME": "Seema Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3244",
            "STD_TC_ISSUE_DATE": "14-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg5NA==&cwid=MjI1NQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2206",
            "STD_NAME": "Naveen Chaudhary",
            "STD_FATHER_NAME": "Ranjeet Chaudhary",
            "STD_MOTHER_NAME": "Sita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3232",
            "STD_TC_ISSUE_DATE": "14-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg0NQ==&cwid=MjI1Nw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2218",
            "STD_NAME": "Varsha ",
            "STD_FATHER_NAME": "Saurabh Bhardwaj",
            "STD_MOTHER_NAME": "Pooja Bhardwaj",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3235",
            "STD_TC_ISSUE_DATE": "14-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg1Nw==&cwid=MjI1OQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2309",
            "STD_NAME": "Aditi Rawat",
            "STD_FATHER_NAME": "Uday Singh Rawat",
            "STD_MOTHER_NAME": "Vimala  Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3237",
            "STD_TC_ISSUE_DATE": "14-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk0OA==&cwid=MjI2MQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2217",
            "STD_NAME": "Ankit Solanki",
            "STD_FATHER_NAME": "Sadanand Prasad",
            "STD_MOTHER_NAME": "Usha Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3245",
            "STD_TC_ISSUE_DATE": "14-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg1Ng==&cwid=MjI2Mw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2293",
            "STD_NAME": "Rahul ",
            "STD_FATHER_NAME": "Jagdish ",
            "STD_MOTHER_NAME": "Priti ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3241",
            "STD_TC_ISSUE_DATE": "14-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjkzMg==&cwid=MjI2NQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2372",
            "STD_NAME": "Priyanshu Kasana",
            "STD_FATHER_NAME": "Dindayal Kasana",
            "STD_MOTHER_NAME": "Rajesh Kasana",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3249",
            "STD_TC_ISSUE_DATE": "14-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzAxMQ==&cwid=MjI2Nw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2401",
            "STD_NAME": "Boby ",
            "STD_FATHER_NAME": "Dariya Singh",
            "STD_MOTHER_NAME": "Babita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3251",
            "STD_TC_ISSUE_DATE": "14-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA0MA==&cwid=MjI2OQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2333",
            "STD_NAME": "Komal Mourya",
            "STD_FATHER_NAME": "Sadashiv Mourya",
            "STD_MOTHER_NAME": "Kamla Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3228",
            "STD_TC_ISSUE_DATE": "14-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk3Mg==&cwid=MjI3MQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2396",
            "STD_NAME": "Jyoti Devi",
            "STD_FATHER_NAME": "Dharmpal ",
            "STD_MOTHER_NAME": "Sudesh Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3234",
            "STD_TC_ISSUE_DATE": "08-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzAzNQ==&cwid=MjI3Mw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2191",
            "STD_NAME": "Vimal Sharma",
            "STD_FATHER_NAME": "Subhash Sharma",
            "STD_MOTHER_NAME": "Manju Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3247",
            "STD_TC_ISSUE_DATE": "14-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjgzMA==&cwid=MjI3NQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/16",
            "STD_NAME": "Rishank Shandilya",
            "STD_FATHER_NAME": "Rakesh Kumar",
            "STD_MOTHER_NAME": "Rani Bharti",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3253",
            "STD_TC_ISSUE_DATE": "17-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjEyNQ==&cwid=MjI3Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2343",
            "STD_NAME": "Sachin Mishra",
            "STD_FATHER_NAME": "Anand Kumar Mishra",
            "STD_MOTHER_NAME": "Santosh Mishra",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3255",
            "STD_TC_ISSUE_DATE": "17-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk4Mg==&cwid=MjI3OQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2320",
            "STD_NAME": "Amisha Mishra",
            "STD_FATHER_NAME": "Nityanand Mishra",
            "STD_MOTHER_NAME": "Rani Mishra",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3254",
            "STD_TC_ISSUE_DATE": "17-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk1OQ==&cwid=MjI4MQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2291",
            "STD_NAME": "Nupur ",
            "STD_FATHER_NAME": "Niranjan Roy",
            "STD_MOTHER_NAME": "Archana Roy",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3267",
            "STD_TC_ISSUE_DATE": "17-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjkzMA==&cwid=MjI4Mw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2213",
            "STD_NAME": "Shubham Gupta",
            "STD_FATHER_NAME": "Hari Shankar Gupta",
            "STD_MOTHER_NAME": "Bindu Gupta",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3264",
            "STD_TC_ISSUE_DATE": "17-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg1Mg==&cwid=MjI4NQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2365",
            "STD_NAME": "Abhishek Kumar Singh",
            "STD_FATHER_NAME": "Sunil Singh",
            "STD_MOTHER_NAME": "Priya Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3256",
            "STD_TC_ISSUE_DATE": "17-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzAwNA==&cwid=MjI4Nw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2358",
            "STD_NAME": "Ritika Roy",
            "STD_FATHER_NAME": "Hare Krishana Roy",
            "STD_MOTHER_NAME": "Anjana  Roy",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3262",
            "STD_TC_ISSUE_DATE": "17-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk5Nw==&cwid=MjI4OQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2204",
            "STD_NAME": "Tripti Sharma",
            "STD_FATHER_NAME": "Sheetal Sharma",
            "STD_MOTHER_NAME": "Preeti Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3260",
            "STD_TC_ISSUE_DATE": "17-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg0Mw==&cwid=MjI5MQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/583",
            "STD_NAME": "Riya Mazumdar",
            "STD_FATHER_NAME": "Kajal Mazumdar",
            "STD_MOTHER_NAME": "Sadhana Mandal",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3268",
            "STD_TC_ISSUE_DATE": "19-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTM=&cwid=MjI5Mw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2384",
            "STD_NAME": "Tarun Kumar",
            "STD_FATHER_NAME": "Sukesh Kumar",
            "STD_MOTHER_NAME": "Kamlesh ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3184",
            "STD_TC_ISSUE_DATE": "24-Jun-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzAyMw==&cwid=MjI5NQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/80",
            "STD_NAME": "Kajal Rani",
            "STD_FATHER_NAME": "Shiv Shankar Chaurasia",
            "STD_MOTHER_NAME": "Sindu Rani",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3271",
            "STD_TC_ISSUE_DATE": "02-Jul-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc0NQ==&cwid=MjI5Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2307",
            "STD_NAME": "Sudhanshu Kumar Gupta",
            "STD_FATHER_NAME": "Manoj Kumar Gupta",
            "STD_MOTHER_NAME": "Sunita Gupta",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3273",
            "STD_TC_ISSUE_DATE": "10-Jul-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk0Ng==&cwid=MjI5OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2116",
            "STD_NAME": "Jauhar Jamal",
            "STD_FATHER_NAME": "M  Rahman ",
            "STD_MOTHER_NAME": "Noshaba ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3275",
            "STD_TC_ISSUE_DATE": "10-Jul-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY1Mw==&cwid=MjMwMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2315",
            "STD_NAME": "Dhankesh Gupta",
            "STD_FATHER_NAME": "Ravinder Gupta",
            "STD_MOTHER_NAME": "Kunti Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "3279",
            "STD_TC_ISSUE_DATE": "12-Jul-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk1NA==&cwid=MjMwMw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/430",
            "STD_NAME": "Ayesha Khatoon",
            "STD_FATHER_NAME": "Asgar  Ali",
            "STD_MOTHER_NAME": " Alma  Begam",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3280",
            "STD_TC_ISSUE_DATE": "20-Jul-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTgz&cwid=MjMwNQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/372",
            "STD_NAME": "Shubham Jaiswal",
            "STD_FATHER_NAME": "Mantosh Kumar",
            "STD_MOTHER_NAME": "Lata ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3283",
            "STD_TC_ISSUE_DATE": "29-Jul-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc0&cwid=MjMwNw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2653",
            "STD_NAME": "Kabeer Jeevan Bhawasar",
            "STD_FATHER_NAME": "Jeevan Dilip Bhawasar",
            "STD_MOTHER_NAME": "Bharati Jeewan  Bhawasar",
            "STD_LAST_CLASS": "LKG",
            "STD_TCNO": "3285",
            "STD_TC_ISSUE_DATE": "09-Aug-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM0OA==&cwid=MjMwOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2258",
            "STD_NAME": "Shashi Bhatt",
            "STD_FATHER_NAME": "Ravi Prakash Bhatt",
            "STD_MOTHER_NAME": "Kanchan Bhatt",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3289",
            "STD_TC_ISSUE_DATE": "28-Aug-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg5Nw==&cwid=MjMxMQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1890",
            "STD_NAME": "Sagar Singh",
            "STD_FATHER_NAME": "Jaiveer Singh",
            "STD_MOTHER_NAME": "Pushpa Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3288",
            "STD_TC_ISSUE_DATE": "28-Aug-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM4MA==&cwid=MjMxMw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1679",
            "STD_NAME": "Akshay ",
            "STD_FATHER_NAME": "Rakesh  ",
            "STD_MOTHER_NAME": "Babita ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3293",
            "STD_TC_ISSUE_DATE": "14-Sep-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE2OQ==&cwid=MjMxNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2327",
            "STD_NAME": "Archana Rai",
            "STD_FATHER_NAME": "Anand Rai",
            "STD_MOTHER_NAME": "Sarita Rai",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3297",
            "STD_TC_ISSUE_DATE": "22-Oct-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk2Ng==&cwid=MjMxNw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2037",
            "STD_NAME": "Sweety Jha",
            "STD_FATHER_NAME": "Sunil Kumar Jha",
            "STD_MOTHER_NAME": "Mamta Jha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3299",
            "STD_TC_ISSUE_DATE": "24-Oct-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjU3NA==&cwid=MjMxOQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/633",
            "STD_NAME": "Prarthna ",
            "STD_FATHER_NAME": "Niranjan Rai",
            "STD_MOTHER_NAME": "Archana  Rai",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3301",
            "STD_TC_ISSUE_DATE": "20-Jan-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY2&cwid=MjMyMQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/24",
            "STD_NAME": "Harsh Negi",
            "STD_FATHER_NAME": "Naresh Negi",
            "STD_MOTHER_NAME": "Bhawana Negi",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3145",
            "STD_TC_ISSUE_DATE": "02-May-2019",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ1NQ==&cwid=MjMyMw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2702",
            "STD_NAME": "Anshul ",
            "STD_FATHER_NAME": "Shishpal ",
            "STD_MOTHER_NAME": "Neeru ",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "3307",
            "STD_TC_ISSUE_DATE": "06-Jul-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM5Nw==&cwid=MjMyNg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2691",
            "STD_NAME": "Vivaan Sharma",
            "STD_FATHER_NAME": "Anil Kumar Sharma",
            "STD_MOTHER_NAME": "Archana Sharma",
            "STD_LAST_CLASS": "UKG",
            "STD_TCNO": "3308",
            "STD_TC_ISSUE_DATE": "06-Jul-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM4Ng==&cwid=MjMyOA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/951",
            "STD_NAME": "Ravi Kumar",
            "STD_FATHER_NAME": "Dev Nandan Kumar",
            "STD_MOTHER_NAME": "Lalita Devi",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "3304",
            "STD_TC_ISSUE_DATE": "06-Jul-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzg=&cwid=MjMzMA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/73",
            "STD_NAME": "Amrit Kumar Das Mohapatra",
            "STD_FATHER_NAME": "Anil Kumar Das Mohapatra",
            "STD_MOTHER_NAME": "Hemangini Das Mohapatra",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3310",
            "STD_TC_ISSUE_DATE": "07-Aug-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjczOA==&cwid=MjMzMg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/36",
            "STD_NAME": "Nilesh Singh Rawat",
            "STD_FATHER_NAME": "Kundan Singh Rawat",
            "STD_MOTHER_NAME": "Basanti Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3311",
            "STD_TC_ISSUE_DATE": "05-Aug-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE0NQ==&cwid=MjMzNA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2436",
            "STD_NAME": "Ayush Singh",
            "STD_FATHER_NAME": "Amar Singh",
            "STD_MOTHER_NAME": "Poonam Singh",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3318",
            "STD_TC_ISSUE_DATE": "06-Aug-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzExMA==&cwid=MjMzNg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/119",
            "STD_NAME": "Mayank ",
            "STD_FATHER_NAME": "Satbir  Singh",
            "STD_MOTHER_NAME": "Manju ",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3312",
            "STD_TC_ISSUE_DATE": "06-Aug-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTMzNw==&cwid=MjMzOA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/926",
            "STD_NAME": "Yash Khatana",
            "STD_FATHER_NAME": "Rajiv Khatana",
            "STD_MOTHER_NAME": "Sunita Khatana",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3315",
            "STD_TC_ISSUE_DATE": "06-Aug-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTUy&cwid=MjM0MA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2482",
            "STD_NAME": "Prem Bhardwaj",
            "STD_FATHER_NAME": "Saurabh Bhardwaj",
            "STD_MOTHER_NAME": "Pooja Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3320",
            "STD_TC_ISSUE_DATE": "07-Aug-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE1Ng==&cwid=MjM0Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2573",
            "STD_NAME": "Vansh Chaprana",
            "STD_FATHER_NAME": "Nakul Chaprana",
            "STD_MOTHER_NAME": "Poonam ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3321",
            "STD_TC_ISSUE_DATE": "07-Aug-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI0Nw==&cwid=MjM0NA==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2198",
            "STD_NAME": "Vasudev ",
            "STD_FATHER_NAME": "Tarachand ",
            "STD_MOTHER_NAME": "Laxmi Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3702",
            "STD_TC_ISSUE_DATE": "22-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjgzNw==&cwid=MjM0Ng==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2447",
            "STD_NAME": "Aakash Gupta",
            "STD_FATHER_NAME": "Sijalu Gupta",
            "STD_MOTHER_NAME": "Durgawati ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3341",
            "STD_TC_ISSUE_DATE": "08-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzEyMQ==&cwid=MjM0OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1634",
            "STD_NAME": "Pooja Kumari",
            "STD_FATHER_NAME": "Shiv Muni  ",
            "STD_MOTHER_NAME": "Jhunra Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3354",
            "STD_TC_ISSUE_DATE": "08-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjA4Ng==&cwid=MjM1MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2421",
            "STD_NAME": "Nikita Jha",
            "STD_FATHER_NAME": "Suresh Kumar Jha",
            "STD_MOTHER_NAME": "Rani Jha",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3353",
            "STD_TC_ISSUE_DATE": "08-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA5NQ==&cwid=MjM1Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2421",
            "STD_NAME": "Nikita Jha",
            "STD_FATHER_NAME": "Suresh Kumar Jha",
            "STD_MOTHER_NAME": "Rani Jha",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3353",
            "STD_TC_ISSUE_DATE": "08-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA5NQ==&cwid=MjM1NA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2421",
            "STD_NAME": "Nikita Jha",
            "STD_FATHER_NAME": "Suresh Kumar Jha",
            "STD_MOTHER_NAME": "Rani Jha",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3353",
            "STD_TC_ISSUE_DATE": "08-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA5NQ==&cwid=MjM1Ng==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2421",
            "STD_NAME": "Nikita Jha",
            "STD_FATHER_NAME": "Suresh Kumar Jha",
            "STD_MOTHER_NAME": "Rani Jha",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3353",
            "STD_TC_ISSUE_DATE": "08-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA5NQ==&cwid=MjM1OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2421",
            "STD_NAME": "Nikita Jha",
            "STD_FATHER_NAME": "Suresh Kumar Jha",
            "STD_MOTHER_NAME": "Rani Jha",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3353",
            "STD_TC_ISSUE_DATE": "08-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA5NQ==&cwid=MjM2MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2421",
            "STD_NAME": "Nikita Jha",
            "STD_FATHER_NAME": "Suresh Kumar Jha",
            "STD_MOTHER_NAME": "Rani Jha",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3353",
            "STD_TC_ISSUE_DATE": "08-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA5NQ==&cwid=MjM2Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2421",
            "STD_NAME": "Nikita Jha",
            "STD_FATHER_NAME": "Suresh Kumar Jha",
            "STD_MOTHER_NAME": "Rani Jha",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3353",
            "STD_TC_ISSUE_DATE": "08-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA5NQ==&cwid=MjM2NA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2421",
            "STD_NAME": "Nikita Jha",
            "STD_FATHER_NAME": "Suresh Kumar Jha",
            "STD_MOTHER_NAME": "Rani Jha",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3353",
            "STD_TC_ISSUE_DATE": "08-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA5NQ==&cwid=MjM2Ng==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2421",
            "STD_NAME": "Nikita Jha",
            "STD_FATHER_NAME": "Suresh Kumar Jha",
            "STD_MOTHER_NAME": "Rani Jha",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3353",
            "STD_TC_ISSUE_DATE": "08-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA5NQ==&cwid=MjM2OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2421",
            "STD_NAME": "Nikita Jha",
            "STD_FATHER_NAME": "Suresh Kumar Jha",
            "STD_MOTHER_NAME": "Rani Jha",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3353",
            "STD_TC_ISSUE_DATE": "08-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA5NQ==&cwid=MjM3MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2402",
            "STD_NAME": "Sonu Mahor",
            "STD_FATHER_NAME": "Rameshwar ",
            "STD_MOTHER_NAME": "Savitri ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3350",
            "STD_TC_ISSUE_DATE": "08-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA0MQ==&cwid=MjM3Mg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/18",
            "STD_NAME": "Sonam  Kumari",
            "STD_FATHER_NAME": "Rajesh  Kumar Srivastav",
            "STD_MOTHER_NAME": "Renu Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3342",
            "STD_TC_ISSUE_DATE": "08-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ0OQ==&cwid=MjM3NA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2592",
            "STD_NAME": "Neelima Pant",
            "STD_FATHER_NAME": "Amar Jyoti Sarmah Guardian",
            "STD_MOTHER_NAME": "Devki Pant",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3345",
            "STD_TC_ISSUE_DATE": "09-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI2Ng==&cwid=MjM3Ng==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2590",
            "STD_NAME": "Jyoti Tuli",
            "STD_FATHER_NAME": "Dharampal ",
            "STD_MOTHER_NAME": "Late Sunita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3343",
            "STD_TC_ISSUE_DATE": "09-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI2NA==&cwid=MjM3OA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2545",
            "STD_NAME": "Aparna ",
            "STD_FATHER_NAME": "Govind Singh",
            "STD_MOTHER_NAME": "Pushpa ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3358",
            "STD_TC_ISSUE_DATE": "11-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIxOQ==&cwid=MjM4MA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2444",
            "STD_NAME": "Hemant Prasad",
            "STD_FATHER_NAME": "Rajesh Prasad",
            "STD_MOTHER_NAME": "Rani Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3338",
            "STD_TC_ISSUE_DATE": "11-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzExOA==&cwid=MjM4Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2614",
            "STD_NAME": "Lakhan Chaudhary",
            "STD_FATHER_NAME": "Pradeep Chaudhary",
            "STD_MOTHER_NAME": "Nirmal Chaudhary",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3359",
            "STD_TC_ISSUE_DATE": "11-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI4OA==&cwid=MjM4NA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2572",
            "STD_NAME": "Nisha Soni",
            "STD_FATHER_NAME": "Suresh Kumar Soni",
            "STD_MOTHER_NAME": "Pramila Soni",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3357",
            "STD_TC_ISSUE_DATE": "11-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI0Ng==&cwid=MjM4Ng==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2585",
            "STD_NAME": "Ansh Kumar Choudhary",
            "STD_FATHER_NAME": "Ramesh Kumar",
            "STD_MOTHER_NAME": "Sunita Rani",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3363",
            "STD_TC_ISSUE_DATE": "11-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI1OQ==&cwid=MjM4OA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2554",
            "STD_NAME": "Tanvi Gupta",
            "STD_FATHER_NAME": "Saroj Kumar Gupta",
            "STD_MOTHER_NAME": "Sunita Gupta",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3339",
            "STD_TC_ISSUE_DATE": "15-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIyOA==&cwid=MjM5MA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/88",
            "STD_NAME": "Harshit Garg",
            "STD_FATHER_NAME": "Deepak Garg",
            "STD_MOTHER_NAME": "Nisha  Garg",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3369",
            "STD_TC_ISSUE_DATE": "18-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc1Mw==&cwid=MjM5Mg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/632",
            "STD_NAME": "Ashish ",
            "STD_FATHER_NAME": "Pritam Singh",
            "STD_MOTHER_NAME": "Rajesh  Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3365",
            "STD_TC_ISSUE_DATE": "18-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjEw&cwid=MjM5NA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1659",
            "STD_NAME": "Pushkar Singh",
            "STD_FATHER_NAME": "Dhan Singh Bisht",
            "STD_MOTHER_NAME": "Kalawati Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3372",
            "STD_TC_ISSUE_DATE": "26-Sep-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE0OQ==&cwid=MjM5Ng==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2457",
            "STD_NAME": "Anishka Gupta",
            "STD_FATHER_NAME": "Susheel Gupta",
            "STD_MOTHER_NAME": "Babli Gupta",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3371",
            "STD_TC_ISSUE_DATE": "01-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzEzMQ==&cwid=MjM5OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1933",
            "STD_NAME": "Sagar ",
            "STD_FATHER_NAME": "Soran Singh",
            "STD_MOTHER_NAME": "Late Neetu ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3376",
            "STD_TC_ISSUE_DATE": "01-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQyMw==&cwid=MjQwMA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2560",
            "STD_NAME": "Waseem Khan",
            "STD_FATHER_NAME": "Safi Mohd",
            "STD_MOTHER_NAME": "Meera Begum",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3381",
            "STD_TC_ISSUE_DATE": "01-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIzNA==&cwid=MjQwMg==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2550",
            "STD_NAME": "Monu ",
            "STD_FATHER_NAME": "Bijendra Kumar",
            "STD_MOTHER_NAME": "Dharamwati ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3378",
            "STD_TC_ISSUE_DATE": "01-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIyNA==&cwid=MjQwNQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2567",
            "STD_NAME": "Shorya Singh",
            "STD_FATHER_NAME": "Late  Alkendra Singh",
            "STD_MOTHER_NAME": "Late  Babli ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3380",
            "STD_TC_ISSUE_DATE": "01-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI0MQ==&cwid=MjQwNw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2546",
            "STD_NAME": "Priyanshu Gupta",
            "STD_FATHER_NAME": "Ravi Gupta",
            "STD_MOTHER_NAME": "Ritu Gupta",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3347",
            "STD_TC_ISSUE_DATE": "08-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIyMA==&cwid=MjQwOQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2558",
            "STD_NAME": "Ajay ",
            "STD_FATHER_NAME": "Gajraj Sharma",
            "STD_MOTHER_NAME": "Sharda ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3384",
            "STD_TC_ISSUE_DATE": "08-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIzMg==&cwid=MjQxMQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2594",
            "STD_NAME": "Bhumika ",
            "STD_FATHER_NAME": "Praveen Kumar",
            "STD_MOTHER_NAME": "Rakhi ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3393",
            "STD_TC_ISSUE_DATE": "08-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI2OA==&cwid=MjQxMw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2584",
            "STD_NAME": "Khushi ",
            "STD_FATHER_NAME": "Devender ",
            "STD_MOTHER_NAME": "Beena ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3391",
            "STD_TC_ISSUE_DATE": "08-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI1OA==&cwid=MjQxNQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2606",
            "STD_NAME": "Dechen Wangmo",
            "STD_FATHER_NAME": "Late Sonam  Wangdak",
            "STD_MOTHER_NAME": "Tsering Youldon",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3392",
            "STD_TC_ISSUE_DATE": "08-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI4MA==&cwid=MjQxNw==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2570",
            "STD_NAME": "Himani Shukla",
            "STD_FATHER_NAME": "Ajay Shukla",
            "STD_MOTHER_NAME": "Sukrekha Shukla",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3395",
            "STD_TC_ISSUE_DATE": "08-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI0NA==&cwid=MjQxOQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2445",
            "STD_NAME": "Abhishek Yadav",
            "STD_FATHER_NAME": "Nagender Yadav",
            "STD_MOTHER_NAME": "Anita Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3388",
            "STD_TC_ISSUE_DATE": "08-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzExOQ==&cwid=MjQyMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2565",
            "STD_NAME": "Archana ",
            "STD_FATHER_NAME": "Sri Ram ",
            "STD_MOTHER_NAME": "Anita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3396",
            "STD_TC_ISSUE_DATE": "08-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIzOQ==&cwid=MjQyMw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2541",
            "STD_NAME": "Andrea Mitra",
            "STD_FATHER_NAME": "Ady Mitra",
            "STD_MOTHER_NAME": "Louisa Mitra",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3399",
            "STD_TC_ISSUE_DATE": "14-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIxNQ==&cwid=MjQyNQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2259",
            "STD_NAME": "Nancy Jha",
            "STD_FATHER_NAME": "Anand Kumar Jha",
            "STD_MOTHER_NAME": "Nisha Jha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3400",
            "STD_TC_ISSUE_DATE": "14-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg5OA==&cwid=MjQyNw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/23",
            "STD_NAME": "Muskan Negi",
            "STD_FATHER_NAME": "Suresh Negi",
            "STD_MOTHER_NAME": "Mamta Negi",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3403",
            "STD_TC_ISSUE_DATE": "15-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ1NA==&cwid=MjQyOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2598",
            "STD_NAME": "Avinash Singh",
            "STD_FATHER_NAME": "Jai Kishore Singh",
            "STD_MOTHER_NAME": "Pinki Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3405",
            "STD_TC_ISSUE_DATE": "16-Oct-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI3Mg==&cwid=MjQzMQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2300",
            "STD_NAME": "Ashish Rawat",
            "STD_FATHER_NAME": "Sanjay Singh Rawat",
            "STD_MOTHER_NAME": "Meenu Rawat",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3409",
            "STD_TC_ISSUE_DATE": "07-Nov-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjkzOQ==&cwid=MjQzMw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2623",
            "STD_NAME": "Sandeep ",
            "STD_FATHER_NAME": "Ram Kumar",
            "STD_MOTHER_NAME": "Kamlesh ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3407",
            "STD_TC_ISSUE_DATE": "07-Nov-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI5Nw==&cwid=MjQzNQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2607",
            "STD_NAME": "Aniket Sagar",
            "STD_FATHER_NAME": "Braham Sagar",
            "STD_MOTHER_NAME": "Seema Sagar",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3414",
            "STD_TC_ISSUE_DATE": "07-Nov-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI4MQ==&cwid=MjQzNw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2580",
            "STD_NAME": "Rohit Pal",
            "STD_FATHER_NAME": "Ramraj Pal",
            "STD_MOTHER_NAME": "Parwati Pal",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3412",
            "STD_TC_ISSUE_DATE": "07-Nov-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI1NA==&cwid=MjQzOQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2544",
            "STD_NAME": "Roshan Yadav",
            "STD_FATHER_NAME": "Sobran Singh Yadav",
            "STD_MOTHER_NAME": "Sarvesh Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3411",
            "STD_TC_ISSUE_DATE": "07-Nov-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIxOA==&cwid=MjQ0MQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1929",
            "STD_NAME": "Rohan Singh",
            "STD_FATHER_NAME": "Brijesh Singh",
            "STD_MOTHER_NAME": "Preeti Singh",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "3417",
            "STD_TC_ISSUE_DATE": "04-Dec-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQxOQ==&cwid=MjQ0Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2552",
            "STD_NAME": "Jayanti Singh",
            "STD_FATHER_NAME": "Amar Singh",
            "STD_MOTHER_NAME": "Poonam Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3420",
            "STD_TC_ISSUE_DATE": "04-Dec-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIyNg==&cwid=MjQ0NQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2621",
            "STD_NAME": "Ishika ",
            "STD_FATHER_NAME": "Ghan Shyam ",
            "STD_MOTHER_NAME": "Sangeeta ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3421",
            "STD_TC_ISSUE_DATE": "10-Dec-2020",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI5NQ==&cwid=MjQ0Nw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2278",
            "STD_NAME": "Lalit ",
            "STD_FATHER_NAME": "Yogender Singh",
            "STD_MOTHER_NAME": "Savita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3423",
            "STD_TC_ISSUE_DATE": "04-Jan-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjkxNw==&cwid=MjQ0OQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2555",
            "STD_NAME": "Bobby Dogra",
            "STD_FATHER_NAME": "Vijay Kumar",
            "STD_MOTHER_NAME": "Sunita Kumari",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3424",
            "STD_TC_ISSUE_DATE": "04-Jan-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIyOQ==&cwid=MjQ1MQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2624",
            "STD_NAME": "Manish ",
            "STD_FATHER_NAME": "Ramesh Chand",
            "STD_MOTHER_NAME": "Ritu ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3426",
            "STD_TC_ISSUE_DATE": "16-Jan-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI5OA==&cwid=MjQ1Mw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2737",
            "STD_NAME": "Muskan Mishra",
            "STD_FATHER_NAME": "Prasidh Mishra",
            "STD_MOTHER_NAME": "Jyoti Mishra",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3430",
            "STD_TC_ISSUE_DATE": "17-Feb-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQzMg==&cwid=MjQ1NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1835",
            "STD_NAME": "Adarsh Kumar  Singh",
            "STD_FATHER_NAME": "Ajay Singh",
            "STD_MOTHER_NAME": "Sheela  Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3431",
            "STD_TC_ISSUE_DATE": "22-Feb-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMyNQ==&cwid=MjQ1Nw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/9",
            "STD_NAME": "Vedik Singh Nayal",
            "STD_FATHER_NAME": "Gaurav Singh Nayal",
            "STD_MOTHER_NAME": "Babita ",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "3445",
            "STD_TC_ISSUE_DATE": "17-Apr-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY3NA==&cwid=MjQ1OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1262",
            "STD_NAME": "Ekansh Baghel",
            "STD_FATHER_NAME": "Harish Baghel",
            "STD_MOTHER_NAME": "Babita ",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3441",
            "STD_TC_ISSUE_DATE": "17-Apr-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTcwNw==&cwid=MjQ2MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2",
            "STD_NAME": "Akshita L  Mashee",
            "STD_FATHER_NAME": "Sunil  Mashee",
            "STD_MOTHER_NAME": "Martha Mashee",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "3435",
            "STD_TC_ISSUE_DATE": "17-Apr-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQzMw==&cwid=MjQ2Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2660",
            "STD_NAME": "Ayush Ranjan",
            "STD_FATHER_NAME": "Sanjay Sharma",
            "STD_MOTHER_NAME": "Archana Prakash",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "3444",
            "STD_TC_ISSUE_DATE": "17-Apr-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM1NQ==&cwid=MjQ2NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2158",
            "STD_NAME": "Ujjwal Yadav",
            "STD_FATHER_NAME": "Yadvender Singh Yadav",
            "STD_MOTHER_NAME": "Saroj Yadav",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "3438",
            "STD_TC_ISSUE_DATE": "17-Apr-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc5Nw==&cwid=MjQ2Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1266",
            "STD_NAME": "Palak ",
            "STD_FATHER_NAME": "Harish Baghel",
            "STD_MOTHER_NAME": "Babita ",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "3440",
            "STD_TC_ISSUE_DATE": "17-Apr-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTcxMQ==&cwid=MjQ2OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/128",
            "STD_NAME": "Sagar Mavi",
            "STD_FATHER_NAME": "Bijander Mavi",
            "STD_MOTHER_NAME": "Chandra Mavi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3432",
            "STD_TC_ISSUE_DATE": "17-Apr-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM0Ng==&cwid=MjQ3MQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1315",
            "STD_NAME": "Manisha Kumari",
            "STD_FATHER_NAME": "Anil Gupta",
            "STD_MOTHER_NAME": "Lalita Devi",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3449",
            "STD_TC_ISSUE_DATE": "24-May-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc2NA==&cwid=MjQ3Mw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1305",
            "STD_NAME": "Avinash ",
            "STD_FATHER_NAME": "Pintu Gupta",
            "STD_MOTHER_NAME": "Savita Devi",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3450",
            "STD_TC_ISSUE_DATE": "24-May-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc1MA==&cwid=MjQ3NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/16",
            "STD_NAME": "Prveen Kumar Singh",
            "STD_FATHER_NAME": "Ram Kumar Singh",
            "STD_MOTHER_NAME": "Phool  Kumari",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3453",
            "STD_TC_ISSUE_DATE": "15-Jun-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY4MQ==&cwid=MjQ3Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1313",
            "STD_NAME": "Sunny ",
            "STD_FATHER_NAME": "Santosh Kumar",
            "STD_MOTHER_NAME": "Pramila Devi",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3456",
            "STD_TC_ISSUE_DATE": "16-Jun-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc2Mg==&cwid=MjQ3OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1302",
            "STD_NAME": "Abhinav ",
            "STD_FATHER_NAME": "Dev Chand",
            "STD_MOTHER_NAME": "Shashi Kala",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3457",
            "STD_TC_ISSUE_DATE": "16-Jun-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc0Nw==&cwid=MjQ4MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/24",
            "STD_NAME": "Surya Krishna Menon",
            "STD_FATHER_NAME": "Saiju Thayyil",
            "STD_MOTHER_NAME": "Divya Saiju",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "3459",
            "STD_TC_ISSUE_DATE": "29-Jun-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA2OA==&cwid=MjQ4Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1303",
            "STD_NAME": "Alok Kumar",
            "STD_FATHER_NAME": "Arun Kumar",
            "STD_MOTHER_NAME": "Malti Devi",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "3460",
            "STD_TC_ISSUE_DATE": "29-Jun-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc0OA==&cwid=MjQ4NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2658",
            "STD_NAME": "Divyanshu Sharma",
            "STD_FATHER_NAME": "Shrikant Sharma",
            "STD_MOTHER_NAME": "Pushpa Sharma",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3463",
            "STD_TC_ISSUE_DATE": "23-Jul-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM1Mw==&cwid=MjQ4Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2703",
            "STD_NAME": "Yogesh ",
            "STD_FATHER_NAME": "Pawan Sharma",
            "STD_MOTHER_NAME": "Geeta Sharma",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3464",
            "STD_TC_ISSUE_DATE": "30-Jul-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM5OA==&cwid=MjQ4OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/28",
            "STD_NAME": "Dipti Kumari",
            "STD_FATHER_NAME": "Roopesh Giri",
            "STD_MOTHER_NAME": "Sunita Devi",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3583",
            "STD_TC_ISSUE_DATE": "19-Jan-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTUyOQ==&cwid=MjQ5MQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1946",
            "STD_NAME": "Satyam Jawla",
            "STD_FATHER_NAME": "Aadesh  Kumar",
            "STD_MOTHER_NAME": "Aruna Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3467",
            "STD_TC_ISSUE_DATE": "07-Aug-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ4Mw==&cwid=MjQ5Mw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2705",
            "STD_NAME": "Hitesh ",
            "STD_FATHER_NAME": "Pawan Sharma",
            "STD_MOTHER_NAME": "Geeta Sharma",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3469",
            "STD_TC_ISSUE_DATE": "07-Aug-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQwMA==&cwid=MjQ5NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1830",
            "STD_NAME": "Naval Kishor",
            "STD_FATHER_NAME": "Kamlesh Gupta",
            "STD_MOTHER_NAME": "Kushmila Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3473",
            "STD_TC_ISSUE_DATE": "10-Aug-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMyMA==&cwid=MjQ5Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2659",
            "STD_NAME": "Ujjwal Sharma",
            "STD_FATHER_NAME": "Shrikant Sharma",
            "STD_MOTHER_NAME": "Pushpa Sharma",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3470",
            "STD_TC_ISSUE_DATE": "10-Aug-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM1NA==&cwid=MjQ5OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3131",
            "STD_NAME": "Anubhav Sharma",
            "STD_FATHER_NAME": "Dheeraj Kumar Sharma",
            "STD_MOTHER_NAME": "Sunitha Sharma",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "3485",
            "STD_TC_ISSUE_DATE": "17-Aug-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzgyNg==&cwid=MjUwMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/8",
            "STD_NAME": "Nakshatra Tiwari",
            "STD_FATHER_NAME": "Rajeev Kumar Tiwari",
            "STD_MOTHER_NAME": "Anjani Tiwari",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "3487",
            "STD_TC_ISSUE_DATE": "24-Aug-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY3Mw==&cwid=MjUwMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1961",
            "STD_NAME": "Sahil Giri",
            "STD_FATHER_NAME": "Omprakash Giri",
            "STD_MOTHER_NAME": "Premsheela  Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3478",
            "STD_TC_ISSUE_DATE": "25-Aug-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ5OA==&cwid=MjUwNQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1648",
            "STD_NAME": "Fardeen ",
            "STD_FATHER_NAME": "Shahid Ali",
            "STD_MOTHER_NAME": "Sahida ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3493",
            "STD_TC_ISSUE_DATE": "28-Aug-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjEwMA==&cwid=MjUwNw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2860",
            "STD_NAME": "Ayush Sachan",
            "STD_FATHER_NAME": "Pramod Kumar",
            "STD_MOTHER_NAME": "Vimlesh Sachan",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3495",
            "STD_TC_ISSUE_DATE": "28-Aug-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU1NQ==&cwid=MjUwOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1883",
            "STD_NAME": "Devender Singh",
            "STD_FATHER_NAME": "Sukhbir Singh",
            "STD_MOTHER_NAME": "Maya Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3480",
            "STD_TC_ISSUE_DATE": "04-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM3Mw==&cwid=MjUxMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2733",
            "STD_NAME": "Shadab Ahmad Khan",
            "STD_FATHER_NAME": "Parvez Ahmad Khan",
            "STD_MOTHER_NAME": "Shabana Yasmin",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3492",
            "STD_TC_ISSUE_DATE": "04-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQyOA==&cwid=MjUxMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2900",
            "STD_NAME": "Mohd Shahzeb Iderisi",
            "STD_FATHER_NAME": "Mohd  Nasir  Iderisi",
            "STD_MOTHER_NAME": "Chanda Bi Iderisi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3506",
            "STD_TC_ISSUE_DATE": "13-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU5NQ==&cwid=MjUxNQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2907",
            "STD_NAME": "Shashank ",
            "STD_FATHER_NAME": "Mukesh Kumar",
            "STD_MOTHER_NAME": "Sarita Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3509",
            "STD_TC_ISSUE_DATE": "13-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYwMg==&cwid=MjUxNw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2839",
            "STD_NAME": "Ashi ",
            "STD_FATHER_NAME": "Devender ",
            "STD_MOTHER_NAME": "Beena ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3511",
            "STD_TC_ISSUE_DATE": "13-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzUzNA==&cwid=MjUxOQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2959",
            "STD_NAME": "Kritika Sharma",
            "STD_FATHER_NAME": "Rakesh  Sharma",
            "STD_MOTHER_NAME": "Poonam  Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3512",
            "STD_TC_ISSUE_DATE": "13-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY1NA==&cwid=MjUyMQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2906",
            "STD_NAME": "Kashish ",
            "STD_FATHER_NAME": "Suresh ",
            "STD_MOTHER_NAME": "Hemlata ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3515",
            "STD_TC_ISSUE_DATE": "13-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYwMQ==&cwid=MjUyMw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2902",
            "STD_NAME": "Poonam Singh",
            "STD_FATHER_NAME": "Rahis Pal Singh",
            "STD_MOTHER_NAME": "Prabha Kiran",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3497",
            "STD_TC_ISSUE_DATE": "13-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU5Nw==&cwid=MjUyNQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2843",
            "STD_NAME": "Shivam ",
            "STD_FATHER_NAME": "Somveer Singh",
            "STD_MOTHER_NAME": "Bimlesh ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3501",
            "STD_TC_ISSUE_DATE": "13-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzUzOA==&cwid=MjUyNw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2958",
            "STD_NAME": "Tanya ",
            "STD_FATHER_NAME": "Harpal Singh",
            "STD_MOTHER_NAME": "Rohini Kaul",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3499",
            "STD_TC_ISSUE_DATE": "13-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY1Mw==&cwid=MjUyOQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2912",
            "STD_NAME": "Sohita ",
            "STD_FATHER_NAME": "Mahabir Singh",
            "STD_MOTHER_NAME": "Renu ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3484",
            "STD_TC_ISSUE_DATE": "13-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYwNw==&cwid=MjUzMQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2890",
            "STD_NAME": "Arpita Adak",
            "STD_FATHER_NAME": "Jagodish Adak",
            "STD_MOTHER_NAME": "Aruna Adak",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3502",
            "STD_TC_ISSUE_DATE": "13-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU4NQ==&cwid=MjUzMw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2924",
            "STD_NAME": "Lakshmi Bhat",
            "STD_FATHER_NAME": "Rajender Prasad",
            "STD_MOTHER_NAME": "Shanta Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3496",
            "STD_TC_ISSUE_DATE": "13-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYxOQ==&cwid=MjUzNQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2934",
            "STD_NAME": "Aditya Chaprana",
            "STD_FATHER_NAME": "Narender ",
            "STD_MOTHER_NAME": "Neeraj ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3505",
            "STD_TC_ISSUE_DATE": "13-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYyOQ==&cwid=MjUzNw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2616",
            "STD_NAME": "Happy Singh",
            "STD_FATHER_NAME": "Mata Prasad Singh",
            "STD_MOTHER_NAME": "Rita Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3517",
            "STD_TC_ISSUE_DATE": "15-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI5MA==&cwid=MjUzOQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2591",
            "STD_NAME": "Nomita ",
            "STD_FATHER_NAME": "Shailesh ",
            "STD_MOTHER_NAME": "Shyamoli Sarkar",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3475",
            "STD_TC_ISSUE_DATE": "15-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI2NQ==&cwid=MjU0MQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2974",
            "STD_NAME": "Amul Dwivedi",
            "STD_FATHER_NAME": "Santosh Dwivedi",
            "STD_MOTHER_NAME": "Jaya Dwivedi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3521",
            "STD_TC_ISSUE_DATE": "01-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY2OQ==&cwid=MjU0Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2971",
            "STD_NAME": "Mayank Bhadana",
            "STD_FATHER_NAME": "Kiran Pal Bhadana",
            "STD_MOTHER_NAME": "Neeraj  Bhadana",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3531",
            "STD_TC_ISSUE_DATE": "04-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY2Ng==&cwid=MjU0NQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2933",
            "STD_NAME": "Rishi Pal",
            "STD_FATHER_NAME": "Dharam Pal",
            "STD_MOTHER_NAME": "Geeta ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3524",
            "STD_TC_ISSUE_DATE": "04-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYyOA==&cwid=MjU0Nw==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2665",
            "STD_NAME": "Sambhav Shukla",
            "STD_FATHER_NAME": "Satish Chandra Shukla",
            "STD_MOTHER_NAME": "Goldi Shukla",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3532",
            "STD_TC_ISSUE_DATE": "04-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM2MA==&cwid=MjU0OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2903",
            "STD_NAME": "Rashmi ",
            "STD_FATHER_NAME": "Anil Kumar",
            "STD_MOTHER_NAME": "Seeta ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3481",
            "STD_TC_ISSUE_DATE": "04-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU5OA==&cwid=MjU1MQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2876",
            "STD_NAME": "Lakshay ",
            "STD_FATHER_NAME": "Rajender Sharma",
            "STD_MOTHER_NAME": "Poonam Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3530",
            "STD_TC_ISSUE_DATE": "04-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU3MQ==&cwid=MjU1Mw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2923",
            "STD_NAME": "Rupa ",
            "STD_FATHER_NAME": "K S Dubey   Guardian",
            "STD_MOTHER_NAME": "Chandra Mouli",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3534",
            "STD_TC_ISSUE_DATE": "04-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYxOA==&cwid=MjU1NQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2953",
            "STD_NAME": "Aniket Mishra",
            "STD_FATHER_NAME": "Shrinivash Mishra",
            "STD_MOTHER_NAME": "Sarita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3525",
            "STD_TC_ISSUE_DATE": "04-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY0OA==&cwid=MjU1Nw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2892",
            "STD_NAME": "Yash ",
            "STD_FATHER_NAME": "Uma Kant",
            "STD_MOTHER_NAME": "Raj Rani",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3538",
            "STD_TC_ISSUE_DATE": "07-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU4Nw==&cwid=MjU1OQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2962",
            "STD_NAME": "Deepak Kumar Jha",
            "STD_FATHER_NAME": "Shiv Jee Jha",
            "STD_MOTHER_NAME": "Sunaina Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3542",
            "STD_TC_ISSUE_DATE": "07-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY1Nw==&cwid=MjU2MQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2802",
            "STD_NAME": "Kamal Jeet Singh",
            "STD_FATHER_NAME": "Raghubir Singh",
            "STD_MOTHER_NAME": "Kalpana Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3535",
            "STD_TC_ISSUE_DATE": "07-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQ5Nw==&cwid=MjU2Mw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2851",
            "STD_NAME": "Ritu ",
            "STD_FATHER_NAME": "Pramod Kumar",
            "STD_MOTHER_NAME": "Anita Kumari",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3541",
            "STD_TC_ISSUE_DATE": "07-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU0Ng==&cwid=MjU2NQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2794",
            "STD_NAME": "Abhishek Ray",
            "STD_FATHER_NAME": "Dhananjay Ray",
            "STD_MOTHER_NAME": "Poonam Ray",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3546",
            "STD_TC_ISSUE_DATE": "07-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQ4OQ==&cwid=MjU2Nw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1869",
            "STD_NAME": "Ravi Karan",
            "STD_FATHER_NAME": "Rajesh ",
            "STD_MOTHER_NAME": "Late Maya ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "3539",
            "STD_TC_ISSUE_DATE": "07-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM1OQ==&cwid=MjU2OQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2858",
            "STD_NAME": "Aditya Raj",
            "STD_FATHER_NAME": "Keshav Kumar Singh",
            "STD_MOTHER_NAME": "Rinki Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3547",
            "STD_TC_ISSUE_DATE": "13-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU1Mw==&cwid=MjU3MQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2925",
            "STD_NAME": "Meena Bahadur",
            "STD_FATHER_NAME": "Ram Bahadur",
            "STD_MOTHER_NAME": "Sunita Bahadur",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3550",
            "STD_TC_ISSUE_DATE": "13-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYyMA==&cwid=MjU3Mw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2910",
            "STD_NAME": "Dishakha Saini",
            "STD_FATHER_NAME": "Mekchand Saini",
            "STD_MOTHER_NAME": "Laxmi Saini",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3553",
            "STD_TC_ISSUE_DATE": "16-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYwNQ==&cwid=MjU3NQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2972",
            "STD_NAME": "Kunal Madnawat",
            "STD_FATHER_NAME": "Anil Kumar",
            "STD_MOTHER_NAME": "Yogita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3551",
            "STD_TC_ISSUE_DATE": "16-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY2Nw==&cwid=MjU3Nw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2846",
            "STD_NAME": "Gulshan ",
            "STD_FATHER_NAME": "Rampal ",
            "STD_MOTHER_NAME": "Sunita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3556",
            "STD_TC_ISSUE_DATE": "20-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU0MQ==&cwid=MjU3OQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2796",
            "STD_NAME": "Laxmi ",
            "STD_FATHER_NAME": "Ram Lakhan",
            "STD_MOTHER_NAME": "Shiv Dhara",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3560",
            "STD_TC_ISSUE_DATE": "25-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQ5MQ==&cwid=MjU4MQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2888",
            "STD_NAME": "Ketan Chauhan",
            "STD_FATHER_NAME": "Dharamvir Singh",
            "STD_MOTHER_NAME": "Munesh Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3558",
            "STD_TC_ISSUE_DATE": "25-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU4Mw==&cwid=MjU4Mw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2917",
            "STD_NAME": "Jayanti ",
            "STD_FATHER_NAME": "Mukesh Choudhary",
            "STD_MOTHER_NAME": "Nutan Choudhary",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3562",
            "STD_TC_ISSUE_DATE": "26-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYxMg==&cwid=MjU4NQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2926",
            "STD_NAME": "Poonam Verma",
            "STD_FATHER_NAME": "Keshav Verma",
            "STD_MOTHER_NAME": "Chanda Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3564",
            "STD_TC_ISSUE_DATE": "29-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYyMQ==&cwid=MjU4Nw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2845",
            "STD_NAME": "Nishant Kumar Jha",
            "STD_FATHER_NAME": "Hirday Kant Jha",
            "STD_MOTHER_NAME": "Sanju Jha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3563",
            "STD_TC_ISSUE_DATE": "29-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU0MA==&cwid=MjU4OQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2943",
            "STD_NAME": "Varsha Kumar",
            "STD_FATHER_NAME": "Sunil Kumar",
            "STD_MOTHER_NAME": "Saroj Kumar",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3568",
            "STD_TC_ISSUE_DATE": "29-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYzOA==&cwid=MjU5MQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2930",
            "STD_NAME": "Ujala ",
            "STD_FATHER_NAME": "Amar Jyoti Sarmah (Guardian)",
            "STD_MOTHER_NAME": "Devki Pant",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3570",
            "STD_TC_ISSUE_DATE": "30-Oct-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYyNQ==&cwid=MjU5Mw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2944",
            "STD_NAME": "Aditya ",
            "STD_FATHER_NAME": "Devesh Kumar",
            "STD_MOTHER_NAME": "Aneeta Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3572",
            "STD_TC_ISSUE_DATE": "17-Nov-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYzOQ==&cwid=MjU5NQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2929",
            "STD_NAME": "Jatin Negi",
            "STD_FATHER_NAME": "Nariander Singh Negi",
            "STD_MOTHER_NAME": "Manju Negi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3575",
            "STD_TC_ISSUE_DATE": "24-Nov-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYyNA==&cwid=MjU5Nw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3006",
            "STD_NAME": "Faizan Malik",
            "STD_FATHER_NAME": "Salim Muhammad",
            "STD_MOTHER_NAME": "Nasrin Begum",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3577",
            "STD_TC_ISSUE_DATE": "09-Dec-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzcwMQ==&cwid=MjU5OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2576",
            "STD_NAME": "Ritik ",
            "STD_FATHER_NAME": "Dharmender ",
            "STD_MOTHER_NAME": "Saroj ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3581",
            "STD_TC_ISSUE_DATE": "15-Dec-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI1MA==&cwid=MjYwMQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2941",
            "STD_NAME": "Nitin Kumar",
            "STD_FATHER_NAME": "Ghanshyam ",
            "STD_MOTHER_NAME": "Revti Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3578",
            "STD_TC_ISSUE_DATE": "15-Dec-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYzNg==&cwid=MjYwMw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2964",
            "STD_NAME": "Kunal ",
            "STD_FATHER_NAME": "Amar Jyoti  Sarmah",
            "STD_MOTHER_NAME": "Manju Bala  Panda",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "3518",
            "STD_TC_ISSUE_DATE": "21-Sep-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY1OQ==&cwid=MjYwNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1294",
            "STD_NAME": "Princy ",
            "STD_FATHER_NAME": "Balkishan Ram",
            "STD_MOTHER_NAME": "Tara Devi",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3582",
            "STD_TC_ISSUE_DATE": "23-Dec-2021",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTczOQ==&cwid=MjYwNw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/271",
            "STD_NAME": "Nishtha Pant",
            "STD_FATHER_NAME": "Ravindra Kumar",
            "STD_MOTHER_NAME": "Devki Pant",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3588",
            "STD_TC_ISSUE_DATE": "21-Feb-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQ5MA==&cwid=MjYwOQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/253",
            "STD_NAME": "Priya ",
            "STD_FATHER_NAME": "Jaipal ",
            "STD_MOTHER_NAME": "Kiran ",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3585",
            "STD_TC_ISSUE_DATE": "21-Feb-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQ3Mg==&cwid=MjYxMQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1391",
            "STD_NAME": "Kritika Sharma",
            "STD_FATHER_NAME": "Rajkumar Sharma",
            "STD_MOTHER_NAME": "Savita Sharma",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "3589",
            "STD_TC_ISSUE_DATE": "21-Feb-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg0Mw==&cwid=MjYxMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/695",
            "STD_NAME": "Anubhav Bhardwaj",
            "STD_FATHER_NAME": "Sanjeev ",
            "STD_MOTHER_NAME": "Anita ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3590",
            "STD_TC_ISSUE_DATE": "23-Feb-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NTU=&cwid=MjYxNQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2795",
            "STD_NAME": "Ishita ",
            "STD_FATHER_NAME": "Rajiv Kumar Sharma",
            "STD_MOTHER_NAME": "Pratibha ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3593",
            "STD_TC_ISSUE_DATE": "09-Mar-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQ5MA==&cwid=MjYxNw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1304",
            "STD_NAME": "Asmita ",
            "STD_FATHER_NAME": "Rajender Prasad",
            "STD_MOTHER_NAME": "Chinta Devi",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3598",
            "STD_TC_ISSUE_DATE": "24-Mar-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc0OQ==&cwid=MjYxOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2602",
            "STD_NAME": "Namish Gaurav",
            "STD_FATHER_NAME": "Maneesh  Kumar Gaurav",
            "STD_MOTHER_NAME": "Poonam ",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "3601",
            "STD_TC_ISSUE_DATE": "24-Mar-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzI3Ng==&cwid=MjYyMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/28",
            "STD_NAME": "Ishana Bansal",
            "STD_FATHER_NAME": "Hardeep Kumar",
            "STD_MOTHER_NAME": "Vinita Bansal",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "3595",
            "STD_TC_ISSUE_DATE": "15-Mar-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ1OQ==&cwid=MjYyMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2667",
            "STD_NAME": "Nehal Sharma",
            "STD_FATHER_NAME": "Gaurav Sharma",
            "STD_MOTHER_NAME": "Ruma Sharma",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3596",
            "STD_TC_ISSUE_DATE": "21-Mar-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM2Mg==&cwid=MjYyNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/7",
            "STD_NAME": "Aprameya Rana",
            "STD_FATHER_NAME": "Anup Kumar Rana",
            "STD_MOTHER_NAME": "Nisha Rana",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "3603",
            "STD_TC_ISSUE_DATE": "28-Mar-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA1MQ==&cwid=MjYyNw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2657",
            "STD_NAME": "Kanik ",
            "STD_FATHER_NAME": "Rahul Bhadana",
            "STD_MOTHER_NAME": "Harita ",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3606",
            "STD_TC_ISSUE_DATE": "30-Mar-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM1Mg==&cwid=MjYyOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2523",
            "STD_NAME": "Neha Kumari",
            "STD_FATHER_NAME": "Ramesh Varma",
            "STD_MOTHER_NAME": "Pramila Devi",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3610",
            "STD_TC_ISSUE_DATE": "06-Apr-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE5Nw==&cwid=MjYzMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3127",
            "STD_NAME": "Vedanshi ",
            "STD_FATHER_NAME": "Naresh Prakash",
            "STD_MOTHER_NAME": "Madhu Bala ",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "3612",
            "STD_TC_ISSUE_DATE": "06-Apr-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzgyMg==&cwid=MjYzMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/76",
            "STD_NAME": "Pari Tanwar",
            "STD_FATHER_NAME": "Pardeep Tanwar",
            "STD_MOTHER_NAME": "Sushma Devi",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3609",
            "STD_TC_ISSUE_DATE": "06-Apr-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc0MQ==&cwid=MjYzNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3002",
            "STD_NAME": "Aryan Gound",
            "STD_FATHER_NAME": "Ramesh Kumar",
            "STD_MOTHER_NAME": "Archana Gaud",
            "STD_LAST_CLASS": "UKG",
            "STD_TCNO": "3613",
            "STD_TC_ISSUE_DATE": "07-Apr-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY5Nw==&cwid=MjYzNw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2692",
            "STD_NAME": "Rishika ",
            "STD_FATHER_NAME": "Vikrant ",
            "STD_MOTHER_NAME": "Karabi ",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3617",
            "STD_TC_ISSUE_DATE": "16-Apr-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM4Nw==&cwid=MjYzOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2243",
            "STD_NAME": "Sonam Kumari",
            "STD_FATHER_NAME": "Late Arjun ",
            "STD_MOTHER_NAME": "Late Reeta ",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "3622",
            "STD_TC_ISSUE_DATE": "20-Apr-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg4Mg==&cwid=MjY0MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1939",
            "STD_NAME": "Priyanka ",
            "STD_FATHER_NAME": "Late Raju ",
            "STD_MOTHER_NAME": "Late Konika Chakravarty",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3624",
            "STD_TC_ISSUE_DATE": "20-Apr-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQyOQ==&cwid=MjY0Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1935",
            "STD_NAME": "Meena ",
            "STD_FATHER_NAME": "Late Krishna ",
            "STD_MOTHER_NAME": "Late Monika ",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "3626",
            "STD_TC_ISSUE_DATE": "20-Apr-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQyNQ==&cwid=MjY0NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2302",
            "STD_NAME": "Anosh Massey",
            "STD_FATHER_NAME": "Ravi Massey",
            "STD_MOTHER_NAME": "Ribka Massey",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "3619",
            "STD_TC_ISSUE_DATE": "20-Apr-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk0MQ==&cwid=MjY0Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1301",
            "STD_NAME": "Vasundhra ",
            "STD_FATHER_NAME": "Bechu Prasad",
            "STD_MOTHER_NAME": "Nirmala Devi",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3627",
            "STD_TC_ISSUE_DATE": "20-Apr-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc0Ng==&cwid=MjY0OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2671",
            "STD_NAME": "Vansh ",
            "STD_FATHER_NAME": "Satya Parkash",
            "STD_MOTHER_NAME": "Rekha ",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "3629",
            "STD_TC_ISSUE_DATE": "29-Apr-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM2Ng==&cwid=MjY1MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/2993",
            "STD_NAME": "Mayank Mishra",
            "STD_FATHER_NAME": "Dhairju Kumar Mishra",
            "STD_MOTHER_NAME": "Kanchan Mishra",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "3634",
            "STD_TC_ISSUE_DATE": "19-May-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY4OA==&cwid=MjY1Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2687",
            "STD_NAME": "Prachi  Tomar",
            "STD_FATHER_NAME": "Pramod Singh",
            "STD_MOTHER_NAME": "Santoshi Tomar",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3637",
            "STD_TC_ISSUE_DATE": "06-Jun-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM4Mg==&cwid=MjY1NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/17",
            "STD_NAME": "Jigyasha ",
            "STD_FATHER_NAME": "Jasbeer ",
            "STD_MOTHER_NAME": "Pinki ",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3638",
            "STD_TC_ISSUE_DATE": "22-Jul-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA2MQ==&cwid=MjY1Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3059",
            "STD_NAME": "Rudrakshi ",
            "STD_FATHER_NAME": "Mukesh Kumar",
            "STD_MOTHER_NAME": "Rajni Rani",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3646",
            "STD_TC_ISSUE_DATE": "05-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc1NA==&cwid=MjY1OQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3045",
            "STD_NAME": "Hinaz Khan",
            "STD_FATHER_NAME": "Mohammad Habib Khan",
            "STD_MOTHER_NAME": "Chandni Khan",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3648",
            "STD_TC_ISSUE_DATE": "05-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc0MA==&cwid=MjY2MQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/8",
            "STD_NAME": "Lucky Singh",
            "STD_FATHER_NAME": "Ravi Pratap Gingh",
            "STD_MOTHER_NAME": "Geeta Singh",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3649",
            "STD_TC_ISSUE_DATE": "05-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjExNw==&cwid=MjY2Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/537",
            "STD_NAME": "Ashish Arvind Jha",
            "STD_FATHER_NAME": "Arvind Kumar Jha",
            "STD_MOTHER_NAME": "Neetu Arvind Jha",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3651",
            "STD_TC_ISSUE_DATE": "05-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY=&cwid=MjY2NQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1741",
            "STD_NAME": "Asif  Ali",
            "STD_FATHER_NAME": "Mazid  Ali",
            "STD_MOTHER_NAME": "Sazida Parveen",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3645",
            "STD_TC_ISSUE_DATE": "05-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjIzMQ==&cwid=MjY2Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2899",
            "STD_NAME": "Rajesh Kumar",
            "STD_FATHER_NAME": "Madan Prasad",
            "STD_MOTHER_NAME": "Sheela Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "3644",
            "STD_TC_ISSUE_DATE": "05-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU5NA==&cwid=MjY2OQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/366",
            "STD_NAME": "Beenish Jahan",
            "STD_FATHER_NAME": "Guldraz Ahmed",
            "STD_MOTHER_NAME": "Kishwar  Firdaus",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3653",
            "STD_TC_ISSUE_DATE": "08-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTAw&cwid=MjY3MQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3049",
            "STD_NAME": "Gaurav Dhiman",
            "STD_FATHER_NAME": "Davinder Dhiman",
            "STD_MOTHER_NAME": "Gurjeet  Kaur",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3658",
            "STD_TC_ISSUE_DATE": "10-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc0NA==&cwid=MjY3Mw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1670",
            "STD_NAME": "Krishna Rajvansh",
            "STD_FATHER_NAME": "Prem Kumar",
            "STD_MOTHER_NAME": "Mamta ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3661",
            "STD_TC_ISSUE_DATE": "10-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE2MA==&cwid=MjY3NQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2514",
            "STD_NAME": "Aparna Kaushik",
            "STD_FATHER_NAME": "Sulekh Chand",
            "STD_MOTHER_NAME": "Anuradha ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3664",
            "STD_TC_ISSUE_DATE": "10-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE4OA==&cwid=MjY3Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3055",
            "STD_NAME": "Rajat Diwakar",
            "STD_FATHER_NAME": "Mansingh ",
            "STD_MOTHER_NAME": "Neetu Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3655",
            "STD_TC_ISSUE_DATE": "10-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc1MA==&cwid=MjY3OQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3056",
            "STD_NAME": "Deepanshu Singh",
            "STD_FATHER_NAME": "Jagan Singh",
            "STD_MOTHER_NAME": "Chanda Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3656",
            "STD_TC_ISSUE_DATE": "10-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc1MQ==&cwid=MjY4MQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2140",
            "STD_NAME": "Anurag Singh",
            "STD_FATHER_NAME": "Santosh Kumar Singh",
            "STD_MOTHER_NAME": "Babita Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3669",
            "STD_TC_ISSUE_DATE": "17-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc3OQ==&cwid=MjY4Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2419",
            "STD_NAME": "Shaurya Kumar Maurya",
            "STD_FATHER_NAME": "Sandeep Kumar Maurya",
            "STD_MOTHER_NAME": "Sunita Maurya",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3666",
            "STD_TC_ISSUE_DATE": "17-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA5Mw==&cwid=MjY4NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/347",
            "STD_NAME": "Kashvi Yadav",
            "STD_FATHER_NAME": "Yadvender Singh Yadav",
            "STD_MOTHER_NAME": "Saroj Yadav",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3668",
            "STD_TC_ISSUE_DATE": "17-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTEw&cwid=MjY4Nw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/628",
            "STD_NAME": "Siddharth ",
            "STD_FATHER_NAME": "Bipin Kumar",
            "STD_MOTHER_NAME": "Anju Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3683",
            "STD_TC_ISSUE_DATE": "17-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjAw&cwid=MjY4OQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/399",
            "STD_NAME": "Kashvi ",
            "STD_FATHER_NAME": "Gaurav Vats",
            "STD_MOTHER_NAME": "Shivangi ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3670",
            "STD_TC_ISSUE_DATE": "17-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTM2&cwid=MjY5MQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3078",
            "STD_NAME": "Joy Majumdar",
            "STD_FATHER_NAME": "Ashok Majumdar",
            "STD_MOTHER_NAME": "Asha Majumdar",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3671",
            "STD_TC_ISSUE_DATE": "17-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc3Mw==&cwid=MjY5Mw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2539",
            "STD_NAME": "Shifa ",
            "STD_FATHER_NAME": "Mahfooz  Husain",
            "STD_MOTHER_NAME": "Fatima Khatoon",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3682",
            "STD_TC_ISSUE_DATE": "17-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIxMw==&cwid=MjY5NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2169",
            "STD_NAME": "Ajay ",
            "STD_FATHER_NAME": "Rameshwar ",
            "STD_MOTHER_NAME": "Savitri ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3674",
            "STD_TC_ISSUE_DATE": "17-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjgwOA==&cwid=MjY5Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1895",
            "STD_NAME": "Deshraj Meena",
            "STD_FATHER_NAME": "Phool  Chand Meena",
            "STD_MOTHER_NAME": "Geeta Meena",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3676",
            "STD_TC_ISSUE_DATE": "17-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM4NQ==&cwid=MjY5OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3066",
            "STD_NAME": "Komal Singh",
            "STD_FATHER_NAME": "Jitender ",
            "STD_MOTHER_NAME": "Reena ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3680",
            "STD_TC_ISSUE_DATE": "17-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc2MQ==&cwid=MjcwMQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2273",
            "STD_NAME": "Ritesh Luthra",
            "STD_FATHER_NAME": "Rajesh Luthra",
            "STD_MOTHER_NAME": "Ritu Luthra",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3685",
            "STD_TC_ISSUE_DATE": "17-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjkxMg==&cwid=MjcwMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1632",
            "STD_NAME": "Rajnandni ",
            "STD_FATHER_NAME": "Krishan Lal ",
            "STD_MOTHER_NAME": "Lalti  Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3688",
            "STD_TC_ISSUE_DATE": "18-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjA4NA==&cwid=MjcwNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2670",
            "STD_NAME": "Rahul Kumar Ray",
            "STD_FATHER_NAME": "Rajiv Kumar Ray",
            "STD_MOTHER_NAME": "Punam Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3701",
            "STD_TC_ISSUE_DATE": "22-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM2NQ==&cwid=MjcwNw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2521",
            "STD_NAME": "Vidyanand Yadav",
            "STD_FATHER_NAME": "Munna Yadav",
            "STD_MOTHER_NAME": "Geeta Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3703",
            "STD_TC_ISSUE_DATE": "22-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE5NQ==&cwid=MjcwOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/799",
            "STD_NAME": "Riya Tomer",
            "STD_FATHER_NAME": "Narender Singh ",
            "STD_MOTHER_NAME": "Rashmi ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3687",
            "STD_TC_ISSUE_DATE": "22-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTE5&cwid=MjcxMQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1031",
            "STD_NAME": "Mahenoor Sayyed",
            "STD_FATHER_NAME": "Suheal Ahmed Shafiq Sayyed",
            "STD_MOTHER_NAME": "Azra Khatoon",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3690",
            "STD_TC_ISSUE_DATE": "22-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTI3&cwid=MjcxMw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/92",
            "STD_NAME": "Jatin Parashar",
            "STD_FATHER_NAME": "Dinesh ",
            "STD_MOTHER_NAME": "Rajni ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3689",
            "STD_TC_ISSUE_DATE": "22-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc1Nw==&cwid=MjcxNQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2483",
            "STD_NAME": "Gungun ",
            "STD_FATHER_NAME": "Rajkumar ",
            "STD_MOTHER_NAME": "Meena ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3695",
            "STD_TC_ISSUE_DATE": "22-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE1Nw==&cwid=MjcxNw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2511",
            "STD_NAME": "Harsh Kumar",
            "STD_FATHER_NAME": "Rajeev Poddar",
            "STD_MOTHER_NAME": "Anita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3691",
            "STD_TC_ISSUE_DATE": "22-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE4NQ==&cwid=MjcxOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3076",
            "STD_NAME": "Swati ",
            "STD_FATHER_NAME": "Hemant Kumar",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3696",
            "STD_TC_ISSUE_DATE": "22-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc3MQ==&cwid=MjcyMQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/711",
            "STD_NAME": "Pranjal Kapil",
            "STD_FATHER_NAME": "Manoj Jyoti Kapil",
            "STD_MOTHER_NAME": "Nirdesh Kapil",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3705",
            "STD_TC_ISSUE_DATE": "23-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQz&cwid=MjcyMw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1361",
            "STD_NAME": "Saksham Kumar Gupta",
            "STD_FATHER_NAME": "Suresh Kumar Gupta",
            "STD_MOTHER_NAME": "Indu Gupta",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3706",
            "STD_TC_ISSUE_DATE": "23-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTgxMw==&cwid=MjcyNQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/408",
            "STD_NAME": "Manish Chaprana",
            "STD_FATHER_NAME": "Jaiveer Chaprana",
            "STD_MOTHER_NAME": "Alka ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3716",
            "STD_TC_ISSUE_DATE": "27-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQw&cwid=MjcyNw==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/62",
            "STD_NAME": "Sunny Singh",
            "STD_FATHER_NAME": "Prem Nath",
            "STD_MOTHER_NAME": "Reena Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3718",
            "STD_TC_ISSUE_DATE": "27-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTI4MA==&cwid=MjcyOQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1894",
            "STD_NAME": "Gaurav ",
            "STD_FATHER_NAME": "Sanju Singh",
            "STD_MOTHER_NAME": "Sonia Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3719",
            "STD_TC_ISSUE_DATE": "27-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM4NA==&cwid=MjczMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3048",
            "STD_NAME": "Gulshan  Kumar",
            "STD_FATHER_NAME": "Gajender  Chaudhary ",
            "STD_MOTHER_NAME": "Rani  Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3714",
            "STD_TC_ISSUE_DATE": "27-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc0Mw==&cwid=MjczMw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3037",
            "STD_NAME": "Avinash Yadav",
            "STD_FATHER_NAME": "Nagender  Yadav",
            "STD_MOTHER_NAME": "Anita  Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3715",
            "STD_TC_ISSUE_DATE": "27-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzczMg==&cwid=MjczNQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3075",
            "STD_NAME": "Aayush Shakya",
            "STD_FATHER_NAME": "Jitender Kumar",
            "STD_MOTHER_NAME": "Shashi  Prabha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3710",
            "STD_TC_ISSUE_DATE": "27-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc3MA==&cwid=MjczNw==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2341",
            "STD_NAME": "Sakshi Rai",
            "STD_FATHER_NAME": "Shailesh Rai",
            "STD_MOTHER_NAME": "Sandhya Rai",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3723",
            "STD_TC_ISSUE_DATE": "02-Sep-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjk4MA==&cwid=MjczOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1",
            "STD_NAME": "Stephen L Mashee",
            "STD_FATHER_NAME": "Sunil  Mashee",
            "STD_MOTHER_NAME": "Martha ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3722",
            "STD_TC_ISSUE_DATE": "02-Sep-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQzMg==&cwid=Mjc0MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2952",
            "STD_NAME": "Bhivu ",
            "STD_FATHER_NAME": "Abdhesh Kumar Jha",
            "STD_MOTHER_NAME": "Rupa Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3726",
            "STD_TC_ISSUE_DATE": "03-Sep-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY0Nw==&cwid=Mjc0Mw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2443",
            "STD_NAME": "Shivam Kumar",
            "STD_FATHER_NAME": "Moolchand ",
            "STD_MOTHER_NAME": "Rita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3731",
            "STD_TC_ISSUE_DATE": "07-Sep-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzExNw==&cwid=Mjc0NQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3058",
            "STD_NAME": "Sweta Bharti",
            "STD_FATHER_NAME": "Shambhu Kumar Mahto",
            "STD_MOTHER_NAME": "Pinky Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3736",
            "STD_TC_ISSUE_DATE": "07-Sep-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc1Mw==&cwid=Mjc0Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/650",
            "STD_NAME": "Aditi ",
            "STD_FATHER_NAME": "Amar Jyoti Sarmah Guardian",
            "STD_MOTHER_NAME": "Jyotsna Behura",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3733",
            "STD_TC_ISSUE_DATE": "07-Sep-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTI5&cwid=Mjc0OQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/565",
            "STD_NAME": "Anjum Parveen",
            "STD_FATHER_NAME": "Md Sajjad Alam",
            "STD_MOTHER_NAME": "Parveen Khatoon",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3728",
            "STD_TC_ISSUE_DATE": "07-Sep-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTk=&cwid=Mjc1MQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3107",
            "STD_NAME": "Rishabh Singh",
            "STD_FATHER_NAME": "Shailesh Kumar Singh",
            "STD_MOTHER_NAME": "Pratima Singh",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3737",
            "STD_TC_ISSUE_DATE": "08-Sep-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzgwMg==&cwid=Mjc1Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3082",
            "STD_NAME": "Saloni ",
            "STD_FATHER_NAME": "Dhananjay Kumar Tiwari",
            "STD_MOTHER_NAME": "Priyanka Tiwari",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3744",
            "STD_TC_ISSUE_DATE": "12-Sep-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc3Nw==&cwid=Mjc1NQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1866",
            "STD_NAME": "Kushant ",
            "STD_FATHER_NAME": "Late Rohtash ",
            "STD_MOTHER_NAME": "Babli ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3742",
            "STD_TC_ISSUE_DATE": "12-Sep-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM1Ng==&cwid=Mjc1Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/462",
            "STD_NAME": "Abhay ",
            "STD_FATHER_NAME": "Late Shri Bhagvan ",
            "STD_MOTHER_NAME": "Prem Lata ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3739",
            "STD_TC_ISSUE_DATE": "12-Sep-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTgw&cwid=Mjc1OQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/36",
            "STD_NAME": "Himanshu Pawar",
            "STD_FATHER_NAME": "Rakesh Kumar",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3745",
            "STD_TC_ISSUE_DATE": "14-Sep-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjcwMQ==&cwid=Mjc2MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/252",
            "STD_NAME": "Pooja ",
            "STD_FATHER_NAME": "Mr J.N Kaul",
            "STD_MOTHER_NAME": "Sunita Jadoun",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3748",
            "STD_TC_ISSUE_DATE": "01-Oct-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQ3MQ==&cwid=Mjc2Mw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1649",
            "STD_NAME": "Bimlesh ",
            "STD_FATHER_NAME": "Rajender Gautam",
            "STD_MOTHER_NAME": "Nema Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3749",
            "STD_TC_ISSUE_DATE": "01-Oct-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjEwMQ==&cwid=Mjc2NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3044",
            "STD_NAME": "Abhay ",
            "STD_FATHER_NAME": "Ravinder Kumar",
            "STD_MOTHER_NAME": "Rachna ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3753",
            "STD_TC_ISSUE_DATE": "19-Oct-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzczOQ==&cwid=Mjc2Nw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3088",
            "STD_NAME": "Khushnuma Khatoon",
            "STD_FATHER_NAME": "Mani Hussain",
            "STD_MOTHER_NAME": "Sanjana ",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "3756",
            "STD_TC_ISSUE_DATE": "09-Nov-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc4Mw==&cwid=Mjc2OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1585",
            "STD_NAME": "Indra Kaul",
            "STD_FATHER_NAME": "Late Sh. J.N. Kaul",
            "STD_MOTHER_NAME": "Molly Mathew",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3759",
            "STD_TC_ISSUE_DATE": "30-Aug-2022",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjAzNw==&cwid=Mjc3MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/20",
            "STD_NAME": "Akshat Sharma",
            "STD_FATHER_NAME": "Sanjeev Sharma",
            "STD_MOTHER_NAME": "Pooja Sharma",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3763",
            "STD_TC_ISSUE_DATE": "24-Feb-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY4NQ==&cwid=Mjc3Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2480",
            "STD_NAME": "Vaishnavi ",
            "STD_FATHER_NAME": "Aman Shukla",
            "STD_MOTHER_NAME": "Kavita Shukla",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "3770",
            "STD_TC_ISSUE_DATE": "13-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE1NA==&cwid=Mjc3NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3180",
            "STD_NAME": "Ayush Pratap Singh",
            "STD_FATHER_NAME": "Sanjeet Singh",
            "STD_MOTHER_NAME": "Shobha Singh",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3769",
            "STD_TC_ISSUE_DATE": "13-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzg3NQ==&cwid=Mjc3Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3271",
            "STD_NAME": "Avni Gautam",
            "STD_FATHER_NAME": "Ravi Kant Gautam",
            "STD_MOTHER_NAME": "Soniya Gautam",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "3779",
            "STD_TC_ISSUE_DATE": "13-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDAwOA==&cwid=Mjc3OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/13",
            "STD_NAME": "Tanmay Kumar Jain",
            "STD_FATHER_NAME": "Gaurav Jain",
            "STD_MOTHER_NAME": "Sonia Jain",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "3780",
            "STD_TC_ISSUE_DATE": "13-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzk0NQ==&cwid=Mjc4MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/12",
            "STD_NAME": "Yuvanshi ",
            "STD_FATHER_NAME": "Rambir ",
            "STD_MOTHER_NAME": "Seema  ",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3781",
            "STD_TC_ISSUE_DATE": "13-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzk0NA==&cwid=Mjc4Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/14",
            "STD_NAME": "Aarav Kumar Jain",
            "STD_FATHER_NAME": "Gaurav Jain",
            "STD_MOTHER_NAME": "Sonia Jain",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3783",
            "STD_TC_ISSUE_DATE": "13-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzk0Ng==&cwid=Mjc4NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/2985",
            "STD_NAME": "Harshit Rawat",
            "STD_FATHER_NAME": "Gaurav Rawat",
            "STD_MOTHER_NAME": "Priyanka ",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "3777",
            "STD_TC_ISSUE_DATE": "13-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY4MA==&cwid=Mjc4Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/8",
            "STD_NAME": "Bhavesh Bhardwaj",
            "STD_FATHER_NAME": "Sanjay Bhardwaj",
            "STD_MOTHER_NAME": "Rajbala Bhardwaj",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3774",
            "STD_TC_ISSUE_DATE": "15-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA1Mg==&cwid=Mjc4OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1623",
            "STD_NAME": "Sameer ",
            "STD_FATHER_NAME": "Rais Khan",
            "STD_MOTHER_NAME": "Rozi Khatun",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3768",
            "STD_TC_ISSUE_DATE": "15-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjA3NQ==&cwid=Mjc5MQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3343",
            "STD_NAME": "Ram Kumar",
            "STD_FATHER_NAME": "Vinod   Kumar",
            "STD_MOTHER_NAME": "Late Gitanjali Devi",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "3802",
            "STD_TC_ISSUE_DATE": "25-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDA4MA==&cwid=Mjc5Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3105",
            "STD_NAME": "Pravesh Singh",
            "STD_FATHER_NAME": "Charan Singh",
            "STD_MOTHER_NAME": "Bhagwati ",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "3794",
            "STD_TC_ISSUE_DATE": "25-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzgwMA==&cwid=Mjc5NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3171",
            "STD_NAME": "Heena ",
            "STD_FATHER_NAME": "Amar Jyoti Sarmah",
            "STD_MOTHER_NAME": "Sabana  Ramjani",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "3798",
            "STD_TC_ISSUE_DATE": "25-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzg2Ng==&cwid=Mjc5Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2713",
            "STD_NAME": "Dev Raj",
            "STD_FATHER_NAME": "Amar Jyoti Sarmah",
            "STD_MOTHER_NAME": ".Meena  Pandey",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "3792",
            "STD_TC_ISSUE_DATE": "25-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQwOA==&cwid=Mjc5OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1941",
            "STD_NAME": "Tamanna ",
            "STD_FATHER_NAME": "Naresh Kumar",
            "STD_MOTHER_NAME": "Geeta ",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3791",
            "STD_TC_ISSUE_DATE": "25-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQzMQ==&cwid=MjgwMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3096",
            "STD_NAME": "Naitik ",
            "STD_FATHER_NAME": "Rajesh ",
            "STD_MOTHER_NAME": "Savita Mohnty",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "3797",
            "STD_TC_ISSUE_DATE": "25-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc5MQ==&cwid=MjgwMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3093",
            "STD_NAME": "Navya ",
            "STD_FATHER_NAME": "Rajesh ",
            "STD_MOTHER_NAME": "Savita Mohnty",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3795",
            "STD_TC_ISSUE_DATE": "25-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc4OA==&cwid=MjgwNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/269",
            "STD_NAME": "Puneet Singh",
            "STD_FATHER_NAME": "Amar Jyoti Sarmah ",
            "STD_MOTHER_NAME": "Reena Chatterjee",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3785",
            "STD_TC_ISSUE_DATE": "25-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQ4OA==&cwid=MjgwNw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1873",
            "STD_NAME": "Sachin ",
            "STD_FATHER_NAME": "Horilal ",
            "STD_MOTHER_NAME": "Manju ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3788",
            "STD_TC_ISSUE_DATE": "25-Apr-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM2Mw==&cwid=MjgwOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3404",
            "STD_NAME": "Krish Baisla",
            "STD_FATHER_NAME": "Neeraj Baisla",
            "STD_MOTHER_NAME": "Anita Baisla",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "3772",
            "STD_TC_ISSUE_DATE": "04-May-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDE0MQ==&cwid=MjgxMQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2961",
            "STD_NAME": "Daksh ",
            "STD_FATHER_NAME": "Hari Chand",
            "STD_MOTHER_NAME": "Santosh ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3803",
            "STD_TC_ISSUE_DATE": "04-May-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY1Ng==&cwid=MjgxMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/35",
            "STD_NAME": "Preksha Parashar",
            "STD_FATHER_NAME": "Parveen Kumar",
            "STD_MOTHER_NAME": "Geeta Sharma",
            "STD_LAST_CLASS": "UKG",
            "STD_TCNO": "3805",
            "STD_TC_ISSUE_DATE": "08-May-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzk2Nw==&cwid=MjgxNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/56",
            "STD_NAME": "Ayush Kumar",
            "STD_FATHER_NAME": "Mahavir ",
            "STD_MOTHER_NAME": "Geeta ",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3808",
            "STD_TC_ISSUE_DATE": "15-May-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTU1Nw==&cwid=MjgxNw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3338",
            "STD_NAME": "Ishaan ",
            "STD_FATHER_NAME": "Mukesh ",
            "STD_MOTHER_NAME": "Shilpi Devi",
            "STD_LAST_CLASS": "NUR",
            "STD_TCNO": "3811",
            "STD_TC_ISSUE_DATE": "30-May-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDA3NQ==&cwid=MjgxOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/81",
            "STD_NAME": "Jaishvi Vats",
            "STD_FATHER_NAME": "Gaurav Vats",
            "STD_MOTHER_NAME": "Shivangi Vats",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3814",
            "STD_TC_ISSUE_DATE": "30-May-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTI5OQ==&cwid=MjgyMQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/829",
            "STD_NAME": "Krishna Rawat",
            "STD_FATHER_NAME": "Raj Bahadur Singh Rawat",
            "STD_MOTHER_NAME": "Bimla Rawat",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3813",
            "STD_TC_ISSUE_DATE": "30-May-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OQ==&cwid=MjgyMw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3079",
            "STD_NAME": "Shushank Tripathi",
            "STD_FATHER_NAME": "Digvijay ",
            "STD_MOTHER_NAME": "Neelam ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3815",
            "STD_TC_ISSUE_DATE": "06-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc3NA==&cwid=MjgyNQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/622",
            "STD_NAME": "Eshaa Shukla",
            "STD_FATHER_NAME": "Nilanjan ",
            "STD_MOTHER_NAME": "Anuradha Rai Shukla",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3817",
            "STD_TC_ISSUE_DATE": "14-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NzQ=&cwid=MjgyNw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/37",
            "STD_NAME": "Sushant Dubey",
            "STD_FATHER_NAME": "Anil Kumar Dubey",
            "STD_MOTHER_NAME": "Reena ",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "3820",
            "STD_TC_ISSUE_DATE": "16-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjcwMg==&cwid=MjgyOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1287",
            "STD_NAME": "Yash Athang",
            "STD_FATHER_NAME": "Amar Jyoti  Sarmah Guardian",
            "STD_MOTHER_NAME": "Anjali Das",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3822",
            "STD_TC_ISSUE_DATE": "16-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTczMg==&cwid=MjgzMQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2743",
            "STD_NAME": "Prince Shahi",
            "STD_FATHER_NAME": "Vijay Kumar",
            "STD_MOTHER_NAME": "Rama Shahi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3824",
            "STD_TC_ISSUE_DATE": "17-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQzOA==&cwid=MjgzMw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2714",
            "STD_NAME": "Rohit ",
            "STD_FATHER_NAME": "Amar Jyoti Sarmah",
            "STD_MOTHER_NAME": "Sonia ",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "3829",
            "STD_TC_ISSUE_DATE": "17-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQwOQ==&cwid=MjgzNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2866",
            "STD_NAME": "Ganpati Singh Chouhan",
            "STD_FATHER_NAME": "Jai Shankar Prasad Singh",
            "STD_MOTHER_NAME": "Rangeeta Kumari",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3826",
            "STD_TC_ISSUE_DATE": "17-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU2MQ==&cwid=MjgzNw==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2719",
            "STD_NAME": "Yash Sharma",
            "STD_FATHER_NAME": "Bhagwati Prasad Sharma",
            "STD_MOTHER_NAME": "Suman Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3830",
            "STD_TC_ISSUE_DATE": "19-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQxNA==&cwid=MjgzOQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2633",
            "STD_NAME": "Prashant Gupta",
            "STD_FATHER_NAME": "Sudhir Kumar Gupta",
            "STD_MOTHER_NAME": "Nanda  Rani",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3835",
            "STD_TC_ISSUE_DATE": "21-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzMwNw==&cwid=Mjg0MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/33",
            "STD_NAME": "Bhavishya Kaushik",
            "STD_FATHER_NAME": "Vijay Kumar Kaushik",
            "STD_MOTHER_NAME": "Nisha Kaushik",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3833",
            "STD_TC_ISSUE_DATE": "21-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA3Nw==&cwid=Mjg0Mw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/31",
            "STD_NAME": "Abhay  Pant",
            "STD_FATHER_NAME": "Ravinder Kumar Pant",
            "STD_MOTHER_NAME": "Kamla Pant",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3841",
            "STD_TC_ISSUE_DATE": "22-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA3NQ==&cwid=Mjg0NQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/4",
            "STD_NAME": "Prashant Kumar Jha",
            "STD_FATHER_NAME": "Hirday Kant Jha",
            "STD_MOTHER_NAME": "Sanju Jha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3839",
            "STD_TC_ISSUE_DATE": "22-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY2OQ==&cwid=Mjg0Nw==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2501",
            "STD_NAME": "Sumit Sharma",
            "STD_FATHER_NAME": "Mahesh Chand",
            "STD_MOTHER_NAME": "Geeta Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3837",
            "STD_TC_ISSUE_DATE": "22-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE3NQ==&cwid=Mjg0OQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2894",
            "STD_NAME": "Md Shahanwaj ",
            "STD_FATHER_NAME": "Md Firoj Udin",
            "STD_MOTHER_NAME": "Roshan Khatun",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3842",
            "STD_TC_ISSUE_DATE": "22-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU4OQ==&cwid=Mjg1MQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/12",
            "STD_NAME": "Aarush Kaushik",
            "STD_FATHER_NAME": "Rakesh Kumar Sharma",
            "STD_MOTHER_NAME": "Shashi Kant",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3844",
            "STD_TC_ISSUE_DATE": "30-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA1Ng==&cwid=Mjg1Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2916",
            "STD_NAME": "Anshu Kumar",
            "STD_FATHER_NAME": "Shashi Bhushan Prasad",
            "STD_MOTHER_NAME": "Suman Prabha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3845",
            "STD_TC_ISSUE_DATE": "30-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzYxMQ==&cwid=Mjg1NQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2512",
            "STD_NAME": "Mayank Sharma",
            "STD_FATHER_NAME": "Mahesh Chand",
            "STD_MOTHER_NAME": "Geeta ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3854",
            "STD_TC_ISSUE_DATE": "30-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE4Ng==&cwid=Mjg1Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/20",
            "STD_NAME": "Saksham Singh",
            "STD_FATHER_NAME": "Uday Pratap  Singh",
            "STD_MOTHER_NAME": "Meenu  Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3850",
            "STD_TC_ISSUE_DATE": "30-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA2NA==&cwid=Mjg1OQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1588",
            "STD_NAME": "Ramyata Kaul",
            "STD_FATHER_NAME": "Amar Jyoti Sarmah Guardian",
            "STD_MOTHER_NAME": "Poonam ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3855",
            "STD_TC_ISSUE_DATE": "30-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjA0MA==&cwid=Mjg2MQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2701",
            "STD_NAME": "Gautam Jha",
            "STD_FATHER_NAME": "Viveka Nand  Jha",
            "STD_MOTHER_NAME": "Renu Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3851",
            "STD_TC_ISSUE_DATE": "30-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM5Ng==&cwid=Mjg2Mw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2842",
            "STD_NAME": "Sakshi Rai",
            "STD_FATHER_NAME": "Pashupati Nath Rai",
            "STD_MOTHER_NAME": "Sangeeta Rai",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3853",
            "STD_TC_ISSUE_DATE": "30-Jun-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzUzNw==&cwid=Mjg2NQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/577",
            "STD_NAME": "Ayushi ",
            "STD_FATHER_NAME": "Sanjay Kumar",
            "STD_MOTHER_NAME": "Shobha Kumari",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3858",
            "STD_TC_ISSUE_DATE": "05-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjE=&cwid=Mjg2Nw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1675",
            "STD_NAME": "Yash Kumar Jha",
            "STD_FATHER_NAME": "Dhananjay Kumar Jha",
            "STD_MOTHER_NAME": "Bineeta  Jha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3860",
            "STD_TC_ISSUE_DATE": "05-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE2NQ==&cwid=Mjg2OQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1029",
            "STD_NAME": "Jamil Ahmed Sayyed",
            "STD_FATHER_NAME": "Suheal Ahmed Shafiq Sayyed",
            "STD_MOTHER_NAME": "Azra Khatoon",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3862",
            "STD_TC_ISSUE_DATE": "05-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=OTQ=&cwid=Mjg3MQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/9",
            "STD_NAME": "Bibhash Das Mohapatra",
            "STD_FATHER_NAME": "Anil Kumar Das Mohapatra",
            "STD_MOTHER_NAME": "Madhabi Das Mohapatra",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3864",
            "STD_TC_ISSUE_DATE": "05-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ0MA==&cwid=Mjg3Mw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2517",
            "STD_NAME": "Harsh Maurya",
            "STD_FATHER_NAME": "Devi Prasad Maurya",
            "STD_MOTHER_NAME": "Usha Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3866",
            "STD_TC_ISSUE_DATE": "05-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE5MQ==&cwid=Mjg3NQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2647",
            "STD_NAME": "Mohommad Arshad",
            "STD_FATHER_NAME": "Mohommad Meraj",
            "STD_MOTHER_NAME": "Asefa Khatoon",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3868",
            "STD_TC_ISSUE_DATE": "05-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM0Mg==&cwid=Mjg3Nw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/553",
            "STD_NAME": "Bhavishya ",
            "STD_FATHER_NAME": "Lalit Prasad",
            "STD_MOTHER_NAME": "Khasti Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3870",
            "STD_TC_ISSUE_DATE": "05-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NjQ=&cwid=Mjg3OQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3203",
            "STD_NAME": "Jahanvi Nagar",
            "STD_FATHER_NAME": "Sunil Nagar",
            "STD_MOTHER_NAME": "Shweta Bhati",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3872",
            "STD_TC_ISSUE_DATE": "05-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzg5OA==&cwid=Mjg4MQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2946",
            "STD_NAME": "Pushkar Raj",
            "STD_FATHER_NAME": "Sudhir Kumar",
            "STD_MOTHER_NAME": "Sanju Singh",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3875",
            "STD_TC_ISSUE_DATE": "06-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY0MQ==&cwid=Mjg4Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2621",
            "STD_NAME": "Sanjna ",
            "STD_FATHER_NAME": "Hansraj ",
            "STD_MOTHER_NAME": "Kusumlata ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3876",
            "STD_TC_ISSUE_DATE": "07-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzMxNg==&cwid=Mjg4NQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2730",
            "STD_NAME": "Neha Yadav",
            "STD_FATHER_NAME": "Shri Bhagwan Yadav",
            "STD_MOTHER_NAME": "Chinta Yadav",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3877",
            "STD_TC_ISSUE_DATE": "12-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQyNQ==&cwid=Mjg4Nw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3211",
            "STD_NAME": "Tapish Nagar",
            "STD_FATHER_NAME": "Vinod Kumar",
            "STD_MOTHER_NAME": "Nutan ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3882",
            "STD_TC_ISSUE_DATE": "18-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzkwNg==&cwid=Mjg4OQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1584",
            "STD_NAME": "Kareena Kaul",
            "STD_FATHER_NAME": "Amar Jyoti Sarmah Guardian",
            "STD_MOTHER_NAME": "Rita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3881",
            "STD_TC_ISSUE_DATE": "19-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjAzNg==&cwid=Mjg5MQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1290",
            "STD_NAME": "Pawan Bhati",
            "STD_FATHER_NAME": "Vinod Bhati",
            "STD_MOTHER_NAME": "Prabha ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3885",
            "STD_TC_ISSUE_DATE": "19-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTczNQ==&cwid=Mjg5Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2678",
            "STD_NAME": "Aryan Prajapati",
            "STD_FATHER_NAME": "Suresh Kumar",
            "STD_MOTHER_NAME": "Subhawati ",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "3887",
            "STD_TC_ISSUE_DATE": "19-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM3Mw==&cwid=Mjg5NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3226",
            "STD_NAME": "Sneha Jha",
            "STD_FATHER_NAME": "Amrendra Jha",
            "STD_MOTHER_NAME": "Pinki Jha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3889",
            "STD_TC_ISSUE_DATE": "22-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzkyMQ==&cwid=Mjg5Nw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2725",
            "STD_NAME": "Aparna Sharma",
            "STD_FATHER_NAME": "Satya Narayan Sharma",
            "STD_MOTHER_NAME": "Mamta Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3897",
            "STD_TC_ISSUE_DATE": "26-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQyMA==&cwid=Mjg5OQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2693",
            "STD_NAME": "Arman Khan",
            "STD_FATHER_NAME": "Mansoor Alam",
            "STD_MOTHER_NAME": "Samina Bano",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3892",
            "STD_TC_ISSUE_DATE": "26-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM4OA==&cwid=MjkwMQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2143",
            "STD_NAME": "Anushka ",
            "STD_FATHER_NAME": "Sharwan Singh Chauhan",
            "STD_MOTHER_NAME": "Pushpa  Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3893",
            "STD_TC_ISSUE_DATE": "26-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc4Mg==&cwid=MjkwMw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2251",
            "STD_NAME": "Sulochana Kumari",
            "STD_FATHER_NAME": "Sarat  Patra",
            "STD_MOTHER_NAME": "Basanti Patra",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3896",
            "STD_TC_ISSUE_DATE": "26-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg5MA==&cwid=MjkwNQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2100",
            "STD_NAME": "Ayan Pasha",
            "STD_FATHER_NAME": "Aftab ",
            "STD_MOTHER_NAME": "Shama Parveen",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3898",
            "STD_TC_ISSUE_DATE": "27-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYzNw==&cwid=MjkwNw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/442",
            "STD_NAME": "Rupali ",
            "STD_FATHER_NAME": "Purusharth Singh",
            "STD_MOTHER_NAME": "Rekha  Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3904",
            "STD_TC_ISSUE_DATE": "28-Jul-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=ODE=&cwid=MjkwOQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3223",
            "STD_NAME": "Vansh ",
            "STD_FATHER_NAME": "Naresh Kumar",
            "STD_MOTHER_NAME": "Poonam ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3906",
            "STD_TC_ISSUE_DATE": "10-Aug-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzkxOA==&cwid=MjkxMQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1693",
            "STD_NAME": "Ayush ",
            "STD_FATHER_NAME": "Vijay Kumar",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3909",
            "STD_TC_ISSUE_DATE": "10-Aug-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjE4Mw==&cwid=MjkxMw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1369",
            "STD_NAME": "Kumkum Yadav",
            "STD_FATHER_NAME": "Rajesh Yadav",
            "STD_MOTHER_NAME": "Kamlesh Yadav",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3908",
            "STD_TC_ISSUE_DATE": "10-Aug-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTgyMQ==&cwid=MjkxNQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/19",
            "STD_NAME": "Pihu Mishra",
            "STD_FATHER_NAME": "Dheeraj Mishra",
            "STD_MOTHER_NAME": "Luxmi Devi",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "3912",
            "STD_TC_ISSUE_DATE": "10-Aug-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA2Mw==&cwid=MjkxNw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3209",
            "STD_NAME": "Lakshya Sharma",
            "STD_FATHER_NAME": "Sanjeev Sharma",
            "STD_MOTHER_NAME": "Sangeeta Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3914",
            "STD_TC_ISSUE_DATE": "17-Aug-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzkwNA==&cwid=MjkxOQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1379",
            "STD_NAME": "Anuj Soni",
            "STD_FATHER_NAME": "Suresh Kumar Soni",
            "STD_MOTHER_NAME": "Parmila Soni",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3915",
            "STD_TC_ISSUE_DATE": "18-Aug-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTgzMQ==&cwid=MjkyMQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2689",
            "STD_NAME": "Alok Kumar Jha",
            "STD_FATHER_NAME": "Shambhu Jha",
            "STD_MOTHER_NAME": "Munni Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3917",
            "STD_TC_ISSUE_DATE": "28-Aug-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM4NA==&cwid=MjkyMw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3199",
            "STD_NAME": "Dabbu ",
            "STD_FATHER_NAME": "Sarvan  Gaand",
            "STD_MOTHER_NAME": "Kusumlata ",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "4069",
            "STD_TC_ISSUE_DATE": "02-Sep-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzg5NA==&cwid=MjkyNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2245",
            "STD_NAME": "Udit Kumar",
            "STD_FATHER_NAME": "Amar Jyoti Sarmah",
            "STD_MOTHER_NAME": "Sunita Devi",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "3921",
            "STD_TC_ISSUE_DATE": "20-Sep-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg4NA==&cwid=MjkyNw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/47",
            "STD_NAME": "Mohit Tanwar",
            "STD_FATHER_NAME": "Satpal Tanwar",
            "STD_MOTHER_NAME": "Anita Tanwar",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3925",
            "STD_TC_ISSUE_DATE": "22-Sep-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTI2NQ==&cwid=MjkyOQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3221",
            "STD_NAME": "Anurodh Singh",
            "STD_FATHER_NAME": "Gopal Singh",
            "STD_MOTHER_NAME": "Phoolo Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3923",
            "STD_TC_ISSUE_DATE": "22-Sep-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzkxNg==&cwid=MjkzMQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/274",
            "STD_NAME": "Ritik ",
            "STD_FATHER_NAME": "Rajaram Kanaujia",
            "STD_MOTHER_NAME": "Asha ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3926",
            "STD_TC_ISSUE_DATE": "06-Oct-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQ5Mw==&cwid=MjkzMw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2708",
            "STD_NAME": "Suraj ",
            "STD_FATHER_NAME": "Amar Jyoti Sarmah",
            "STD_MOTHER_NAME": "Anjali Das",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3928",
            "STD_TC_ISSUE_DATE": "27-Oct-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQwMw==&cwid=MjkzNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2686",
            "STD_NAME": "Dev Veer Bhan",
            "STD_FATHER_NAME": "Amod Kumar",
            "STD_MOTHER_NAME": "Santosh  Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3930",
            "STD_TC_ISSUE_DATE": "15-Dec-2023",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM4MQ==&cwid=MjkzNw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/99",
            "STD_NAME": "Sanjana Singh",
            "STD_FATHER_NAME": "Sanjay Kumar Singh",
            "STD_MOTHER_NAME": "Vibha Singh",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3932",
            "STD_TC_ISSUE_DATE": "24-Jan-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc2NA==&cwid=MjkzOQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/244",
            "STD_NAME": "Rashmi ",
            "STD_FATHER_NAME": "J N Kaul",
            "STD_MOTHER_NAME": "Pooja ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3935",
            "STD_TC_ISSUE_DATE": "13-Mar-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM2&cwid=Mjk0MQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3283",
            "STD_NAME": "Kartik Jangra",
            "STD_FATHER_NAME": "Ramesh Kumar",
            "STD_MOTHER_NAME": "Pooja Devi",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "3938",
            "STD_TC_ISSUE_DATE": "02-Apr-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDAyMA==&cwid=Mjk0Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3594",
            "STD_NAME": "Aishwarya ",
            "STD_FATHER_NAME": "Pramod  Jain",
            "STD_MOTHER_NAME": "Rajni ",
            "STD_LAST_CLASS": "III",
            "STD_TCNO": "3940",
            "STD_TC_ISSUE_DATE": "02-Apr-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDMzMQ==&cwid=Mjk0NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3245",
            "STD_NAME": "Priyanka Aggarwal",
            "STD_FATHER_NAME": "Nitin Aggarwal",
            "STD_MOTHER_NAME": "Vandana Aggarwal",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "3942",
            "STD_TC_ISSUE_DATE": "04-Apr-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzk4Mg==&cwid=Mjk0Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3538",
            "STD_NAME": "Aarna ",
            "STD_FATHER_NAME": "Ashish  Kumar",
            "STD_MOTHER_NAME": "Aradhana Mishra",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "3944",
            "STD_TC_ISSUE_DATE": "04-Apr-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDI3NQ==&cwid=Mjk0OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3110",
            "STD_NAME": "Jyotsna Mandal",
            "STD_FATHER_NAME": "Saptarishi Mandal",
            "STD_MOTHER_NAME": "Deboshree Banerji",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "3946",
            "STD_TC_ISSUE_DATE": "06-Apr-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzgwNQ==&cwid=Mjk1MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/17",
            "STD_NAME": "Aditya Baisla",
            "STD_FATHER_NAME": "Harinder Kumar",
            "STD_MOTHER_NAME": "Vinkal ",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "3949",
            "STD_TC_ISSUE_DATE": "06-Apr-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzk0OQ==&cwid=Mjk1Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3434",
            "STD_NAME": "Sonal Chaudhary",
            "STD_FATHER_NAME": "Subhash Chandra",
            "STD_MOTHER_NAME": "Chitra Chaudhary",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3952",
            "STD_TC_ISSUE_DATE": "06-Apr-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDE3MQ==&cwid=Mjk1NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2672",
            "STD_NAME": "Om  Chauhan",
            "STD_FATHER_NAME": "Guddu Chauhan",
            "STD_MOTHER_NAME": "Nisha Chauhan",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "3953",
            "STD_TC_ISSUE_DATE": "10-Apr-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM2Nw==&cwid=Mjk1Nw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2154",
            "STD_NAME": "Vansh Yadav",
            "STD_FATHER_NAME": "Anil Yadav",
            "STD_MOTHER_NAME": "Meenu Yadav",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "3954",
            "STD_TC_ISSUE_DATE": "16-Apr-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc5Mw==&cwid=Mjk1OQ==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3319",
            "STD_NAME": "Harsh ",
            "STD_FATHER_NAME": "Kabool Chand ",
            "STD_MOTHER_NAME": "Sarita ",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "3957",
            "STD_TC_ISSUE_DATE": "16-Apr-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDA1Ng==&cwid=Mjk2MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3320",
            "STD_NAME": "Yashvi ",
            "STD_FATHER_NAME": "Kabool Chand ",
            "STD_MOTHER_NAME": "Sarita Devi",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "3961",
            "STD_TC_ISSUE_DATE": "29-Apr-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDA1Nw==&cwid=Mjk2Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2651",
            "STD_NAME": "Ayush Singh",
            "STD_FATHER_NAME": "Jitendra Singh",
            "STD_MOTHER_NAME": "Hemlata Singh",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3964",
            "STD_TC_ISSUE_DATE": "29-Apr-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM0Ng==&cwid=Mjk2NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/24",
            "STD_NAME": "Prince Malakar",
            "STD_FATHER_NAME": "Debabrata Malakar",
            "STD_MOTHER_NAME": "Kajal Malakar",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3966",
            "STD_TC_ISSUE_DATE": "29-Apr-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY4OQ==&cwid=Mjk2Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2646",
            "STD_NAME": "Naveen Hasan",
            "STD_FATHER_NAME": "Ummed Khan",
            "STD_MOTHER_NAME": "Barisa Begam",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3968",
            "STD_TC_ISSUE_DATE": "29-Apr-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM0MQ==&cwid=Mjk2OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2712",
            "STD_NAME": "Sabra ",
            "STD_FATHER_NAME": "Nasruddin ",
            "STD_MOTHER_NAME": "Firoja Khatoon",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "3972",
            "STD_TC_ISSUE_DATE": "06-May-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQwNw==&cwid=Mjk3MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/1151",
            "STD_NAME": "Ankit Singh Rawat",
            "STD_FATHER_NAME": "Mahavir Singh",
            "STD_MOTHER_NAME": "Usha Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3973",
            "STD_TC_ISSUE_DATE": "08-May-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTAyMQ==&cwid=Mjk3Mw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3257",
            "STD_NAME": "Akshita ",
            "STD_FATHER_NAME": "Yogesh Sharma",
            "STD_MOTHER_NAME": "Renu ",
            "STD_LAST_CLASS": "LKG",
            "STD_TCNO": "3975",
            "STD_TC_ISSUE_DATE": "16-May-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzk5NA==&cwid=Mjk3NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3381",
            "STD_NAME": "Sorabh ",
            "STD_FATHER_NAME": "Satish Kumar",
            "STD_MOTHER_NAME": "Jyoti Rani",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3972",
            "STD_TC_ISSUE_DATE": "27-May-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDExOA==&cwid=Mjk3Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/37",
            "STD_NAME": "Ragini Shukla",
            "STD_FATHER_NAME": "Anurag Shukla",
            "STD_MOTHER_NAME": "Sudha Shukla",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3979",
            "STD_TC_ISSUE_DATE": "05-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzk2OQ==&cwid=Mjk3OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3120",
            "STD_NAME": "Bhavya Tyagi",
            "STD_FATHER_NAME": "Rahul Tyagi",
            "STD_MOTHER_NAME": "Rashmi Tyagi",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "3978",
            "STD_TC_ISSUE_DATE": "05-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzgxNQ==&cwid=Mjk4MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3010",
            "STD_NAME": "Amit Kumar Vishwakarma",
            "STD_FATHER_NAME": "Mathura  Prasad",
            "STD_MOTHER_NAME": "Sushila Vishwakarma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3981",
            "STD_TC_ISSUE_DATE": "05-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzcwNQ==&cwid=Mjk4Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3411",
            "STD_NAME": "Krish Aggarwal",
            "STD_FATHER_NAME": "Sanjay Aggarwal",
            "STD_MOTHER_NAME": "Rinki Aggarwal",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3984",
            "STD_TC_ISSUE_DATE": "05-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDE0OA==&cwid=Mjk4NQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2134",
            "STD_NAME": "Bandita Panthi",
            "STD_FATHER_NAME": "Gopi Panthi",
            "STD_MOTHER_NAME": "Bheema ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3987",
            "STD_TC_ISSUE_DATE": "12-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc3Mw==&cwid=Mjk4Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1456",
            "STD_NAME": "Harshit Sharma",
            "STD_FATHER_NAME": "Vivek Kumar",
            "STD_MOTHER_NAME": "Shweta Sharma",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "3988",
            "STD_TC_ISSUE_DATE": "12-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTkwOA==&cwid=Mjk4OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/5",
            "STD_NAME": "Hanshika Raghav",
            "STD_FATHER_NAME": "Nempal Singh",
            "STD_MOTHER_NAME": "Anju Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3997",
            "STD_TC_ISSUE_DATE": "21-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjY3MA==&cwid=Mjk5MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2097",
            "STD_NAME": "Aakash ",
            "STD_FATHER_NAME": "Banti  Kumar",
            "STD_MOTHER_NAME": "Seema ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3993",
            "STD_TC_ISSUE_DATE": "21-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYzNA==&cwid=Mjk5Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1337",
            "STD_NAME": "Manik ",
            "STD_FATHER_NAME": "Parveen Kumar",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3992",
            "STD_TC_ISSUE_DATE": "21-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc4OQ==&cwid=Mjk5NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2096",
            "STD_NAME": "Rajnandni ",
            "STD_FATHER_NAME": "Ashok Kumar",
            "STD_MOTHER_NAME": "Sunita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3996",
            "STD_TC_ISSUE_DATE": "21-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYzMw==&cwid=Mjk5Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/2986",
            "STD_NAME": "Rajan Kumar",
            "STD_FATHER_NAME": "Harendra Kumar Mahto",
            "STD_MOTHER_NAME": "Kiran  Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "3999",
            "STD_TC_ISSUE_DATE": "22-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY4MQ==&cwid=Mjk5OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1878",
            "STD_NAME": "Anju ",
            "STD_FATHER_NAME": "Dharampal ",
            "STD_MOTHER_NAME": "Late Sunita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4003",
            "STD_TC_ISSUE_DATE": "22-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM2OA==&cwid=MzAwMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1740",
            "STD_NAME": "Priya ",
            "STD_FATHER_NAME": "Amba Prasad",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4005",
            "STD_TC_ISSUE_DATE": "22-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjIzMA==&cwid=MzAwMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2440",
            "STD_NAME": "Aditya Jha",
            "STD_FATHER_NAME": "Nand Kumar Jha",
            "STD_MOTHER_NAME": "Beena Devi",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "4004",
            "STD_TC_ISSUE_DATE": "22-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzExNA==&cwid=MzAwNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3014",
            "STD_NAME": "Vishwajeet Yadav",
            "STD_FATHER_NAME": "Birendra Singh Yadav",
            "STD_MOTHER_NAME": "Beena Yadav",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4007",
            "STD_TC_ISSUE_DATE": "22-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzcwOQ==&cwid=MzAwNw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3403",
            "STD_NAME": "Anubhav Bhardwaj",
            "STD_FATHER_NAME": "Sanjeev ",
            "STD_MOTHER_NAME": "Anita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4008",
            "STD_TC_ISSUE_DATE": "22-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDE0MA==&cwid=MzAwOQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/5",
            "STD_NAME": "Himanshu Jha",
            "STD_FATHER_NAME": "Rajesh Jha",
            "STD_MOTHER_NAME": "Kamini Jha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4013",
            "STD_TC_ISSUE_DATE": "24-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA0OQ==&cwid=MzAxMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2862",
            "STD_NAME": "Tannu ",
            "STD_FATHER_NAME": "Ajit Singh",
            "STD_MOTHER_NAME": "Sony Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4011",
            "STD_TC_ISSUE_DATE": "24-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzU1Nw==&cwid=MzAxMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3057",
            "STD_NAME": "Aditya Kumar Jha",
            "STD_FATHER_NAME": "Shanker  Jha",
            "STD_MOTHER_NAME": "Kiran  Jha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4012",
            "STD_TC_ISSUE_DATE": "24-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc1Mg==&cwid=MzAxNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1578",
            "STD_NAME": "Harvinder Kaur",
            "STD_FATHER_NAME": "Rajender Singh",
            "STD_MOTHER_NAME": "Amarjit Kaur",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4019",
            "STD_TC_ISSUE_DATE": "26-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjAzMA==&cwid=MzAxNw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2240",
            "STD_NAME": "Kajal Kumari",
            "STD_FATHER_NAME": "Late  Dinesh Yadav",
            "STD_MOTHER_NAME": "Phoola  Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4021",
            "STD_TC_ISSUE_DATE": "26-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg3OQ==&cwid=MzAxOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3394",
            "STD_NAME": "Tiksha ",
            "STD_FATHER_NAME": "Harish Kumar",
            "STD_MOTHER_NAME": "Baby ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4024",
            "STD_TC_ISSUE_DATE": "26-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDEzMQ==&cwid=MzAyMQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3416",
            "STD_NAME": "Kanak Mahawar",
            "STD_FATHER_NAME": "Jagmohan Mahawar",
            "STD_MOTHER_NAME": "Jyoti Mahawar",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4017",
            "STD_TC_ISSUE_DATE": "26-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDE1Mw==&cwid=MzAyMw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2529",
            "STD_NAME": "Kajal Kumari",
            "STD_FATHER_NAME": "Santosh Singh",
            "STD_MOTHER_NAME": "Shanti Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4021",
            "STD_TC_ISSUE_DATE": "26-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIwMw==&cwid=MzAyNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3038",
            "STD_NAME": "Preet Kumar",
            "STD_FATHER_NAME": "Harish Chand",
            "STD_MOTHER_NAME": "Rajni ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4023",
            "STD_TC_ISSUE_DATE": "26-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzczMw==&cwid=MzAyNw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1911",
            "STD_NAME": "Jagdish ",
            "STD_FATHER_NAME": "Sukhbir Singh",
            "STD_MOTHER_NAME": "Maya Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4031",
            "STD_TC_ISSUE_DATE": "29-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQwMQ==&cwid=MzAyOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2729",
            "STD_NAME": "Dipanshu Yadav",
            "STD_FATHER_NAME": "Shribhagwan Yadav",
            "STD_MOTHER_NAME": "Chinta Yadav",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4029",
            "STD_TC_ISSUE_DATE": "29-Jun-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQyNA==&cwid=MzAzMQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3128",
            "STD_NAME": "Janvi ",
            "STD_FATHER_NAME": "Sharvan Singh",
            "STD_MOTHER_NAME": "Sadhna Singh",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "4032",
            "STD_TC_ISSUE_DATE": "02-Jul-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzgyMw==&cwid=MzAzMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3413",
            "STD_NAME": "Harshit ",
            "STD_FATHER_NAME": "Mansingh ",
            "STD_MOTHER_NAME": "Neetu Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4033",
            "STD_TC_ISSUE_DATE": "03-Jul-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDE1MA==&cwid=MzAzNQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/922",
            "STD_NAME": "Navjodh Singh ",
            "STD_FATHER_NAME": "Balbir Singh Bhatia",
            "STD_MOTHER_NAME": "Chetna ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4034",
            "STD_TC_ISSUE_DATE": "03-Jul-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc=&cwid=MzAzNw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/17",
            "STD_NAME": "Ravi Singh",
            "STD_FATHER_NAME": "Mahavir Singh",
            "STD_MOTHER_NAME": "Rekha Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4040",
            "STD_TC_ISSUE_DATE": "10-Jul-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ0OA==&cwid=MzAzOQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1977",
            "STD_NAME": "Bikram Roy",
            "STD_FATHER_NAME": "Kajal Roy",
            "STD_MOTHER_NAME": "Meena Roy",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4042",
            "STD_TC_ISSUE_DATE": "10-Jul-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjUxNA==&cwid=MzA0MQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3039",
            "STD_NAME": "Shreya Mishra",
            "STD_FATHER_NAME": "Shri Nivash Mishra",
            "STD_MOTHER_NAME": "Sarita  Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4043",
            "STD_TC_ISSUE_DATE": "10-Jul-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzczNA==&cwid=MzA0Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/25",
            "STD_NAME": "Aditya Chaprana",
            "STD_FATHER_NAME": "Narender Chaprana",
            "STD_MOTHER_NAME": "Sonia Chaprana",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4051",
            "STD_TC_ISSUE_DATE": "15-Jul-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjEzNA==&cwid=MzA0NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2139",
            "STD_NAME": "Shiwank Pandey",
            "STD_FATHER_NAME": "Ghanshyam Pandey",
            "STD_MOTHER_NAME": "Vinita Pandey",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4045",
            "STD_TC_ISSUE_DATE": "15-Jul-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc3OA==&cwid=MzA0Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2151",
            "STD_NAME": "Chirag Juggal",
            "STD_FATHER_NAME": "Pankaj Kumar Juggal",
            "STD_MOTHER_NAME": "Pushpinder  Kaur ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4048",
            "STD_TC_ISSUE_DATE": "15-Jul-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc5MA==&cwid=MzA0OQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2717",
            "STD_NAME": "Varsha Kumari",
            "STD_FATHER_NAME": "Bir Singh",
            "STD_MOTHER_NAME": "Saroj Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4054",
            "STD_TC_ISSUE_DATE": "15-Jul-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQxMg==&cwid=MzA1MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3383",
            "STD_NAME": "Khushi Yadav",
            "STD_FATHER_NAME": "Bhagirath Singh",
            "STD_MOTHER_NAME": "Sanesh Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4044",
            "STD_TC_ISSUE_DATE": "15-Jul-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDEyMA==&cwid=MzA1Mw==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3392",
            "STD_NAME": "Akash Yadav",
            "STD_FATHER_NAME": "Bhoodev Singh Yadav",
            "STD_MOTHER_NAME": "Sushma Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4049",
            "STD_TC_ISSUE_DATE": "15-Jul-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDEyOQ==&cwid=MzA1NQ==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1936",
            "STD_NAME": "Sadhan ",
            "STD_FATHER_NAME": "Late Ranjan  Sarkar",
            "STD_MOTHER_NAME": "Sonali ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4055",
            "STD_TC_ISSUE_DATE": "19-Jul-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQyNg==&cwid=MzA1Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/123",
            "STD_NAME": "Muskan Singhania",
            "STD_FATHER_NAME": "Brijesh Singhania",
            "STD_MOTHER_NAME": "Poonam ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4058",
            "STD_TC_ISSUE_DATE": "23-Jul-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTYyNA==&cwid=MzA1OQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3419",
            "STD_NAME": "Ranjeet Singh",
            "STD_FATHER_NAME": "Maharaj Singh",
            "STD_MOTHER_NAME": "Juglesh Kumari",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4061",
            "STD_TC_ISSUE_DATE": "29-Jul-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDE1Ng==&cwid=MzA2MQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/95",
            "STD_NAME": "Jasleen Kaur Virdi",
            "STD_FATHER_NAME": "Harjot Singh Virdi",
            "STD_MOTHER_NAME": "Sukhbir Kaur Virdi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4063",
            "STD_TC_ISSUE_DATE": "01-Aug-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjc2MA==&cwid=MzA2Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1848",
            "STD_NAME": "Neha ",
            "STD_FATHER_NAME": "Late Balram  ",
            "STD_MOTHER_NAME": "Runnia ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4065",
            "STD_TC_ISSUE_DATE": "08-Aug-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMzOA==&cwid=MzA2NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1406",
            "STD_NAME": "Aniket Raj",
            "STD_FATHER_NAME": "Himanshu Raj",
            "STD_MOTHER_NAME": "Savita Raj",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4068",
            "STD_TC_ISSUE_DATE": "02-Sep-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg1OA==&cwid=MzA2Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/99",
            "STD_NAME": "Suhali Singh",
            "STD_FATHER_NAME": "Mukesh Singh",
            "STD_MOTHER_NAME": "Indu Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4070",
            "STD_TC_ISSUE_DATE": "04-Sep-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTYwMA==&cwid=MzA2OQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3391",
            "STD_NAME": "Aditya Jha",
            "STD_FATHER_NAME": "Vinay Jha",
            "STD_MOTHER_NAME": "Vandana Jha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4072",
            "STD_TC_ISSUE_DATE": "28-Nov-2024",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDEyOA==&cwid=MzA3MQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3275",
            "STD_NAME": "Akshra Rani",
            "STD_FATHER_NAME": "Sunil Kumar",
            "STD_MOTHER_NAME": "Munesh Kumari",
            "STD_LAST_CLASS": "IV",
            "STD_TCNO": "4075",
            "STD_TC_ISSUE_DATE": "27-Jan-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDAxMg==&cwid=MzA3Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3326",
            "STD_NAME": "Prince ",
            "STD_FATHER_NAME": "Sudhir ",
            "STD_MOTHER_NAME": "Khushboo ",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "4077",
            "STD_TC_ISSUE_DATE": "24-Mar-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDA2Mw==&cwid=MzA3NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3268",
            "STD_NAME": "Yashika ",
            "STD_FATHER_NAME": "Amit Kumar Aggarwal",
            "STD_MOTHER_NAME": "Harita Gupta",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "4078",
            "STD_TC_ISSUE_DATE": "11-Apr-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDAwNQ==&cwid=MzA3Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3448",
            "STD_NAME": "Shreyansh Tyagi",
            "STD_FATHER_NAME": "Pankaj  Tyagi",
            "STD_MOTHER_NAME": "Shubhangi Tyagi",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "4080",
            "STD_TC_ISSUE_DATE": "11-Apr-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDE4NQ==&cwid=MzA3OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/23",
            "STD_NAME": "Keshav Kumar",
            "STD_FATHER_NAME": "Rahul Kumar Jha",
            "STD_MOTHER_NAME": "Runa Jha",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "4082",
            "STD_TC_ISSUE_DATE": "11-Apr-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjEzMg==&cwid=MzA4MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/23",
            "STD_NAME": "Vedansh Yadav",
            "STD_FATHER_NAME": "Yatendra  Pratap Singh",
            "STD_MOTHER_NAME": "Beena Yadav",
            "STD_LAST_CLASS": "II",
            "STD_TCNO": "4085",
            "STD_TC_ISSUE_DATE": "11-Apr-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzk1NQ==&cwid=MzA4Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2425/3675",
            "STD_NAME": "Nikesh  Thakur",
            "STD_FATHER_NAME": "Rakesh Kumar Singh",
            "STD_MOTHER_NAME": "Jyoti  Thakur",
            "STD_LAST_CLASS": "NUR",
            "STD_TCNO": "4087",
            "STD_TC_ISSUE_DATE": "11-Apr-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDQxNA==&cwid=MzA4NQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2425/3683",
            "STD_NAME": "Shlok Singh",
            "STD_FATHER_NAME": "Hemant Kumar",
            "STD_MOTHER_NAME": "Shraddha ",
            "STD_LAST_CLASS": "LKG",
            "STD_TCNO": "4090",
            "STD_TC_ISSUE_DATE": "11-Apr-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDQyMg==&cwid=MzA4Nw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3302",
            "STD_NAME": "Navya Yadav",
            "STD_FATHER_NAME": "Ashok Kumar Yadav",
            "STD_MOTHER_NAME": "Rajni Yadav",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "4088",
            "STD_TC_ISSUE_DATE": "11-Apr-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDAzOQ==&cwid=MzA4OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2404",
            "STD_NAME": "Ranveer Singh",
            "STD_FATHER_NAME": "Naveen Singh",
            "STD_MOTHER_NAME": "Kusha Singh",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "4083",
            "STD_TC_ISSUE_DATE": "15-Apr-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA0Mw==&cwid=MzA5MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3444",
            "STD_NAME": "Trisha Sharma",
            "STD_FATHER_NAME": "Rinku Sharma",
            "STD_MOTHER_NAME": "Sakshi Sharma",
            "STD_LAST_CLASS": "I",
            "STD_TCNO": "LEFT",
            "STD_TC_ISSUE_DATE": "18-Apr-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDE4MQ==&cwid=MzA5Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3263",
            "STD_NAME": "Prakash Vineet Jha",
            "STD_FATHER_NAME": "Vineet Jaikishor Jha",
            "STD_MOTHER_NAME": "Simmi Vineet Jha",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "4094",
            "STD_TC_ISSUE_DATE": "28-Apr-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDAwMA==&cwid=MzA5NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3130",
            "STD_NAME": "Deepanshu Kumar Singh",
            "STD_FATHER_NAME": "Chandra Kant Singh",
            "STD_MOTHER_NAME": "Chanda Singh",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "4096",
            "STD_TC_ISSUE_DATE": "28-Apr-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzgyNQ==&cwid=MzA5Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2726",
            "STD_NAME": "Jonathan Dey",
            "STD_FATHER_NAME": "Swarup Dey",
            "STD_MOTHER_NAME": "Shobha Dey",
            "STD_LAST_CLASS": "VI",
            "STD_TCNO": "4098",
            "STD_TC_ISSUE_DATE": "28-Apr-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQyMQ==&cwid=MzA5OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3018",
            "STD_NAME": "Varjeet Nagar",
            "STD_FATHER_NAME": "Deepak Nagar",
            "STD_MOTHER_NAME": "Deepika Nagar",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "4100",
            "STD_TC_ISSUE_DATE": "28-Apr-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzcxMw==&cwid=MzEwMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3488",
            "STD_NAME": "Reyansh Upadhyay",
            "STD_FATHER_NAME": "Geetendra Upadhyay",
            "STD_MOTHER_NAME": "Yogendri Upadhyay ",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "4102",
            "STD_TC_ISSUE_DATE": "28-Apr-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDIyNQ==&cwid=MzEwMw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/46",
            "STD_NAME": "Krish Raghav",
            "STD_FATHER_NAME": "Nempal Singh",
            "STD_MOTHER_NAME": "Anju Devi",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "4104",
            "STD_TC_ISSUE_DATE": "30-Apr-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjcxMQ==&cwid=MzEwNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3317",
            "STD_NAME": "Aman Pal",
            "STD_FATHER_NAME": "Shyam Babu",
            "STD_MOTHER_NAME": "Basanti Devi",
            "STD_LAST_CLASS": "XI",
            "STD_TCNO": "4106",
            "STD_TC_ISSUE_DATE": "13-May-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDA1NA==&cwid=MzEwNw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3606",
            "STD_NAME": "Ayush ",
            "STD_FATHER_NAME": "Sunder  ",
            "STD_MOTHER_NAME": "Rotani  Rawat",
            "STD_LAST_CLASS": "V",
            "STD_TCNO": "4111",
            "STD_TC_ISSUE_DATE": "13-May-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDM0Mw==&cwid=MzEwOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3607",
            "STD_NAME": "Amit ",
            "STD_FATHER_NAME": " Sunder ",
            "STD_MOTHER_NAME": "Rotani  Rawat",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "4110",
            "STD_TC_ISSUE_DATE": "13-May-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDM0NA==&cwid=MzExMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2528",
            "STD_NAME": "Vivek Singh Tanwar",
            "STD_FATHER_NAME": "Late Sher Singh",
            "STD_MOTHER_NAME": "Poonam Singh",
            "STD_LAST_CLASS": "IX",
            "STD_TCNO": "4108",
            "STD_TC_ISSUE_DATE": "13-May-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzIwMg==&cwid=MzExMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2636",
            "STD_NAME": "Prajanya Mishra",
            "STD_FATHER_NAME": "Gopal Mishra",
            "STD_MOTHER_NAME": "Rukmani Mishra",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4113",
            "STD_TC_ISSUE_DATE": "22-May-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzMzMQ==&cwid=MzExNQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3492",
            "STD_NAME": "Aarav Raj",
            "STD_FATHER_NAME": "Arjun Puri",
            "STD_MOTHER_NAME": "Neelema Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4117",
            "STD_TC_ISSUE_DATE": "22-May-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDIyOQ==&cwid=MzExNw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2632",
            "STD_NAME": "Vanshika ",
            "STD_FATHER_NAME": "Sunil Kumar",
            "STD_MOTHER_NAME": "Suneeta Kumari",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4118",
            "STD_TC_ISSUE_DATE": "22-May-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzMyNw==&cwid=MzExOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3269",
            "STD_NAME": "Bhanvi ",
            "STD_FATHER_NAME": "Amit Kumar Aggarwal",
            "STD_MOTHER_NAME": "Harita Gupta",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4117",
            "STD_TC_ISSUE_DATE": "26-May-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDAwNg==&cwid=MzEyMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3012",
            "STD_NAME": "Aditya Maurya",
            "STD_FATHER_NAME": "Raj Mangal Maurya",
            "STD_MOTHER_NAME": "Suman Maurya",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4116",
            "STD_TC_ISSUE_DATE": "26-May-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzcwNw==&cwid=MzEyMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3506",
            "STD_NAME": "Sourav Mahapatra",
            "STD_FATHER_NAME": "Pradeep Kumar Mohapatra",
            "STD_MOTHER_NAME": "Sasmita Mohapatra",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4121",
            "STD_TC_ISSUE_DATE": "30-May-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDI0Mw==&cwid=MzEyNQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3017",
            "STD_NAME": "Deepanshu ",
            "STD_FATHER_NAME": "Pratap Narayan",
            "STD_MOTHER_NAME": "Sheelam Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4123",
            "STD_TC_ISSUE_DATE": "30-May-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzcxMg==&cwid=MzEyNw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3572",
            "STD_NAME": "Abhi Tomar",
            "STD_FATHER_NAME": "Ashok Kumar Singh",
            "STD_MOTHER_NAME": "Neelam  Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4139",
            "STD_TC_ISSUE_DATE": "26-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDMwOQ==&cwid=MzEyOQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3563",
            "STD_NAME": "Anitej  Srotriya",
            "STD_FATHER_NAME": "Anant  Kumar Pandey",
            "STD_MOTHER_NAME": "Padmini Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4144",
            "STD_TC_ISSUE_DATE": "26-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDMwMA==&cwid=MzEzMQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3188",
            "STD_NAME": "Archit Kumar",
            "STD_FATHER_NAME": "Amit Kumar",
            "STD_MOTHER_NAME": "Archna Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4142",
            "STD_TC_ISSUE_DATE": "26-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzg4Mw==&cwid=MzEzMw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3019",
            "STD_NAME": "Isha Kaur",
            "STD_FATHER_NAME": "Vikram Singh",
            "STD_MOTHER_NAME": "Seema Kaur",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4135",
            "STD_TC_ISSUE_DATE": "26-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzcxNA==&cwid=MzEzNQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3555",
            "STD_NAME": "Mayank Chinwan",
            "STD_FATHER_NAME": "Tribhuven ",
            "STD_MOTHER_NAME": "Promila ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4126",
            "STD_TC_ISSUE_DATE": "26-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDI5Mg==&cwid=MzEzNw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2828",
            "STD_NAME": "Jatin Sagar",
            "STD_FATHER_NAME": "Rakesh Sagar",
            "STD_MOTHER_NAME": "Veervati Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4136",
            "STD_TC_ISSUE_DATE": "26-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzUyMw==&cwid=MzEzOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3562",
            "STD_NAME": "Rahul Kumar",
            "STD_FATHER_NAME": "Amit Kumar Mishra",
            "STD_MOTHER_NAME": "Gudiya  Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4130",
            "STD_TC_ISSUE_DATE": "26-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDI5OQ==&cwid=MzE0NA==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2489",
            "STD_NAME": "Sahil Singh Rawat",
            "STD_FATHER_NAME": "Naveen Singh Rawat",
            "STD_MOTHER_NAME": "Anjali Kumari",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4156",
            "STD_TC_ISSUE_DATE": "26-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE2Mw==&cwid=MzE0Ng==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/25",
            "STD_NAME": "Krishna Kumar Dubey",
            "STD_FATHER_NAME": "Santosh Dubey",
            "STD_MOTHER_NAME": "Late. Ginni Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4149",
            "STD_TC_ISSUE_DATE": "26-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzA2OQ==&cwid=MzE0OA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1362",
            "STD_NAME": "Ishant Chauhan",
            "STD_FATHER_NAME": "Dharmvir Singh",
            "STD_MOTHER_NAME": "Munesh Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4153",
            "STD_TC_ISSUE_DATE": "26-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTgxNA==&cwid=MzE1MA==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2175",
            "STD_NAME": "Dishant Kumar",
            "STD_FATHER_NAME": "Sudhir Kumar",
            "STD_MOTHER_NAME": "Anjana Kumari",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4131",
            "STD_TC_ISSUE_DATE": "26-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjgxNA==&cwid=MzE1NA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/1298",
            "STD_NAME": "Piyush Kumar",
            "STD_FATHER_NAME": "Rakesh Kumar Ravi",
            "STD_MOTHER_NAME": "Rita Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4133",
            "STD_TC_ISSUE_DATE": "26-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTc0Mw==&cwid=MzE1Ng==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/47",
            "STD_NAME": "Chirag Miglani",
            "STD_FATHER_NAME": "Vimal Miglani",
            "STD_MOTHER_NAME": "Meenakshi Miglani",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4125",
            "STD_TC_ISSUE_DATE": "26-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTU0OA==&cwid=MzE1OA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3576",
            "STD_NAME": "Lalit Gaur",
            "STD_FATHER_NAME": "Pawan  Kumar Gaur",
            "STD_MOTHER_NAME": "Usha  Gaur",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4158",
            "STD_TC_ISSUE_DATE": "27-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDMxMw==&cwid=MzE2MA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3566",
            "STD_NAME": "Pratyaksh Parihar",
            "STD_FATHER_NAME": "Devender Pal Singh",
            "STD_MOTHER_NAME": "Priya Parihar",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4174",
            "STD_TC_ISSUE_DATE": "27-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDMwMw==&cwid=MzE2NA==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3542",
            "STD_NAME": "Samiksha ",
            "STD_FATHER_NAME": "Ajay  Kumar Gaur",
            "STD_MOTHER_NAME": "Krishna ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4156",
            "STD_TC_ISSUE_DATE": "27-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDI3OQ==&cwid=MzE2Ng==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3187",
            "STD_NAME": "Arpit Kumar",
            "STD_FATHER_NAME": "Amit Kumar",
            "STD_MOTHER_NAME": "Archna Singh",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4167",
            "STD_TC_ISSUE_DATE": "27-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzg4Mg==&cwid=MzE2OA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1966",
            "STD_NAME": "Shayon Sinha",
            "STD_FATHER_NAME": "Sumit Sinha",
            "STD_MOTHER_NAME": "Krishna Sinha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4165",
            "STD_TC_ISSUE_DATE": "27-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjUwMw==&cwid=MzE3MA==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2951",
            "STD_NAME": "Kajal Singh",
            "STD_FATHER_NAME": "Nahar Singh",
            "STD_MOTHER_NAME": "Rajwati ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4171",
            "STD_TC_ISSUE_DATE": "27-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY0Ng==&cwid=MzE3Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/112",
            "STD_NAME": "Jatin Ashoka",
            "STD_FATHER_NAME": "Anil Kumar Ashoka",
            "STD_MOTHER_NAME": "Ruchi  Ashoka",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4173",
            "STD_TC_ISSUE_DATE": "27-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTMzMA==&cwid=MzE3NQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1112/824",
            "STD_NAME": "Ayush Pandita",
            "STD_FATHER_NAME": "Gash Lal  Pandita",
            "STD_MOTHER_NAME": "Vandana Pandita",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4159",
            "STD_TC_ISSUE_DATE": "28-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mw==&cwid=MzE3Nw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3175",
            "STD_NAME": "Deepanshu Pandey",
            "STD_FATHER_NAME": "Dhruva Chandra Pandey",
            "STD_MOTHER_NAME": "Mamta Rai",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4154",
            "STD_TC_ISSUE_DATE": "28-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzg3MA==&cwid=MzE3OA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/100",
            "STD_NAME": "Hritvik Singh",
            "STD_FATHER_NAME": "Mukesh Singh",
            "STD_MOTHER_NAME": "Indu Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4149",
            "STD_TC_ISSUE_DATE": "26-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTYwMQ==&cwid=MzE1MQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3587",
            "STD_NAME": "Bhumi  Chaudhary",
            "STD_FATHER_NAME": "Gajender Chaudhary",
            "STD_MOTHER_NAME": "Rani ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4161",
            "STD_TC_ISSUE_DATE": "27-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDMyNA==&cwid=MzE2Mg==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3475",
            "STD_NAME": "Anirudh Singh Chauhan",
            "STD_FATHER_NAME": "Pradeep  Singh",
            "STD_MOTHER_NAME": "Rakhi ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4170",
            "STD_TC_ISSUE_DATE": "28-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDIxMg==&cwid=MzE3OQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/1956",
            "STD_NAME": "Jiya Sharma",
            "STD_FATHER_NAME": "Neeraj Sharma",
            "STD_MOTHER_NAME": "Neeru Sharma",
            "STD_LAST_CLASS": "VIII Pursuing",
            "STD_TCNO": "4181",
            "STD_TC_ISSUE_DATE": "28-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQ5Mw==&cwid=MzE4MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3537",
            "STD_NAME": "Sahil ",
            "STD_FATHER_NAME": "Jile  Singh",
            "STD_MOTHER_NAME": "Urmila ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4124",
            "STD_TC_ISSUE_DATE": "26-Jun-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDI3NA==&cwid=MzE0MQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2499",
            "STD_NAME": "Sanjogta ",
            "STD_FATHER_NAME": "Jagdish Sharma",
            "STD_MOTHER_NAME": "Benna Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4184",
            "STD_TC_ISSUE_DATE": "02-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE3Mw==&cwid=MzE4Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3124",
            "STD_NAME": "Sparsh ",
            "STD_FATHER_NAME": "Anuj  Mishra",
            "STD_MOTHER_NAME": "Surbhi Mishra",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4176",
            "STD_TC_ISSUE_DATE": "02-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzgxOQ==&cwid=MzE4NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3605",
            "STD_NAME": "Kush ",
            "STD_FATHER_NAME": "Jainesh Kumar",
            "STD_MOTHER_NAME": "Pinki ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4183",
            "STD_TC_ISSUE_DATE": "02-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDM0Mg==&cwid=MzE4Nw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3551",
            "STD_NAME": "Krishika Shrivastava",
            "STD_FATHER_NAME": "Satender Shrivastava",
            "STD_MOTHER_NAME": "Rashmi Shrivastava",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4190",
            "STD_TC_ISSUE_DATE": "02-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDI4OA==&cwid=MzE4OQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3142",
            "STD_NAME": "Trisha Singh",
            "STD_FATHER_NAME": "Late Bhupender Singh",
            "STD_MOTHER_NAME": "Kavita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4162",
            "STD_TC_ISSUE_DATE": "02-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzgzNw==&cwid=MzE5MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2968",
            "STD_NAME": "Ekta ",
            "STD_FATHER_NAME": "Amit ",
            "STD_MOTHER_NAME": "Monika ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4179",
            "STD_TC_ISSUE_DATE": "02-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzY2Mw==&cwid=MzE5Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1923",
            "STD_NAME": "Robin ",
            "STD_FATHER_NAME": "Praveen Sardana",
            "STD_MOTHER_NAME": "Kanta ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4191",
            "STD_TC_ISSUE_DATE": "02-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQxMw==&cwid=MzE5NQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1923",
            "STD_NAME": "Robin ",
            "STD_FATHER_NAME": "Praveen Sardana",
            "STD_MOTHER_NAME": "Kanta ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4191",
            "STD_TC_ISSUE_DATE": "02-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQxMw==&cwid=MzE5Nw==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1580",
            "STD_NAME": "Ritik Jha",
            "STD_FATHER_NAME": "Manoj Jha",
            "STD_MOTHER_NAME": "Lalita ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4213",
            "STD_TC_ISSUE_DATE": "08-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjAzMg==&cwid=MzE5OQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2709",
            "STD_NAME": "Chirag ",
            "STD_FATHER_NAME": "Amar Jyoti Sarmah",
            "STD_MOTHER_NAME": "Pushpa  Singh",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4208",
            "STD_TC_ISSUE_DATE": "08-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQwNA==&cwid=MzIwMQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3085",
            "STD_NAME": "Abhishek Kumar",
            "STD_FATHER_NAME": "Satya Narayan Yadav",
            "STD_MOTHER_NAME": "Parvati Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4215",
            "STD_TC_ISSUE_DATE": "12-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc4MA==&cwid=MzIwNA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2496",
            "STD_NAME": "Sageer Khan",
            "STD_FATHER_NAME": "Sakeel ",
            "STD_MOTHER_NAME": "Fatima Begum",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4210",
            "STD_TC_ISSUE_DATE": "12-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE3MA==&cwid=MzIwNg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3550",
            "STD_NAME": "Aditya ",
            "STD_FATHER_NAME": "Lal  Chandra",
            "STD_MOTHER_NAME": "Sunita ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4207",
            "STD_TC_ISSUE_DATE": "12-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDI4Nw==&cwid=MzIxMA==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2697",
            "STD_NAME": "Sandhya Kadheriya",
            "STD_FATHER_NAME": "Late. Vijay Kadheriya",
            "STD_MOTHER_NAME": "Rekha Kadheriya",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4203",
            "STD_TC_ISSUE_DATE": "12-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzM5Mg==&cwid=MzIxMg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3544",
            "STD_NAME": "Jaya  Sharma",
            "STD_FATHER_NAME": "Kapil Dev Sharma",
            "STD_MOTHER_NAME": "Sangeeta Sharma ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4206",
            "STD_TC_ISSUE_DATE": "12-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDI4MQ==&cwid=MzIxNA==&stdstream=NA==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3545",
            "STD_NAME": "Anjali Dubey",
            "STD_FATHER_NAME": "Arun Kumar Dubey",
            "STD_MOTHER_NAME": "Poonam Dubey",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4217",
            "STD_TC_ISSUE_DATE": "13-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDI4Mg==&cwid=MzIxNg==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3549",
            "STD_NAME": "Santosh Kumar Moharana",
            "STD_FATHER_NAME": "Sanjay Kumar Moharana",
            "STD_MOTHER_NAME": "Pratima  Moharana",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4198",
            "STD_TC_ISSUE_DATE": "13-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDI4Ng==&cwid=MzIxOA==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3569",
            "STD_NAME": "Divyanshu Ojha",
            "STD_FATHER_NAME": "Ambika  Prasad Ojha",
            "STD_MOTHER_NAME": "Vibha Ojha",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4195",
            "STD_TC_ISSUE_DATE": "13-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDMwNg==&cwid=MzIyMA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/248",
            "STD_NAME": "Kajal ",
            "STD_FATHER_NAME": "Late J.N Kaul",
            "STD_MOTHER_NAME": "Sunita Jadoun",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4193",
            "STD_TC_ISSUE_DATE": "13-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQ2Nw==&cwid=MzIyMg==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3561",
            "STD_NAME": "Bhavishya Sharma",
            "STD_FATHER_NAME": "Ajay  Sharma",
            "STD_MOTHER_NAME": "Soma Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4194",
            "STD_TC_ISSUE_DATE": "13-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDI5OA==&cwid=MzIyNA==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2481",
            "STD_NAME": "Sakshi Phogat",
            "STD_FATHER_NAME": "Surender Singh Phogat",
            "STD_MOTHER_NAME": "Anita Phogat",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4200",
            "STD_TC_ISSUE_DATE": "15-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzE1NQ==&cwid=MzIyNg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1846",
            "STD_NAME": "Laxmi ",
            "STD_FATHER_NAME": "Late Balram ",
            "STD_MOTHER_NAME": "Runnia ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4212",
            "STD_TC_ISSUE_DATE": "08-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjMzNg==&cwid=MzIwMg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/7",
            "STD_NAME": "Mohammad Faiz Ansari",
            "STD_FATHER_NAME": "Muslim ",
            "STD_MOTHER_NAME": "Tabbsum Parveen",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4223",
            "STD_TC_ISSUE_DATE": "16-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjQzOA==&cwid=MzIyOQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1617/2098",
            "STD_NAME": "Neha Nagar",
            "STD_FATHER_NAME": "Jitender Kumar",
            "STD_MOTHER_NAME": "Tannu Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4221",
            "STD_TC_ISSUE_DATE": "16-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjYzNQ==&cwid=MzIzMg==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2223/3382",
            "STD_NAME": "Nandani Raj",
            "STD_FATHER_NAME": "Dhiraj Kumar Singh",
            "STD_MOTHER_NAME": "Mamta Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4217",
            "STD_TC_ISSUE_DATE": "16-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDExOQ==&cwid=MzIzNA==&stdstream=Mg==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3556",
            "STD_NAME": "Pankaj Kumar",
            "STD_FATHER_NAME": "Sanjay Kumar",
            "STD_MOTHER_NAME": "Ruchi  Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4219",
            "STD_TC_ISSUE_DATE": "16-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDI5Mw==&cwid=MzIzNg==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3541",
            "STD_NAME": "Jasmeet Singh",
            "STD_FATHER_NAME": "Gurvinder Singh",
            "STD_MOTHER_NAME": "Rajvinder Kaur",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4209",
            "STD_TC_ISSUE_DATE": "12-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDI3OA==&cwid=MzIwNw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3585",
            "STD_NAME": "Aishwarya  Sharma",
            "STD_FATHER_NAME": "Vineet  Sharma",
            "STD_MOTHER_NAME": "Preeti  Sharma",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4224",
            "STD_TC_ISSUE_DATE": "16-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDMyMg==&cwid=MzIzMA==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1415/1445",
            "STD_NAME": "Akshat Sharma",
            "STD_FATHER_NAME": "Varun Kumar",
            "STD_MOTHER_NAME": "Sangeeta Sharma",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4225",
            "STD_TC_ISSUE_DATE": "16-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTg5Nw==&cwid=MzIyNw==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2122/3181",
            "STD_NAME": "Sarika ",
            "STD_FATHER_NAME": "Anil Kumar",
            "STD_MOTHER_NAME": "Anju Devi",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4229",
            "STD_TC_ISSUE_DATE": "23-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzg3Ng==&cwid=MzI0MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3573",
            "STD_NAME": "Sachin Yadav",
            "STD_FATHER_NAME": "Manoj Kumar Yadav",
            "STD_MOTHER_NAME": "Lalsha Devi ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4232",
            "STD_TC_ISSUE_DATE": "23-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDMxMA==&cwid=MzI0Mw==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3545",
            "STD_NAME": "Anjali Dubey",
            "STD_FATHER_NAME": "Arun Kumar Dubey",
            "STD_MOTHER_NAME": "Poonam Dubey",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4205",
            "STD_TC_ISSUE_DATE": "23-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDI4Mg==&cwid=MzI0NQ==&stdstream=Ng==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1516/1908",
            "STD_NAME": "Sudhir ",
            "STD_FATHER_NAME": "Chandrma Shani",
            "STD_MOTHER_NAME": "Late Pooja ",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4239",
            "STD_TC_ISSUE_DATE": "30-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MjM5OA==&cwid=MzI0Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3574",
            "STD_NAME": "Mukhtar Ahmed Siddique",
            "STD_FATHER_NAME": "Khalil  Ahmed",
            "STD_MOTHER_NAME": "Mustari Khatoon",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4236",
            "STD_TC_ISSUE_DATE": "30-Jul-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDMxMQ==&cwid=MzI0OQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3593",
            "STD_NAME": "Piyush Yadav",
            "STD_FATHER_NAME": "Ram Lakhan Yadav",
            "STD_MOTHER_NAME": "Shiv Dhara  Yadav",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4235",
            "STD_TC_ISSUE_DATE": "01-Aug-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDMzMA==&cwid=MzI1MQ==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1718/2240",
            "STD_NAME": "Kajal Kumari",
            "STD_FATHER_NAME": "Late  Dinesh Yadav",
            "STD_MOTHER_NAME": "Phoola  Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4240",
            "STD_TC_ISSUE_DATE": "05-Aug-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mjg3OQ==&cwid=MzI1Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3598",
            "STD_NAME": "Sagar ",
            "STD_FATHER_NAME": "Vikram ",
            "STD_MOTHER_NAME": "Chaman ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4233",
            "STD_TC_ISSUE_DATE": "06-Aug-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDMzNQ==&cwid=MzI1NQ==&stdstream=NQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2324/3570",
            "STD_NAME": "Vidushi  Rani",
            "STD_FATHER_NAME": "Xxxxx ",
            "STD_MOTHER_NAME": "Rooma  Rani",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4242",
            "STD_TC_ISSUE_DATE": "06-Aug-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=NDMwNw==&cwid=MzI1Nw==&stdstream=Mw==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1213/251",
            "STD_NAME": "Mustafa ",
            "STD_FATHER_NAME": "Late J.N Kaul",
            "STD_MOTHER_NAME": "Jharna Mukherjee",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4245",
            "STD_TC_ISSUE_DATE": "27-Aug-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTQ3MA==&cwid=MzI1OQ==&stdstream=&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1920/2764",
            "STD_NAME": "Hanshika ",
            "STD_FATHER_NAME": "Manoj Kumar",
            "STD_MOTHER_NAME": "Mamta ",
            "STD_LAST_CLASS": "VIII",
            "STD_TCNO": "4246",
            "STD_TC_ISSUE_DATE": "27-Aug-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzQ1OQ==&cwid=MzI2MQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3092",
            "STD_NAME": "Rishabh ",
            "STD_FATHER_NAME": "Sunil ",
            "STD_MOTHER_NAME": "Sangeeta  ",
            "STD_LAST_CLASS": "VII",
            "STD_TCNO": "4249",
            "STD_TC_ISSUE_DATE": "24-Sep-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc4Nw==&cwid=MzI2Mw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1819/2632",
            "STD_NAME": "Roli ",
            "STD_FATHER_NAME": "Santosh Kumar",
            "STD_MOTHER_NAME": "Shanti Devi",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4251",
            "STD_TC_ISSUE_DATE": "26-Sep-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MzMwNg==&cwid=MzI2NQ==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/2021/3099",
            "STD_NAME": "Sita ",
            "STD_FATHER_NAME": "Ram  Avdesh",
            "STD_MOTHER_NAME": "Pushpa Singh",
            "STD_LAST_CLASS": "X",
            "STD_TCNO": "4252",
            "STD_TC_ISSUE_DATE": "26-Sep-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=Mzc5NA==&cwid=MzI2Nw==&stdstream=MQ==&school_code=SEdTRg=="
        },
        {
            "REG_CODE": "HGSF/1314/129",
            "STD_NAME": "Arun Baisla",
            "STD_FATHER_NAME": "Rahul ",
            "STD_MOTHER_NAME": "Reena ",
            "STD_LAST_CLASS": "XII",
            "STD_TCNO": "4254",
            "STD_TC_ISSUE_DATE": "03-Oct-2025",
            "STD_TCURL": "https://eschool.appsosindia.org/views/manage_student/php/pdf/std_tc_wdetails.php?id=MTYzMA==&cwid=MzI2OQ==&stdstream=&school_code=SEdTRg=="
        }
    ]
}

export default studentInfo;